!(function () {
var i = {
556: function (i) {
function t(e) {
return (t =
"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
? function (e) {
return typeof e;
}
: function (e) {
return e &&
"function" == typeof Symbol &&
e.constructor === Symbol &&
e !== Symbol.prototype
? "symbol"
: typeof e;
})(e);
}
function l(e, t) {
if (!(e instanceof t))
throw new TypeError("Cannot call a class as a function");
}
function n(e, t) {
for (var i, n = 0; n < t.length; n++) {
var o = t[n];
(o.enumerable = o.enumerable || !1),
(o.configurable = !0),
"value" in o && (o.writable = !0),
Object.defineProperty(
e,
"symbol" ==
typeof (i = (function (e) {
if ("object" != typeof e || !e) return e;
var t = e[Symbol.toPrimitive];
if (void 0 === t) return String(e);
t = t.call(e, "string");
if ("object" != typeof t) return t;
throw new TypeError(
"@@toPrimitive must return a primitive value."
);
})((i = o.key)))
? i
: i + "",
o
);
}
}
function e(e, t, i) {
return (
t && n(e.prototype, t),
i && n(e, i),
Object.defineProperty(e, "prototype", { writable: !1 }),
e
);
}
function c(e) {
var i = {},
n = !0,
t = 0,
o = arguments.length;
"[object Boolean]" === Object.prototype.toString.call(e) &&
((n = e), t++);
for (; t < o; t++)
!(function (e) {
for (var t in e)
Object.prototype.hasOwnProperty.call(e, t) &&
(n &&
"[object Object]" === Object.prototype.toString.call(e[t])
? (i[t] = c(!0, i[t], e[t]))
: (i[t] = e[t]));
})(arguments[t]);
return i;
}
function p(e, t) {
if (
0 !=
k(
(e =
s((e = !X(e) && e !== window && e !== document ? e : [e])) ||
d(e)
? e
: [e])
)
)
if (s(e) && !d(e))
for (
var i = e.length, n = 0;
n < i && !1 !== t.call(e[n], e[n], n, e);
n++
);
else if (d(e))
for (var o in e)
if (x(e, o) && !1 === t.call(e[o], e[o], o, e)) break;
}
function h(e, t, i) {
var n = 1 < arguments.length && void 0 !== t ? t : null,
o = 2 < arguments.length && void 0 !== i ? i : null,
t = (e[u] = e[u] || []),
s = { all: t, evt: null, found: null };
return (
n &&
o &&
0 < k(t) &&
p(t, function (e, t) {
if (e.eventName == n && e.fn.toString() == o.toString())
return (s.found = !0), (s.evt = t), !1;
}),
s
);
}
function q(i, e, t) {
var e = 1 < arguments.length && void 0 !== e ? e : {},
n = e.onElement,
o = e.withCallback,
s = e.avoidDuplicate,
r = void 0 === s || s,
s = e.once,
l = void 0 !== s && s,
s = e.useCapture,
a = void 0 !== s && s,
c = 2 < arguments.length ? t : void 0,
d = n || [];
function u(e) {
W(o) && o.call(c, e, this), l && u.destroy();
}
return (
b(d) && (d = document.querySelectorAll(d)),
(u.destroy = function () {
p(d, function (e) {
var t = h(e, i, u);
t.found && t.all.splice(t.evt, 1),
e.removeEventListener && e.removeEventListener(i, u, a);
});
}),
p(d, function (e) {
var t = h(e, i, u);
((e.addEventListener && r && !t.found) || !r) &&
(e.addEventListener(i, u, a),
t.all.push({ eventName: i, fn: u }));
}),
u
);
}
function P(t, e) {
p(e.split(" "), function (e) {
return t.classList.add(e);
});
}
function N(t, e) {
p(e.split(" "), function (e) {
return t.classList.remove(e);
});
}
function j(e, t) {
return e.classList.contains(t);
}
function H(e, t) {
for (; e !== document.body; ) {
if (!(e = e.parentElement)) return !1;
if (
"function" == typeof e.matches
? e.matches(t)
: e.msMatchesSelector(t)
)
return e;
}
}
function M(t, e, i) {
var n,
e = 1 < arguments.length && void 0 !== e ? e : "",
o = 2 < arguments.length && void 0 !== i && i;
if (t && "" !== e)
return "none" === e
? W(o) && o()
: ((i = (function () {
var e,
t = document.createElement("fakeelement"),
i = {
animation: "animationend",
OAnimation: "oAnimationEnd",
MozAnimation: "animationend",
WebkitAnimation: "webkitAnimationEnd",
};
for (e in i) if (void 0 !== t.style[e]) return i[e];
})()),
p((n = e.split(" ")), function (e) {
P(t, "g" + e);
}),
void q(i, {
onElement: t,
avoidDuplicate: !1,
once: !0,
withCallback: function (e, t) {
p(n, function (e) {
N(t, "g" + e);
}),
W(o) && o();
},
}));
}
function I(e, t) {
t = 1 < arguments.length && void 0 !== t ? t : "";
if ("" === t)
return (
(e.style.webkitTransform = ""),
(e.style.MozTransform = ""),
(e.style.msTransform = ""),
(e.style.OTransform = ""),
(e.style.transform = ""),
!1
);
(e.style.webkitTransform = t),
(e.style.MozTransform = t),
(e.style.msTransform = t),
(e.style.OTransform = t),
(e.style.transform = t);
}
function r(e) {
e.style.display = "block";
}
function a(e) {
e.style.display = "none";
}
function v(e) {
var t = document.createDocumentFragment(),
i = document.createElement("div");
for (i.innerHTML = e; i.firstChild; ) t.appendChild(i.firstChild);
return t;
}
function z() {
return {
width:
window.innerWidth ||
document.documentElement.clientWidth ||
document.body.clientWidth,
height:
window.innerHeight ||
document.documentElement.clientHeight ||
document.body.clientHeight,
};
}
function y(e, t, i, n) {
var o, s;
e()
? t()
: ((i = i || 100),
(s = setInterval(function () {
e() && (clearInterval(s), o && clearTimeout(o), t());
}, i)),
n &&
(o = setTimeout(function () {
clearInterval(s);
}, n)));
}
function S(e, t, i) {
if (R(e)) console.error("Inject assets error");
else if ((W(t) && ((i = t), (t = !1)), b(t) && t in window))
W(i) && i();
else {
var n, o, s;
if (-1 !== e.indexOf(".css"))
return (
((n = document.querySelectorAll('link[href="' + e + '"]')) &&
0 < n.length) ||
((r = (o =
document.getElementsByTagName(
"head"
)[0]).querySelectorAll('link[rel="stylesheet"]')),
((s = document.createElement("link")).rel = "stylesheet"),
(s.type = "text/css"),
(s.href = e),
(s.media = "all"),
r ? o.insertBefore(s, r[0]) : o.appendChild(s)),
W(i) && i()
);
if (
(n = document.querySelectorAll('script[src="' + e + '"]')) &&
0 < n.length
) {
if (W(i)) {
if (b(t))
return y(
function () {
return void 0 !== window[t];
},
function () {
i();
}
);
i();
}
} else {
var r = document.createElement("script");
(r.type = "text/javascript"),
(r.src = e),
(r.onload = function () {
if (W(i)) {
if (b(t))
return (
y(
function () {
return void 0 !== window[t];
},
function () {
i();
}
),
!1
);
i();
}
}),
document.body.appendChild(r);
}
}
}
function m() {
return (
"navigator" in window &&
window.navigator.userAgent.match(
/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i
)
);
}
function W(e) {
return "function" == typeof e;
}
function b(e) {
return "string" == typeof e;
}
function X(e) {
return e && e.nodeType && 1 == e.nodeType;
}
function T(e) {
return Array.isArray(e);
}
function s(e) {
return e && e.length && isFinite(e.length);
}
function d(e) {
return "object" === t(e) && null != e && !W(e) && !T(e);
}
function R(e) {
return null == e;
}
function x(e, t) {
return null !== e && hasOwnProperty.call(e, t);
}
function k(e) {
if (d(e)) {
if (e.keys) return e.keys().length;
var t,
i = 0;
for (t in e) x(e, t) && i++;
return i;
}
return e.length;
}
function B(e) {
return !isNaN(parseFloat(e)) && isFinite(e);
}
function G(e) {
var e = 0 < arguments.length && void 0 !== e ? e : -1,
t = document.querySelectorAll(
".gbtn[data-taborder]:not(.disabled)"
);
if (!t.length) return !1;
if (1 == t.length) return t[0];
"string" == typeof e && (e = parseInt(e));
var i = [],
t =
(p(t, function (e) {
i.push(e.getAttribute("data-taborder"));
}),
Math.max.apply(
Math,
i.map(function (e) {
return parseInt(e);
})
)),
n = e < 0 ? 1 : e + 1;
t < n && (n = "1");
e = i
.filter(function (e) {
return e >= parseInt(n);
})
.sort()[0];
return document.querySelector(
'.gbtn[data-taborder="'.concat(e, '"]')
);
}
function C(e) {
var t = H(e.target, ".gslide-media");
"enterfullscreen" === e.type && P(t, "fullscreen"),
"exitfullscreen" === e.type && N(t, "fullscreen");
}
function f(e) {
return Math.sqrt(e.x * e.x + e.y * e.y);
}
function o(e, t) {
e = new L(e);
return e.add(t), e;
}
function Y(e) {
var t = (function () {
var e,
t = document.createElement("fakeelement"),
i = {
transition: "transitionend",
OTransition: "oTransitionEnd",
MozTransition: "transitionend",
WebkitTransition: "webkitTransitionEnd",
};
for (e in i) if (void 0 !== t.style[e]) return i[e];
})(),
i =
window.innerWidth ||
document.documentElement.clientWidth ||
document.body.clientWidth,
n = j(e, "gslide-media") ? e : e.querySelector(".gslide-media"),
o = H(n, ".ginner-container"),
e = e.querySelector(".gslide-description");
P((n = 769 < i ? o : n), "greset"),
I(n, "translate3d(0, 0, 0)"),
q(t, {
onElement: n,
once: !0,
withCallback: function (e, t) {
N(n, "greset");
},
}),
(n.style.opacity = ""),
e && (e.style.opacity = "");
}
var u, A, w, E, g, L, Z, F, U, V, $, _;
i.exports =
((u = Date.now()),
(A = e(
function e(t, i) {
var n = this,
o =
2 < arguments.length && void 0 !== arguments[2]
? arguments[2]
: null;
if (
(l(this, e),
(this.img = t),
(this.slide = i),
(this.onclose = o),
this.img.setZoomEvents)
)
return !1;
(this.active = !1),
(this.zoomedIn = !1),
(this.dragging = !1),
(this.currentX = null),
(this.currentY = null),
(this.initialX = null),
(this.initialY = null),
(this.xOffset = 0),
(this.yOffset = 0),
this.img.addEventListener(
"mousedown",
function (e) {
return n.dragStart(e);
},
!1
),
this.img.addEventListener(
"mouseup",
function (e) {
return n.dragEnd(e);
},
!1
),
this.img.addEventListener(
"mousemove",
function (e) {
return n.drag(e);
},
!1
),
this.img.addEventListener(
"click",
function (e) {
return n.slide.classList.contains("dragging-nav")
? (n.zoomOut(), !1)
: n.zoomedIn
? void (n.zoomedIn && !n.dragging && n.zoomOut())
: n.zoomIn();
},
!1
),
(this.img.setZoomEvents = !0);
},
[
{
key: "zoomIn",
value: function () {
var e,
t = this.widowWidth();
this.zoomedIn ||
t <= 768 ||
((e = this.img).setAttribute(
"data-style",
e.getAttribute("style")
),
(e.style.maxWidth = e.naturalWidth + "px"),
(e.style.maxHeight = e.naturalHeight + "px"),
e.naturalWidth > t &&
((t = t / 2 - e.naturalWidth / 2),
this.setTranslate(this.img.parentNode, t, 0)),
this.slide.classList.add("zoomed"),
(this.zoomedIn = !0));
},
},
{
key: "zoomOut",
value: function () {
this.img.parentNode.setAttribute("style", ""),
this.img.setAttribute(
"style",
this.img.getAttribute("data-style")
),
this.slide.classList.remove("zoomed"),
(this.zoomedIn = !1),
(this.currentX = null),
(this.currentY = null),
(this.initialX = null),
(this.initialY = null),
(this.xOffset = 0),
(this.yOffset = 0),
this.onclose &&
"function" == typeof this.onclose &&
this.onclose();
},
},
{
key: "dragStart",
value: function (e) {
e.preventDefault(),
this.zoomedIn
? ("touchstart" === e.type
? ((this.initialX =
e.touches[0].clientX - this.xOffset),
(this.initialY =
e.touches[0].clientY - this.yOffset))
: ((this.initialX = e.clientX - this.xOffset),
(this.initialY = e.clientY - this.yOffset)),
e.target === this.img &&
((this.active = !0),
this.img.classList.add("dragging")))
: (this.active = !1);
},
},
{
key: "dragEnd",
value: function (e) {
var t = this;
e.preventDefault(),
(this.initialX = this.currentX),
(this.initialY = this.currentY),
(this.active = !1),
setTimeout(function () {
(t.dragging = !1),
(t.img.isDragging = !1),
t.img.classList.remove("dragging");
}, 100);
},
},
{
key: "drag",
value: function (e) {
this.active &&
(e.preventDefault(),
"touchmove" === e.type
? ((this.currentX =
e.touches[0].clientX - this.initialX),
(this.currentY =
e.touches[0].clientY - this.initialY))
: ((this.currentX = e.clientX - this.initialX),
(this.currentY = e.clientY - this.initialY)),
(this.xOffset = this.currentX),
(this.yOffset = this.currentY),
(this.img.isDragging = !0),
(this.dragging = !0),
this.setTranslate(
this.img,
this.currentX,
this.currentY
));
},
},
{
key: "onMove",
value: function (e) {
var t;
this.zoomedIn &&
((t = e.clientX - this.img.naturalWidth / 2),
(e = e.clientY - this.img.naturalHeight / 2),
this.setTranslate(this.img, t, e));
},
},
{
key: "setTranslate",
value: function (e, t, i) {
e.style.transform =
"translate3d(" + t + "px, " + i + "px, 0)";
},
},
{
key: "widowWidth",
value: function () {
return (
window.innerWidth ||
document.documentElement.clientWidth ||
document.body.clientWidth
);
},
},
]
)),
(w = e(
function e() {
var t = this,
i =
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: {},
n = (l(this, e), i.dragEl),
o = i.toleranceX,
o = void 0 === o ? 40 : o,
s = i.toleranceY,
s = void 0 === s ? 65 : s,
r = i.slide,
r = void 0 === r ? null : r,
i = i.instance,
i = void 0 === i ? null : i;
(this.el = n),
(this.active = !1),
(this.dragging = !1),
(this.currentX = null),
(this.currentY = null),
(this.initialX = null),
(this.initialY = null),
(this.xOffset = 0),
(this.yOffset = 0),
(this.direction = null),
(this.lastDirection = null),
(this.toleranceX = o),
(this.toleranceY = s),
(this.toleranceReached = !1),
(this.dragContainer = this.el),
(this.slide = r),
(this.instance = i),
this.el.addEventListener(
"mousedown",
function (e) {
return t.dragStart(e);
},
!1
),
this.el.addEventListener(
"mouseup",
function (e) {
return t.dragEnd(e);
},
!1
),
this.el.addEventListener(
"mousemove",
function (e) {
return t.drag(e);
},
!1
);
},
[
{
key: "dragStart",
value: function (e) {
var t;
this.slide.classList.contains("zoomed") ||
("touchstart" === e.type
? ((this.initialX = e.touches[0].clientX - this.xOffset),
(this.initialY = e.touches[0].clientY - this.yOffset))
: ((this.initialX = e.clientX - this.xOffset),
(this.initialY = e.clientY - this.yOffset)),
(t = e.target.nodeName.toLowerCase()),
e.target.classList.contains("nodrag")) ||
H(e.target, ".nodrag") ||
-1 !==
["input", "select", "textarea", "button", "a"].indexOf(t)
? (this.active = !1)
: (e.preventDefault(),
(e.target === this.el ||
("img" !== t && H(e.target, ".gslide-inline"))) &&
((this.active = !0),
this.el.classList.add("dragging"),
(this.dragContainer = H(
e.target,
".ginner-container"
))));
},
},
{
key: "dragEnd",
value: function (e) {
var t = this;
e && e.preventDefault(),
(this.initialX = 0),
(this.initialY = 0),
(this.currentX = null),
(this.currentY = null),
(this.initialX = null),
(this.initialY = null),
(this.xOffset = 0),
(this.yOffset = 0),
(this.active = !1),
this.doSlideChange &&
((this.instance.preventOutsideClick = !0),
"right" == this.doSlideChange &&
this.instance.prevSlide(),
"left" == this.doSlideChange) &&
this.instance.nextSlide(),
this.doSlideClose && this.instance.close(),
this.toleranceReached ||
this.setTranslate(this.dragContainer, 0, 0, !0),
setTimeout(function () {
(t.instance.preventOutsideClick = !1),
(t.toleranceReached = !1),
(t.lastDirection = null),
(t.dragging = !1),
(t.el.isDragging = !1),
t.el.classList.remove("dragging"),
t.slide.classList.remove("dragging-nav"),
(t.dragContainer.style.transform = ""),
(t.dragContainer.style.transition = "");
}, 100);
},
},
{
key: "drag",
value: function (e) {
if (this.active) {
e.preventDefault(),
this.slide.classList.add("dragging-nav"),
"touchmove" === e.type
? ((this.currentX =
e.touches[0].clientX - this.initialX),
(this.currentY =
e.touches[0].clientY - this.initialY))
: ((this.currentX = e.clientX - this.initialX),
(this.currentY = e.clientY - this.initialY)),
(this.xOffset = this.currentX),
(this.yOffset = this.currentY),
(this.el.isDragging = !0),
(this.dragging = !0),
(this.doSlideChange = !1),
(this.doSlideClose = !1);
var e = Math.abs(this.currentX),
t = Math.abs(this.currentY);
if (
0 < e &&
e >= Math.abs(this.currentY) &&
(!this.lastDirection || "x" == this.lastDirection)
) {
(this.yOffset = 0),
(this.lastDirection = "x"),
this.setTranslate(
this.dragContainer,
this.currentX,
0
);
var i = this.shouldChange();
if (
(!this.instance.settings.dragAutoSnap &&
i &&
(this.doSlideChange = i),
this.instance.settings.dragAutoSnap && i)
)
return (
(this.instance.preventOutsideClick = !0),
(this.toleranceReached = !0),
(this.active = !1),
(this.instance.preventOutsideClick = !0),
this.dragEnd(null),
"right" == i && this.instance.prevSlide(),
void ("left" == i && this.instance.nextSlide())
);
}
0 < this.toleranceY &&
0 < t &&
e <= t &&
(!this.lastDirection || "y" == this.lastDirection) &&
((this.xOffset = 0),
(this.lastDirection = "y"),
this.setTranslate(this.dragContainer, 0, this.currentY),
(i = this.shouldClose()),
!this.instance.settings.dragAutoSnap &&
i &&
(this.doSlideClose = !0),
this.instance.settings.dragAutoSnap) &&
i &&
this.instance.close();
}
},
},
{
key: "shouldChange",
value: function () {
var e,
t = !1;
return (t =
Math.abs(this.currentX) >= this.toleranceX &&
(("left" == (e = 0 < this.currentX ? "right" : "left") &&
this.slide !== this.slide.parentNode.lastChild) ||
("right" == e &&
this.slide !== this.slide.parentNode.firstChild))
? e
: t);
},
},
{
key: "shouldClose",
value: function () {
var e = !1;
return (e =
Math.abs(this.currentY) >= this.toleranceY ? !0 : e);
},
},
{
key: "setTranslate",
value: function (e, t, i) {
(e.style.transition =
3 < arguments.length &&
void 0 !== arguments[3] &&
arguments[3]
? "all .2s ease"
: ""),
(e.style.transform = "translate3d("
.concat(t, "px, ")
.concat(i, "px, 0)"));
},
},
]
)),
(E = e(
function e() {
var t =
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: {};
l(this, e),
(this.defaults = {
href: "",
sizes: "",
srcset: "",
title: "",
type: "",
videoProvider: "",
description: "",
alt: "",
descPosition: "bottom",
effect: "",
width: "",
height: "",
content: !1,
zoomable: !0,
draggable: !0,
}),
d(t) && (this.defaults = c(this.defaults, t));
},
[
{
key: "sourceType",
value: function (e) {
var t = e;
return null !==
(e = e.toLowerCase()).match(
/\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/
)
? "image"
: e.match(
/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/
) ||
e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) ||
e.match(
/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/
) ||
e.match(
/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/
) ||
e.match(/vimeo\.com\/([0-9]*)/) ||
null !== e.match(/\.(mp4|ogg|webm|mov)/)
? "video"
: null !== e.match(/\.(mp3|wav|wma|aac|ogg)/)
? "audio"
: -1 < e.indexOf("#") && "" !== t.split("#").pop().trim()
? "inline"
: -1 < e.indexOf("goajax=true")
? "ajax"
: "external";
},
},
{
key: "parseConfig",
value: function (n, o) {
var s = this,
r = c({ descPosition: o.descPosition }, this.defaults);
if (d(n) && !X(n))
return (
x(n, "type") ||
(x(n, "content") && n.content
? (n.type = "inline")
: x(n, "href") &&
(n.type = this.sourceType(n.href))),
(t = c(r, n)),
this.setSize(t, o),
t
);
var l,
e,
t = "",
a = n.getAttribute("data-glightbox"),
i = n.nodeName.toLowerCase();
if (
("a" === i && (t = n.href),
"img" === i && ((t = n.src), (r.alt = n.alt)),
(r.href = t),
p(r, function (e, t) {
x(o, t) && "width" !== t && (r[t] = o[t]);
var i = n.dataset[t];
R(i) || (r[t] = s.sanitizeValue(i));
}),
r.content && (r.type = "inline"),
!r.type && t && (r.type = this.sourceType(t)),
R(a)
? (r.title ||
"a" != i ||
R((t = n.title)) ||
"" === t ||
(r.title = t),
r.title ||
"img" != i ||
R((t = n.alt)) ||
"" === t ||
(r.title = t))
: ((l = []),
p(r, function (e, t) {
l.push(";\\s?" + t);
}),
(l = l.join("\\s?:|")),
"" !== a.trim() &&
p(r, function (e, t) {
var i = a,
n = new RegExp(
"s?" + t + "s?:s?(.*?)(" + l + "s?:|$)"
),
i = i.match(n);
i &&
i.length &&
i[1] &&
((n = i[1].trim().replace(/;\s*$/, "")),
(r[t] = s.sanitizeValue(n)));
})),
r.description && "." === r.description.substring(0, 1))
) {
try {
e = document.querySelector(r.description).innerHTML;
} catch (n) {
if (!(n instanceof DOMException)) throw n;
}
e && (r.description = e);
}
return (
r.description ||
((i = n.querySelector(".glightbox-desc")) &&
(r.description = i.innerHTML)),
this.setSize(r, o, n),
(this.slideConfig = r)
);
},
},
{
key: "setSize",
value: function (e, t) {
var i =
2 < arguments.length && void 0 !== arguments[2]
? arguments[2]
: null,
n =
"video" == e.type
? this.checkSize(t.videosWidth)
: this.checkSize(t.width),
t = this.checkSize(t.height);
return (
(e.width =
x(e, "width") && "" !== e.width
? this.checkSize(e.width)
: n),
(e.height =
x(e, "height") && "" !== e.height
? this.checkSize(e.height)
: t),
i &&
"image" == e.type &&
((e._hasCustomWidth = !!i.dataset.width),
(e._hasCustomHeight = !!i.dataset.height)),
e
);
},
},
{
key: "checkSize",
value: function (e) {
return B(e) ? "".concat(e, "px") : e;
},
},
{
key: "sanitizeValue",
value: function (e) {
return "true" !== e && "false" !== e ? e : "true" === e;
},
},
]
)),
(g = e(
function e(t, i, n) {
l(this, e),
(this.element = t),
(this.instance = i),
(this.index = n);
},
[
{
key: "setContent",
value: function () {
var t = this,
i =
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: null,
e =
1 < arguments.length &&
void 0 !== arguments[1] &&
arguments[1];
if (j(i, "loaded")) return !1;
var n,
o = this.instance.settings,
s = this.slideConfig,
r = m(),
l =
(W(o.beforeSlideLoad) &&
o.beforeSlideLoad({
index: this.index,
slide: i,
player: !1,
}),
s.type),
a = s.descPosition,
c = i.querySelector(".gslide-media"),
d = i.querySelector(".gslide-title"),
u = i.querySelector(".gslide-desc"),
p = i.querySelector(".gdesc-inner"),
h = e,
f = "gSlideTitle_" + this.index,
g = "gSlideDesc_" + this.index;
if (
(W(o.afterSlideLoad) &&
(h = function () {
W(e) && e(),
o.afterSlideLoad({
index: t.index,
slide: i,
player: t.instance.getSlidePlayerInstance(
t.index
),
});
}),
"" == s.title && "" == s.description
? p && p.parentNode.parentNode.removeChild(p.parentNode)
: (d && "" !== s.title
? ((d.id = f), (d.innerHTML = s.title))
: d.parentNode.removeChild(d),
u && "" !== s.description
? ((u.id = g),
r && 0 < o.moreLength
? ((s.smallDescription = this.slideShortDesc(
s.description,
o.moreLength,
o.moreText
)),
(u.innerHTML = s.smallDescription),
this.descriptionEvents(u, s))
: (u.innerHTML = s.description))
: u.parentNode.removeChild(u),
P(c.parentNode, "desc-".concat(a)),
P(p.parentNode, "description-".concat(a))),
P(c, "gslide-".concat(l)),
P(i, "loaded"),
"video" !== l)
) {
if ("external" !== l)
return "inline" === l
? (function (e, t, i, n) {
var o,
s = this,
e = e.querySelector(".gslide-media"),
r =
!(!x(t, "href") || !t.href) &&
t.href.split("#").pop().trim(),
l =
!(!x(t, "content") || !t.content) &&
t.content;
if (
(l &&
(b(l) &&
(o = v(
'<div class="ginlined-content">'.concat(
l,
"</div>"
)
)),
X(l)) &&
("none" == l.style.display &&
(l.style.display = "block"),
((a =
document.createElement("div")).className =
"ginlined-content"),
a.appendChild(l),
(o = a)),
r)
) {
l = document.getElementById(r);
if (!l) return !1;
var a = l.cloneNode(!0);
(a.style.height = t.height),
(a.style.maxWidth = t.width),
P(a, "ginlined-content"),
(o = a);
}
if (!o)
return (
console.error(
"Unable to append inline slide content",
t
),
!1
);
(e.style.height = t.height),
(e.style.width = t.width),
e.appendChild(o),
(this.events["inlineclose" + r] = q("click", {
onElement:
e.querySelectorAll(".gtrigger-close"),
withCallback: function (e) {
e.preventDefault(), s.close();
},
})),
W(n) && n();
}.apply(this.instance, [i, s, this.index, h]),
void (
s.draggable &&
new w({
dragEl: i.querySelector(".gslide-inline"),
toleranceX: o.dragToleranceX,
toleranceY: o.dragToleranceY,
slide: i,
instance: this.instance,
})
))
: void ("image" !== l
? W(h) && h()
: ((f = i),
(d = s),
(g = this.index),
(n = function () {
var e = i.querySelector("img");
s.draggable &&
new w({
dragEl: e,
toleranceX: o.dragToleranceX,
toleranceY: o.dragToleranceY,
slide: i,
instance: t.instance,
}),
s.zoomable &&
e.naturalWidth > e.offsetWidth &&
(P(e, "zoomable"),
new A(e, i, function () {
t.instance.resize();
})),
W(h) && h();
}),
(f = f.querySelector(".gslide-media")),
(r = new Image()),
(u = "gSlideTitle_" + g),
(g = "gSlideDesc_" + g),
r.addEventListener(
"load",
function () {
n();
},
!1
),
(r.src = d.href),
"" != d.sizes &&
"" != d.srcset &&
((r.sizes = d.sizes), (r.srcset = d.srcset)),
(r.alt = ""),
R(d.alt) || "" === d.alt || (r.alt = d.alt),
"" !== d.title &&
r.setAttribute("aria-labelledby", u),
"" !== d.description &&
r.setAttribute("aria-describedby", g),
d.hasOwnProperty("_hasCustomWidth") &&
d._hasCustomWidth &&
(r.style.width = d.width),
d.hasOwnProperty("_hasCustomHeight") &&
d._hasCustomHeight &&
(r.style.height = d.height),
f.insertBefore(r, f.firstChild)));
!function (e, t, i, n) {
var o,
s,
r,
e = e.querySelector(".gslide-media"),
l =
((n = { url: t.href, callback: n }),
(l = n.url),
(o = n.allow),
(s = n.callback),
(n = n.appendTo),
((r = document.createElement("iframe")).className =
"vimeo-video gvideo"),
(r.src = l),
(r.style.width = "100%"),
(r.style.height = "100%"),
o && r.setAttribute("allow", o),
(r.onload = function () {
(r.onload = null),
P(r, "node-ready"),
W(s) && s();
}),
n && n.appendChild(r),
r);
(e.parentNode.style.maxWidth = t.width),
(e.parentNode.style.height = t.height),
e.appendChild(l);
}.apply(this, [i, s, this.index, h]);
} else
!function (t, i, n, o) {
var s = this,
e = t.querySelector(".ginner-container"),
r = "gvideo" + n,
l = t.querySelector(".gslide-media"),
a = this.getAllPlayers(),
c =
(P(e, "gvideo-container"),
l.insertBefore(
v('<div class="gvideo-wrapper"></div>'),
l.firstChild
),
t.querySelector(".gvideo-wrapper")),
d = (S(this.settings.plyr.css, "Plyr"), i.href),
u = null == i ? void 0 : i.videoProvider,
p = !1;
(l.style.maxWidth = i.width),
S(this.settings.plyr.js, "Plyr", function () {
("local" !==
(u =
!(u =
!u && d.match(/vimeo\.com\/([0-9]*)/)
? "vimeo"
: u) &&
(d.match(
/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/
) ||
d.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) ||
d.match(
/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/
) ||
d.match(
/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/
))
? "youtube"
: u) &&
u) ||
((u = "local"),
(e =
(e =
(e = '<video id="' + r + '" ') +
'style="background:#000; max-width: '.concat(
i.width,
';" '
) +
'preload="metadata" x-webkit-airplay="allow" playsinline controls class="gvideo-local">') +
'<source src="'.concat(d, '">')),
(p = v((e += "</video>"))));
var e =
p ||
v(
'<div id="'
.concat(r, '" data-plyr-provider="')
.concat(u, '" data-plyr-embed-id="')
.concat(d, '"></div>')
),
e =
(P(c, "".concat(u, "-video gvideo")),
c.appendChild(e),
c.setAttribute("data-id", r),
c.setAttribute("data-index", n),
x(s.settings.plyr, "config")
? s.settings.plyr.config
: {}),
e = new Plyr("#" + r, e);
e.on("ready", function (e) {
(a[r] = e.detail.plyr), W(o) && o();
}),
y(
function () {
return (
t.querySelector("iframe") &&
"true" ==
t.querySelector("iframe").dataset.ready
);
},
function () {
s.resize(t);
}
),
e.on("enterfullscreen", C),
e.on("exitfullscreen", C);
});
}.apply(this.instance, [i, s, this.index, h]);
},
},
{
key: "slideShortDesc",
value: function (e) {
var t =
1 < arguments.length && void 0 !== arguments[1]
? arguments[1]
: 50,
i =
2 < arguments.length &&
void 0 !== arguments[2] &&
arguments[2],
n = document.createElement("div"),
o = ((n.innerHTML = e), i);
return !((e = n.innerText.trim()).length <= t) &&
((e = e.substr(0, t - 1)), o)
? ((n = null),
e + '... <a href="#" class="desc-more">' + i + "</a>")
: e;
},
},
{
key: "descriptionEvents",
value: function (e, s) {
var r = this,
e = e.querySelector(".desc-more");
if (!e) return !1;
q("click", {
onElement: e,
withCallback: function (e, t) {
e.preventDefault();
var i = document.body,
n = H(t, ".gslide-desc");
if (!n) return !1;
(n.innerHTML = s.description), P(i, "gdesc-open");
var o = q("click", {
onElement: [i, H(n, ".gslide-description")],
withCallback: function (e, t) {
"a" !== e.target.nodeName.toLowerCase() &&
(N(i, "gdesc-open"),
P(i, "gdesc-closed"),
(n.innerHTML = s.smallDescription),
r.descriptionEvents(n, s),
setTimeout(function () {
N(i, "gdesc-closed");
}, 400),
o.destroy());
},
});
},
});
},
},
{
key: "create",
value: function () {
return v(this.instance.settings.slideHTML);
},
},
{
key: "getConfig",
value: function () {
X(this.element) ||
this.element.hasOwnProperty("draggable") ||
(this.element.draggable =
this.instance.settings.draggable);
var e = new E(this.instance.settings.slideExtraAttributes);
return (
(this.slideConfig = e.parseConfig(
this.element,
this.instance.settings
)),
this.slideConfig
);
},
},
]
)),
(L = e(
function e(t) {
l(this, e), (this.handlers = []), (this.el = t);
},
[
{
key: "add",
value: function (e) {
this.handlers.push(e);
},
},
{
key: "del",
value: function (e) {
e || (this.handlers = []);
for (var t = this.handlers.length; 0 <= t; t--)
this.handlers[t] === e && this.handlers.splice(t, 1);
},
},
{
key: "dispatch",
value: function () {
for (var e = 0, t = this.handlers.length; e < t; e++) {
var i = this.handlers[e];
"function" == typeof i && i.apply(this.el, arguments);
}
},
},
]
)),
(Z = e(
function e(t, i) {
l(this, e),
(this.element =
"string" == typeof t ? document.querySelector(t) : t),
(this.start = this.start.bind(this)),
(this.move = this.move.bind(this)),
(this.end = this.end.bind(this)),
(this.cancel = this.cancel.bind(this)),
this.element.addEventListener("touchstart", this.start, !1),
this.element.addEventListener("touchmove", this.move, !1),
this.element.addEventListener("touchend", this.end, !1),
this.element.addEventListener("touchcancel", this.cancel, !1),
(this.preV = { x: null, y: null }),
(this.pinchStartLen = null),
(this.zoom = 1),
(this.isDoubleTap = !1);
function n() {}
(this.rotate = o(this.element, i.rotate || n)),
(this.touchStart = o(this.element, i.touchStart || n)),
(this.multipointStart = o(
this.element,
i.multipointStart || n
)),
(this.multipointEnd = o(this.element, i.multipointEnd || n)),
(this.pinch = o(this.element, i.pinch || n)),
(this.swipe = o(this.element, i.swipe || n)),
(this.tap = o(this.element, i.tap || n)),
(this.doubleTap = o(this.element, i.doubleTap || n)),
(this.longTap = o(this.element, i.longTap || n)),
(this.singleTap = o(this.element, i.singleTap || n)),
(this.pressMove = o(this.element, i.pressMove || n)),
(this.twoFingerPressMove = o(
this.element,
i.twoFingerPressMove || n
)),
(this.touchMove = o(this.element, i.touchMove || n)),
(this.touchEnd = o(this.element, i.touchEnd || n)),
(this.touchCancel = o(this.element, i.touchCancel || n)),
(this.translateContainer = this.element),
(this._cancelAllHandler = this.cancelAll.bind(this)),
window.addEventListener("scroll", this._cancelAllHandler),
(this.delta = null),
(this.last = null),
(this.now = null),
(this.tapTimeout = null),
(this.singleTapTimeout = null),
(this.longTapTimeout = null),
(this.swipeTimeout = null),
(this.x1 = this.x2 = this.y1 = this.y2 = null),
(this.preTapPosition = { x: null, y: null });
},
[
{
key: "start",
value: function (e) {
var t, i;
e.touches &&
(e.target &&
e.target.nodeName &&
0 <=
["a", "button", "input"].indexOf(
e.target.nodeName.toLowerCase()
)
? console.log(
"ignore drag for this touched element",
e.target.nodeName.toLowerCase()
)
: ((this.now = Date.now()),
(this.x1 = e.touches[0].pageX),
(this.y1 = e.touches[0].pageY),
(this.delta = this.now - (this.last || this.now)),
this.touchStart.dispatch(e, this.element),
null !== this.preTapPosition.x &&
((this.isDoubleTap =
0 < this.delta &&
this.delta <= 250 &&
Math.abs(this.preTapPosition.x - this.x1) < 30 &&
Math.abs(this.preTapPosition.y - this.y1) < 30),
this.isDoubleTap) &&
clearTimeout(this.singleTapTimeout),
(this.preTapPosition.x = this.x1),
(this.preTapPosition.y = this.y1),
(this.last = this.now),
(t = this.preV),
1 < e.touches.length &&
(this._cancelLongTap(),
this._cancelSingleTap(),
(i = {
x: e.touches[1].pageX - this.x1,
y: e.touches[1].pageY - this.y1,
}),
(t.x = i.x),
(t.y = i.y),
(this.pinchStartLen = f(t)),
this.multipointStart.dispatch(e, this.element)),
(this._preventTap = !1),
(this.longTapTimeout = setTimeout(
function () {
this.longTap.dispatch(e, this.element),
(this._preventTap = !0);
}.bind(this),
750
))));
},
},
{
key: "move",
value: function (e) {
var t, i, n, o, s, r, l, a, c, d, u, p;
e.touches &&
((t = this.preV),
(i = e.touches.length),
(n = e.touches[0].pageX),
(o = e.touches[0].pageY),
(this.isDoubleTap = !1),
1 < i
? ((s = e.touches[1].pageX),
(r = e.touches[1].pageY),
(l = {
x: e.touches[1].pageX - n,
y: e.touches[1].pageY - o,
}),
null !== t.x &&
(0 < this.pinchStartLen &&
((e.zoom = f(l) / this.pinchStartLen),
this.pinch.dispatch(e, this.element)),
(e.angle =
((p = c = t),
(p =
0 == (u = f((d = a = l)) * f(p))
? 0
: (1 < (d = (d.x * p.x + d.y * p.y) / u) &&
(d = 1),
Math.acos(d))),
0 < a.x * c.y - c.x * a.y && (p *= -1),
(180 * p) / Math.PI)),
this.rotate.dispatch(e, this.element)),
(t.x = l.x),
(t.y = l.y),
null !== this.x2 && null !== this.sx2
? ((e.deltaX = (n - this.x2 + s - this.sx2) / 2),
(e.deltaY = (o - this.y2 + r - this.sy2) / 2))
: ((e.deltaX = 0), (e.deltaY = 0)),
this.twoFingerPressMove.dispatch(e, this.element),
(this.sx2 = s),
(this.sy2 = r))
: (null !== this.x2
? ((e.deltaX = n - this.x2),
(e.deltaY = o - this.y2),
(u = Math.abs(this.x1 - this.x2)),
(d = Math.abs(this.y1 - this.y2)),
(10 < u || 10 < d) && (this._preventTap = !0))
: ((e.deltaX = 0), (e.deltaY = 0)),
this.pressMove.dispatch(e, this.element)),
this.touchMove.dispatch(e, this.element),
this._cancelLongTap(),
(this.x2 = n),
(this.y2 = o),
1 < i) &&
e.preventDefault();
},
},
{
key: "end",
value: function (e) {
var t;
e.changedTouches &&
(this._cancelLongTap(),
(t = this),
e.touches.length < 2 &&
(this.multipointEnd.dispatch(e, this.element),
(this.sx2 = this.sy2 = null)),
(this.x2 && 30 < Math.abs(this.x1 - this.x2)) ||
(this.y2 && 30 < Math.abs(this.y1 - this.y2))
? ((e.direction = this._swipeDirection(
this.x1,
this.x2,
this.y1,
this.y2
)),
(this.swipeTimeout = setTimeout(function () {
t.swipe.dispatch(e, t.element);
}, 0)))
: ((this.tapTimeout = setTimeout(function () {
t._preventTap || t.tap.dispatch(e, t.element),
t.isDoubleTap &&
(t.doubleTap.dispatch(e, t.element),
(t.isDoubleTap = !1));
}, 0)),
t.isDoubleTap ||
(t.singleTapTimeout = setTimeout(function () {
t.singleTap.dispatch(e, t.element);
}, 250))),
this.touchEnd.dispatch(e, this.element),
(this.preV.x = 0),
(this.preV.y = 0),
(this.zoom = 1),
(this.pinchStartLen = null),
(this.x1 = this.x2 = this.y1 = this.y2 = null));
},
},
{
key: "cancelAll",
value: function () {
(this._preventTap = !0),
clearTimeout(this.singleTapTimeout),
clearTimeout(this.tapTimeout),
clearTimeout(this.longTapTimeout),
clearTimeout(this.swipeTimeout);
},
},
{
key: "cancel",
value: function (e) {
this.cancelAll(),
this.touchCancel.dispatch(e, this.element);
},
},
{
key: "_cancelLongTap",
value: function () {
clearTimeout(this.longTapTimeout);
},
},
{
key: "_cancelSingleTap",
value: function () {
clearTimeout(this.singleTapTimeout);
},
},
{
key: "_swipeDirection",
value: function (e, t, i, n) {
return Math.abs(e - t) >= Math.abs(i - n)
? 0 < e - t
? "Left"
: "Right"
: 0 < i - n
? "Up"
: "Down";
},
},
{
key: "on",
value: function (e, t) {
this[e] && this[e].add(t);
},
},
{
key: "off",
value: function (e, t) {
this[e] && this[e].del(t);
},
},
{
key: "destroy",
value: function () {
return (
this.singleTapTimeout &&
clearTimeout(this.singleTapTimeout),
this.tapTimeout && clearTimeout(this.tapTimeout),
this.longTapTimeout && clearTimeout(this.longTapTimeout),
this.swipeTimeout && clearTimeout(this.swipeTimeout),
this.element.removeEventListener(
"touchstart",
this.start
),
this.element.removeEventListener("touchmove", this.move),
this.element.removeEventListener("touchend", this.end),
this.element.removeEventListener(
"touchcancel",
this.cancel
),
this.rotate.del(),
this.touchStart.del(),
this.multipointStart.del(),
this.multipointEnd.del(),
this.pinch.del(),
this.swipe.del(),
this.tap.del(),
this.doubleTap.del(),
this.longTap.del(),
this.singleTap.del(),
this.pressMove.del(),
this.twoFingerPressMove.del(),
this.touchMove.del(),
this.touchEnd.del(),
this.touchCancel.del(),
(this.preV =
this.pinchStartLen =
this.zoom =
this.isDoubleTap =
this.delta =
this.last =
this.now =
this.tapTimeout =
this.singleTapTimeout =
this.longTapTimeout =
this.swipeTimeout =
this.x1 =
this.x2 =
this.y1 =
this.y2 =
this.preTapPosition =
this.rotate =
this.touchStart =
this.multipointStart =
this.multipointEnd =
this.pinch =
this.swipe =
this.tap =
this.doubleTap =
this.longTap =
this.singleTap =
this.pressMove =
this.touchMove =
this.touchEnd =
this.touchCancel =
this.twoFingerPressMove =
null),
window.removeEventListener(
"scroll",
this._cancelAllHandler
),
null
);
},
},
]
)),
(F = m()),
(U =
null !== m() ||
void 0 !== document.createTouch ||
"ontouchstart" in window ||
"onmsgesturechange" in window ||
navigator.msMaxTouchPoints),
(V = document.getElementsByTagName("html")[0]),
(_ = e(
function e() {
var t =
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: {};
l(this, e),
(this.customOptions = t),
(this.settings = c($, t)),
(this.effectsClasses = this.getAnimationClasses()),
(this.videoPlayers = {}),
(this.apiEvents = []),
(this.fullElementsList = !1);
},
[
{
key: "init",
value: function () {
var i = this,
e = this.getSelector();
e &&
(this.baseEvents = q("click", {
onElement: e,
withCallback: function (e, t) {
e.preventDefault(), i.open(t);
},
})),
(this.elements = this.getElements());
},
},
{
key: "open",
value: function () {
var e =
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: null,
t =
1 < arguments.length && void 0 !== arguments[1]
? arguments[1]
: null;
if (0 === this.elements.length) return !1;
(this.activeSlide = null),
(this.prevActiveSlideIndex = null),
(this.prevActiveSlide = null);
var i,
s,
n,
o,
r,
l,
a,
c,
d,
u,
p,
h,
f,
g,
v,
y,
m,
b,
x,
w,
S,
T,
k,
C,
A,
E,
L,
$,
_,
O,
t = B(t) ? t : this.settings.startAt,
D =
(B(
(t =
X(e) &&
((D = e.getAttribute("data-gallery")) &&
((this.fullElementsList = this.elements),
(this.elements = this.getGalleryElements(
this.elements,
D
))),
R(t)) &&
(t = this.getElementIndex(e)) < 0
? 0
: t)
) || (t = 0),
this.build(),
M(
this.overlay,
"none" === this.settings.openEffect
? "none"
: this.settings.cssEfects.fade.in
),
document.body),
e =
window.innerWidth -
document.documentElement.clientWidth;
0 < e &&
(((i = document.createElement("style")).type =
"text/css"),
(i.className = "gcss-styles"),
(i.innerText = ".gscrollbar-fixer {margin-right: ".concat(
e,
"px}"
)),
document.head.appendChild(i),
P(D, "gscrollbar-fixer")),
P(D, "glightbox-open"),
P(V, "glightbox-open"),
F &&
(P(document.body, "glightbox-mobile"),
(this.settings.slideEffect = "slide")),
this.showSlide(t, !0),
(1 === this.elements.length
? (P(this.prevButton, "glightbox-button-hidden"), P)
: (N(this.prevButton, "glightbox-button-hidden"), N))(
this.nextButton,
"glightbox-button-hidden"
),
(this.lightboxOpen = !0),
this.trigger("open"),
W(this.settings.onOpen) && this.settings.onOpen(),
U &&
this.settings.touchNavigation &&
((n = this).events.hasOwnProperty("touch") ||
((e = z()),
(a = e.width),
(c = e.height),
(f = d = !1),
(S = w = x = b = h = p = u = null),
(A = C = m = y = !(v = g = 1)),
(E = {}),
(L = {}),
(_ = $ = k = T = 0),
(e = document.getElementById("glightbox-slider")),
(O = document.querySelector(".goverlay")),
(e = new Z(e, {
touchStart: function (e) {
(d = !0),
(j(
e.targetTouches[0].target,
"ginner-container"
) ||
H(
e.targetTouches[0].target,
".gslide-desc"
) ||
"a" ==
e.targetTouches[0].target.nodeName.toLowerCase()) &&
(d = !1),
(d =
!(
H(
e.targetTouches[0].target,
".gslide-inline"
) &&
!j(
e.targetTouches[0].target.parentNode,
"gslide-inline"
)
) && d) &&
((L = e.targetTouches[0]),
(E.pageX = e.targetTouches[0].pageX),
(E.pageY = e.targetTouches[0].pageY),
($ = e.targetTouches[0].clientX),
(_ = e.targetTouches[0].clientY),
(u = n.activeSlide),
(p = u.querySelector(".gslide-media")),
(l = u.querySelector(".gslide-inline")),
(h = null),
j(p, "gslide-image") &&
(h = p.querySelector("img")),
769 <
(window.innerWidth ||
document.documentElement.clientWidth ||
document.body.clientWidth) &&
(p = u.querySelector(".ginner-container")),
N(O, "greset"),
(20 < e.pageX &&
e.pageX < window.innerWidth - 20) ||
e.preventDefault());
},
touchMove: function (e) {
if (d && ((L = e.targetTouches[0]), !y) && !m) {
if (l && l.offsetHeight > c) {
var t = E.pageX - L.pageX;
if (Math.abs(t) <= 13) return !1;
}
f = !0;
var i,
t = e.targetTouches[0].clientX,
e = e.targetTouches[0].clientY,
t = $ - t,
e = _ - e;
if (
(Math.abs(t) > Math.abs(e)
? (A = !(C = !1))
: (C = !(A = !1)),
(o = L.pageX - E.pageX),
(T = (100 * o) / a),
(r = L.pageY - E.pageY),
(k = (100 * r) / c),
C &&
h &&
((i = 1 - Math.abs(r) / c),
(O.style.opacity = i),
n.settings.touchFollowAxis) &&
(T = 0),
A &&
((i = 1 - Math.abs(o) / a),
(p.style.opacity = i),
n.settings.touchFollowAxis) &&
(k = 0),
!h)
)
return I(
p,
"translate3d(".concat(T, "%, 0, 0)")
);
I(
p,
"translate3d("
.concat(T, "%, ")
.concat(k, "%, 0)")
);
}
},
touchEnd: function () {
if (d) {
var e, t;
if (((f = !1), !m && !y))
return (
(e = Math.abs(parseInt(k))),
(t = Math.abs(parseInt(T))),
29 < e && h
? void n.close()
: e < 29 && t < 25
? (P(O, "greset"),
(O.style.opacity = 1),
Y(p))
: void 0
);
(w = b), (S = x);
}
},
multipointEnd: function () {
setTimeout(function () {
y = !1;
}, 50);
},
multipointStart: function () {
(y = !0), (g = v || 1);
},
pinch: function (e) {
if (!h || f) return !1;
(y = !0), (h.scaleX = h.scaleY = g * e.zoom);
e = g * e.zoom;
(m = !0),
e <= 1
? ((m = !1),
(e = 1),
(x = b = w = S = null),
h.setAttribute("style", ""))
: ((h.style.transform = "scale3d("
.concat((e = 4.5 < e ? 4.5 : e), ", ")
.concat(e, ", 1)")),
(v = e));
},
pressMove: function (e) {
var t, i;
m &&
!y &&
((i = L.pageX - E.pageX),
(t = L.pageY - E.pageY),
w && (i += w),
S && (t += S),
(b = i),
(x = t),
(i = "translate3d("
.concat(i, "px, ")
.concat(t, "px, 0)")),
v &&
(i += " scale3d("
.concat(v, ", ")
.concat(v, ", 1)")),
I(h, i));
},
swipe: function (e) {
if (!m)
if (y) y = !1;
else {
if ("Left" == e.direction) {
if (n.index == n.elements.length - 1)
return Y(p);
n.nextSlide();
}
if ("Right" == e.direction) {
if (0 == n.index) return Y(p);
n.prevSlide();
}
}
},
})),
(n.events.touch = e))),
!this.settings.keyboardNavigation ||
(s = this).events.hasOwnProperty("keyboard") ||
(s.events.keyboard = q("keydown", {
onElement: window,
withCallback: function (e, t) {
var i = (e = e || window.event).keyCode;
if (9 == i) {
var n = document.querySelector(".gbtn.focused");
if (!n) {
var o =
!(
!document.activeElement ||
!document.activeElement.nodeName
) &&
document.activeElement.nodeName.toLocaleLowerCase();
if (
"input" == o ||
"textarea" == o ||
"button" == o
)
return;
}
e.preventDefault();
o = document.querySelectorAll(
".gbtn[data-taborder]"
);
if (!o || o.length <= 0) return;
if (!n)
return void (
(e = G()) && (e.focus(), P(e, "focused"))
);
o = G(n.getAttribute("data-taborder"));
N(n, "focused"),
o && (o.focus(), P(o, "focused"));
}
39 == i && s.nextSlide(),
37 == i && s.prevSlide(),
27 == i && s.close();
},
}));
},
},
{
key: "openAt",
value: function () {
this.open(
null,
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: 0
);
},
},
{
key: "showSlide",
value: function () {
var e,
t = this,
i =
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: 0,
n =
1 < arguments.length &&
void 0 !== arguments[1] &&
arguments[1],
o =
(r(this.loader),
(this.index = parseInt(i)),
this.slidesContainer.querySelector(".current")),
s =
(o && N(o, "current"),
this.slideAnimateOut(),
this.slidesContainer.querySelectorAll(".gslide")[i]);
j(s, "loaded")
? (this.slideAnimateIn(s, n), a(this.loader))
: (r(this.loader),
(o = this.elements[i]),
(e = {
index: this.index,
slide: s,
slideNode: s,
slideConfig: o.slideConfig,
slideIndex: this.index,
trigger: o.node,
player: null,
}),
this.trigger("slide_before_load", e),
o.instance.setContent(s, function () {
a(t.loader),
t.resize(),
t.slideAnimateIn(s, n),
t.trigger("slide_after_load", e);
})),
(this.slideDescription = s.querySelector(
".gslide-description"
)),
(this.slideDescriptionContained =
this.slideDescription &&
j(this.slideDescription.parentNode, "gslide-media")),
this.settings.preload &&
(this.preloadSlide(i + 1), this.preloadSlide(i - 1)),
this.updateNavigationClasses(),
(this.activeSlide = s);
},
},
{
key: "preloadSlide",
value: function (e) {
var t,
i,
n,
o,
s = this;
return (
!(
e < 0 ||
e > this.elements.length - 1 ||
R(this.elements[e]) ||
j(
(t =
this.slidesContainer.querySelectorAll(".gslide")[
e
]),
"loaded"
)
) &&
((n = (i = this.elements[e]).type),
(o = {
index: e,
slide: t,
slideNode: t,
slideConfig: i.slideConfig,
slideIndex: e,
trigger: i.node,
player: null,
}),
this.trigger("slide_before_load", o),
void ("video" === n || "external" === n
? setTimeout(function () {
i.instance.setContent(t, function () {
s.trigger("slide_after_load", o);
});
}, 200)
: i.instance.setContent(t, function () {
s.trigger("slide_after_load", o);
})))
);
},
},
{
key: "prevSlide",
value: function () {
this.goToSlide(this.index - 1);
},
},
{
key: "nextSlide",
value: function () {
this.goToSlide(this.index + 1);
},
},
{
key: "goToSlide",
value: function () {
var e =
0 < arguments.length &&
void 0 !== arguments[0] &&
arguments[0];
if (
((this.prevActiveSlide = this.activeSlide),
(this.prevActiveSlideIndex = this.index),
!this.loop() && (e < 0 || e > this.elements.length - 1))
)
return !1;
e < 0
? (e = this.elements.length - 1)
: e >= this.elements.length && (e = 0),
this.showSlide(e);
},
},
{
key: "insertSlide",
value: function () {
var e =
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: {},
t =
1 < arguments.length && void 0 !== arguments[1]
? arguments[1]
: -1,
e =
(t < 0 && (t = this.elements.length),
new g(e, this, t)),
i = e.getConfig(),
n = c({}, i),
o = e.create(),
s = this.elements.length - 1,
e =
((n.index = t),
(n.node = !1),
(n.instance = e),
(n.slideConfig = i),
this.elements.splice(t, 0, n),
null),
r = null;
this.slidesContainer &&
(s < t
? this.slidesContainer.appendChild(o)
: ((s =
this.slidesContainer.querySelectorAll(".gslide")[
t
]),
this.slidesContainer.insertBefore(o, s)),
((this.settings.preload && 0 == this.index && 0 == t) ||
this.index - 1 == t ||
this.index + 1 == t) &&
this.preloadSlide(t),
0 === this.index && 0 === t && (this.index = 1),
this.updateNavigationClasses(),
(e = this.slidesContainer.querySelectorAll(".gslide")[t]),
(r = this.getSlidePlayerInstance(t)),
(n.slideNode = e)),
this.trigger("slide_inserted", {
index: t,
slide: e,
slideNode: e,
slideConfig: i,
slideIndex: t,
trigger: null,
player: r,
}),
W(this.settings.slideInserted) &&
this.settings.slideInserted({
index: t,
slide: e,
player: r,
});
},
},
{
key: "removeSlide",
value: function () {
var e =
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: -1;
if (e < 0 || e > this.elements.length - 1) return !1;
var t =
this.slidesContainer &&
this.slidesContainer.querySelectorAll(".gslide")[e];
t &&
(this.getActiveSlideIndex() == e &&
(e == this.elements.length - 1
? this.prevSlide()
: this.nextSlide()),
t.parentNode.removeChild(t)),
this.elements.splice(e, 1),
this.trigger("slide_removed", e),
W(this.settings.slideRemoved) &&
this.settings.slideRemoved(e);
},
},
{
key: "slideAnimateIn",
value: function (e, t) {
var i = this,
n = e.querySelector(".gslide-media"),
o = e.querySelector(".gslide-description"),
s = {
index: this.prevActiveSlideIndex,
slide: this.prevActiveSlide,
slideNode: this.prevActiveSlide,
slideIndex: this.prevActiveSlide,
slideConfig: R(this.prevActiveSlideIndex)
? null
: this.elements[this.prevActiveSlideIndex]
.slideConfig,
trigger: R(this.prevActiveSlideIndex)
? null
: this.elements[this.prevActiveSlideIndex].node,
player: this.getSlidePlayerInstance(
this.prevActiveSlideIndex
),
},
r = {
index: this.index,
slide: this.activeSlide,
slideNode: this.activeSlide,
slideConfig: this.elements[this.index].slideConfig,
slideIndex: this.index,
trigger: this.elements[this.index].node,
player: this.getSlidePlayerInstance(this.index),
};
0 < n.offsetWidth && o && (a(o), (o.style.display = "")),
N(e, this.effectsClasses),
t
? M(
e,
this.settings.cssEfects[this.settings.openEffect]
.in,
function () {
i.settings.autoplayVideos && i.slidePlayerPlay(e),
i.trigger("slide_changed", {
prev: s,
current: r,
}),
W(i.settings.afterSlideChange) &&
i.settings.afterSlideChange.apply(i, [s, r]);
}
)
: ((o =
"none" !== (n = this.settings.slideEffect)
? this.settings.cssEfects[n].in
: n),
this.prevActiveSlideIndex > this.index &&
"slide" == this.settings.slideEffect &&
(o = this.settings.cssEfects.slideBack.in),
M(e, o, function () {
i.settings.autoplayVideos && i.slidePlayerPlay(e),
i.trigger("slide_changed", {
prev: s,
current: r,
}),
W(i.settings.afterSlideChange) &&
i.settings.afterSlideChange.apply(i, [s, r]);
})),
setTimeout(function () {
i.resize(e);
}, 100),
P(e, "current");
},
},
{
key: "slideAnimateOut",
value: function () {
if (!this.prevActiveSlide) return !1;
var n = this.prevActiveSlide,
e =
(N(n, this.effectsClasses),
P(n, "prev"),
this.settings.slideEffect),
e = "none" !== e ? this.settings.cssEfects[e].out : e;
this.slidePlayerPause(n),
this.trigger("slide_before_change", {
prev: {
index: this.prevActiveSlideIndex,
slide: this.prevActiveSlide,
slideNode: this.prevActiveSlide,
slideIndex: this.prevActiveSlideIndex,
slideConfig: R(this.prevActiveSlideIndex)
? null
: this.elements[this.prevActiveSlideIndex]
.slideConfig,
trigger: R(this.prevActiveSlideIndex)
? null
: this.elements[this.prevActiveSlideIndex].node,
player: this.getSlidePlayerInstance(
this.prevActiveSlideIndex
),
},
current: {
index: this.index,
slide: this.activeSlide,
slideNode: this.activeSlide,
slideIndex: this.index,
slideConfig: this.elements[this.index].slideConfig,
trigger: this.elements[this.index].node,
player: this.getSlidePlayerInstance(this.index),
},
}),
W(this.settings.beforeSlideChange) &&
this.settings.beforeSlideChange.apply(this, [
{
index: this.prevActiveSlideIndex,
slide: this.prevActiveSlide,
player: this.getSlidePlayerInstance(
this.prevActiveSlideIndex
),
},
{
index: this.index,
slide: this.activeSlide,
player: this.getSlidePlayerInstance(this.index),
},
]),
this.prevActiveSlideIndex > this.index &&
"slide" == this.settings.slideEffect &&
(e = this.settings.cssEfects.slideBack.out),
M(n, e, function () {
var e = n.querySelector(".ginner-container"),
t = n.querySelector(".gslide-media"),
i = n.querySelector(".gslide-description");
(e.style.transform = ""),
(t.style.transform = ""),
N(t, "greset"),
(t.style.opacity = ""),
i && (i.style.opacity = ""),
N(n, "prev");
});
},
},
{
key: "getAllPlayers",
value: function () {
return this.videoPlayers;
},
},
{
key: "getSlidePlayerInstance",
value: function (e) {
var e = "gvideo" + e,
t = this.getAllPlayers();
return !(!x(t, e) || !t[e]) && t[e];
},
},
{
key: "stopSlideVideo",
value: function (e) {
X(e) &&
(t = e.querySelector(".gvideo-wrapper")) &&
(e = t.getAttribute("data-index")),
console.log(
"stopSlideVideo is deprecated, use slidePlayerPause"
);
var t = this.getSlidePlayerInstance(e);
t && t.playing && t.pause();
},
},
{
key: "slidePlayerPause",
value: function (e) {
X(e) &&
(t = e.querySelector(".gvideo-wrapper")) &&
(e = t.getAttribute("data-index"));
var t = this.getSlidePlayerInstance(e);
t && t.playing && t.pause();
},
},
{
key: "playSlideVideo",
value: function (e) {
X(e) &&
(t = e.querySelector(".gvideo-wrapper")) &&
(e = t.getAttribute("data-index")),
console.log(
"playSlideVideo is deprecated, use slidePlayerPlay"
);
var t = this.getSlidePlayerInstance(e);
t && !t.playing && t.play();
},
},
{
key: "slidePlayerPlay",
value: function (e) {
var t;
(!F ||
(null != (t = this.settings.plyr.config) && t.muted)) &&
(X(e) &&
(t = e.querySelector(".gvideo-wrapper")) &&
(e = t.getAttribute("data-index")),
(t = this.getSlidePlayerInstance(e))) &&
!t.playing &&
(t.play(), this.settings.autofocusVideos) &&
t.elements.container.focus();
},
},
{
key: "setElements",
value: function (e) {
var o = this,
s = ((this.settings.elements = !1), []);
e &&
e.length &&
p(e, function (e, t) {
var e = new g(e, o, t),
i = e.getConfig(),
n = c({}, i);
(n.slideConfig = i),
(n.instance = e),
(n.index = t),
s.push(n);
}),
(this.elements = s),
this.lightboxOpen &&
((this.slidesContainer.innerHTML = ""),
this.elements.length) &&
(p(this.elements, function () {
var e = v(o.settings.slideHTML);
o.slidesContainer.appendChild(e);
}),
this.showSlide(0, !0));
},
},
{
key: "getElementIndex",
value: function (i) {
var n = !1;
return (
p(this.elements, function (e, t) {
if (x(e, "node") && e.node == i) return (n = t), !0;
}),
n
);
},
},
{
key: "getElements",
value: function () {
var s = this,
r = [],
e =
((this.elements = this.elements || []),
!R(this.settings.elements) &&
T(this.settings.elements) &&
this.settings.elements.length &&
p(this.settings.elements, function (e, t) {
var e = new g(e, s, t),
i = e.getConfig(),
n = c({}, i);
(n.node = !1),
(n.index = t),
(n.instance = e),
(n.slideConfig = i),
r.push(n);
}),
!1);
return (
(e = this.getSelector()
? document.querySelectorAll(this.getSelector())
: e) &&
p(e, function (e, t) {
var i = new g(e, s, t),
n = i.getConfig(),
o = c({}, n);
(o.node = e),
(o.index = t),
(o.instance = i),
(o.slideConfig = n),
(o.gallery = e.getAttribute("data-gallery")),
r.push(o);
}),
r
);
},
},
{
key: "getGalleryElements",
value: function (e, t) {
return e.filter(function (e) {
return e.gallery == t;
});
},
},
{
key: "getSelector",
value: function () {
return (
!this.settings.elements &&
(this.settings.selector &&
"data-" == this.settings.selector.substring(0, 5)
? "*[".concat(this.settings.selector, "]")
: this.settings.selector)
);
},
},
{
key: "getActiveSlide",
value: function () {
return this.slidesContainer.querySelectorAll(".gslide")[
this.index
];
},
},
{
key: "getActiveSlideIndex",
value: function () {
return this.index;
},
},
{
key: "getAnimationClasses",
value: function () {
var e,
t,
i = [];
for (e in this.settings.cssEfects)
this.settings.cssEfects.hasOwnProperty(e) &&
((t = this.settings.cssEfects[e]),
i.push("g".concat(t.in)),
i.push("g".concat(t.out)));
return i.join(" ");
},
},
{
key: "build",
value: function () {
var i = this;
if (this.built) return !1;
var e = document.body.childNodes,
t = [],
e =
(p(e, function (e) {
e.parentNode == document.body &&
"#" !== e.nodeName.charAt(0) &&
e.hasAttribute &&
!e.hasAttribute("aria-hidden") &&
(t.push(e), e.setAttribute("aria-hidden", "true"));
}),
x(this.settings.svg, "next")
? this.settings.svg.next
: ""),
n = x(this.settings.svg, "prev")
? this.settings.svg.prev
: "",
o = x(this.settings.svg, "close")
? this.settings.svg.close
: "",
s = v(
(s = (s = (s = (s = this.settings.lightboxHTML).replace(
/{nextSVG}/g,
e
)).replace(/{prevSVG}/g, n)).replace(/{closeSVG}/g, o))
),
e =
(document.body.appendChild(s),
document.getElementById("glightbox-body")),
n = (this.modal = e).querySelector(".gclose");
(this.prevButton = e.querySelector(".gprev")),
(this.nextButton = e.querySelector(".gnext")),
(this.overlay = e.querySelector(".goverlay")),
(this.loader = e.querySelector(".gloader")),
(this.slidesContainer =
document.getElementById("glightbox-slider")),
(this.bodyHiddenChildElms = t),
(this.events = {}),
P(this.modal, "glightbox-" + this.settings.skin),
this.settings.closeButton &&
n &&
(this.events.close = q("click", {
onElement: n,
withCallback: function (e, t) {
e.preventDefault(), i.close();
},
})),
n &&
!this.settings.closeButton &&
n.parentNode.removeChild(n),
this.nextButton &&
(this.events.next = q("click", {
onElement: this.nextButton,
withCallback: function (e, t) {
e.preventDefault(), i.nextSlide();
},
})),
this.prevButton &&
(this.events.prev = q("click", {
onElement: this.prevButton,
withCallback: function (e, t) {
e.preventDefault(), i.prevSlide();
},
})),
this.settings.closeOnOutsideClick &&
(this.events.outClose = q("click", {
onElement: e,
withCallback: function (e, t) {
i.preventOutsideClick ||
j(document.body, "glightbox-mobile") ||
H(e.target, ".ginner-container") ||
H(e.target, ".gbtn") ||
j(e.target, "gnext") ||
j(e.target, "gprev") ||
i.close();
},
})),
p(this.elements, function (e, t) {
i.slidesContainer.appendChild(e.instance.create()),
(e.slideNode =
i.slidesContainer.querySelectorAll(".gslide")[t]);
}),
U && P(document.body, "glightbox-touch"),
(this.events.resize = q("resize", {
onElement: window,
withCallback: function () {
i.resize();
},
})),
(this.built = !0);
},
},
{
key: "resize",
value: function () {
var e,
t,
i,
n,
o,
s,
r,
l =
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: null;
(l = l || this.activeSlide) &&
!j(l, "zoomed") &&
((i = z()),
(e = l.querySelector(".gvideo-wrapper")),
(l = l.querySelector(".gslide-image")),
(t = this.slideDescription),
(r = i.width),
(i = i.height),
(r <= 768 ? P : N)(document.body, "glightbox-mobile"),
e || l) &&
((n = !1),
t &&
(j(t, "description-bottom") ||
j(t, "description-top")) &&
!j(t, "gabsolute") &&
(n = !0),
l &&
(r <= 768
? l.querySelector("img")
: n &&
((o = t.offsetHeight),
(l = l.querySelector("img")),
(s =
null !=
(s =
this.elements[this.index].node.getAttribute(
"data-height"
))
? s
: "100vh"),
l.setAttribute(
"style",
"max-height: calc("
.concat(s, " - ")
.concat(o, "px)")
),
t.setAttribute(
"style",
"max-width: ".concat(l.offsetWidth, "px;")
))),
e) &&
((s = x(this.settings.plyr.config, "ratio")
? this.settings.plyr.config.ratio
: "") ||
((o = e.clientWidth),
(l = e.clientHeight),
(s = "".concat(o / (o = o / l), ":").concat(l / o))),
(l = s.split(":")),
(o = this.settings.videosWidth),
(s = this.settings.videosWidth),
(l =
(s =
B(o) || -1 !== o.indexOf("px")
? parseInt(o)
: -1 !== o.indexOf("vw")
? (r * parseInt(o)) / 100
: -1 !== o.indexOf("vh")
? (i * parseInt(o)) / 100
: -1 !== o.indexOf("%")
? (r * parseInt(o)) / 100
: parseInt(e.clientWidth)) /
(parseInt(l[0]) / parseInt(l[1]))),
(l = Math.floor(l)),
n && (i -= t.offsetHeight),
r < s || i < l || (i < l && s < r)
? ((l = e.offsetWidth),
(s = e.offsetHeight),
e.parentNode.setAttribute(
"style",
"max-width: ".concat(
(l = { width: l * (r = i / s), height: s * r })
.width,
"px"
)
),
n &&
t.setAttribute(
"style",
"max-width: ".concat(l.width, "px;")
))
: ((e.parentNode.style.maxWidth = "".concat(o)),
n &&
t.setAttribute(
"style",
"max-width: ".concat(o, ";")
)));
},
},
{
key: "reload",
value: function () {
this.init();
},
},
{
key: "updateNavigationClasses",
value: function () {
var e = this.loop();
N(this.nextButton, "disabled"),
N(this.prevButton, "disabled"),
0 == this.index && this.elements.length - 1 == 0
? (P(this.prevButton, "disabled"),
P(this.nextButton, "disabled"))
: 0 !== this.index || e
? this.index !== this.elements.length - 1 ||
e ||
P(this.nextButton, "disabled")
: P(this.prevButton, "disabled");
},
},
{
key: "loop",
value: function () {
var e = x(this.settings, "loopAtEnd")
? this.settings.loopAtEnd
: null;
return x(this.settings, "loop") ? this.settings.loop : e;
},
},
{
key: "close",
value: function () {
var i = this;
if (!this.lightboxOpen) {
if (this.events) {
for (var e in this.events)
this.events.hasOwnProperty(e) &&
this.events[e].destroy();
this.events = null;
}
return !1;
}
if (this.closing) return !1;
(this.closing = !0),
this.slidePlayerPause(this.activeSlide),
this.fullElementsList &&
(this.elements = this.fullElementsList),
this.bodyHiddenChildElms.length &&
p(this.bodyHiddenChildElms, function (e) {
e.removeAttribute("aria-hidden");
}),
P(this.modal, "glightbox-closing"),
M(
this.overlay,
"none" == this.settings.openEffect
? "none"
: this.settings.cssEfects.fade.out
),
M(
this.activeSlide,
this.settings.cssEfects[this.settings.closeEffect].out,
function () {
if (
((i.activeSlide = null),
(i.prevActiveSlideIndex = null),
(i.prevActiveSlide = null),
(i.built = !1),
i.events)
) {
for (var e in i.events)
i.events.hasOwnProperty(e) &&
i.events[e].destroy();
i.events = null;
}
var t = document.body,
t =
(N(V, "glightbox-open"),
N(
t,
"glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"
),
i.modal.parentNode.removeChild(i.modal),
i.trigger("close"),
W(i.settings.onClose) && i.settings.onClose(),
document.querySelector(".gcss-styles"));
t && t.parentNode.removeChild(t),
(i.lightboxOpen = !1),
(i.closing = null);
}
);
},
},
{
key: "destroy",
value: function () {
this.close(),
this.clearAllEvents(),
this.baseEvents && this.baseEvents.destroy();
},
},
{
key: "on",
value: function (e, t) {
var i =
2 < arguments.length &&
void 0 !== arguments[2] &&
arguments[2];
if (!e || !W(t))
throw new TypeError(
"Event name and callback must be defined"
);
this.apiEvents.push({ evt: e, once: i, callback: t });
},
},
{
key: "once",
value: function (e, t) {
this.on(e, t, !0);
},
},
{
key: "trigger",
value: function (o) {
var t = this,
s =
1 < arguments.length && void 0 !== arguments[1]
? arguments[1]
: null,
r = [];
p(this.apiEvents, function (e, t) {
var i = e.evt,
n = e.once;
i == o && ((0, e.callback)(s), n) && r.push(t);
}),
r.length &&
p(r, function (e) {
return t.apiEvents.splice(e, 1);
});
},
},
{
key: "clearAllEvents",
value: function () {
this.apiEvents.splice(0, this.apiEvents.length);
},
},
{
key: "version",
value: function () {
return "3.3.0";
},
},
]
)),
function () {
var e = new _(
0 < arguments.length && void 0 !== arguments[0]
? arguments[0]
: {}
);
return e.init(), e;
});
},
616: function (ln, an) {
var cn, e, t;
(e = "undefined" != typeof window ? window : this),
(t = function (S, j) {
function m(e) {
return (
"function" == typeof e &&
"number" != typeof e.nodeType &&
"function" != typeof e.item
);
}
function H(e) {
return null != e && e === e.window;
}
var t = [],
M = Object.getPrototypeOf,
l = t.slice,
I = t.flat
? function (e) {
return t.flat.call(e);
}
: function (e) {
return t.concat.apply([], e);
},
z = t.push,
b = t.indexOf,
W = {},
X = W.toString,
R = W.hasOwnProperty,
B = R.toString,
Y = B.call(Object),
g = {},
T = S.document,
F = { type: !0, src: !0, nonce: !0, noModule: !0 };
function U(e, t, i) {
var n,
o,
s = (i = i || T).createElement("script");
if (((s.text = e), t))
for (n in F)
(o = t[n] || (t.getAttribute && t.getAttribute(n))) &&
s.setAttribute(n, o);
i.head.appendChild(s).parentNode.removeChild(s);
}
function V(e) {
return null == e
? e + ""
: "object" == typeof e || "function" == typeof e
? W[X.call(e)] || "object"
: typeof e;
}
var G = /HTML$/i,
k = function (e, t) {
return new k.fn.init(e, t);
};
function Z(e) {
var t = !!e && "length" in e && e.length,
i = V(e);
return (
!m(e) &&
!H(e) &&
("array" === i ||
0 === t ||
("number" == typeof t && 0 < t && t - 1 in e))
);
}
function x(e, t) {
return (
e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
);
}
(k.fn = k.prototype =
{
jquery: "3.7.1",
constructor: k,
length: 0,
toArray: function () {
return l.call(this);
},
get: function (e) {
return null == e
? l.call(this)
: e < 0
? this[e + this.length]
: this[e];
},
pushStack: function (e) {
e = k.merge(this.constructor(), e);
return (e.prevObject = this), e;
},
each: function (e) {
return k.each(this, e);
},
map: function (i) {
return this.pushStack(
k.map(this, function (e, t) {
return i.call(e, t, e);
})
);
},
slice: function () {
return this.pushStack(l.apply(this, arguments));
},
first: function () {
return this.eq(0);
},
last: function () {
return this.eq(-1);
},
even: function () {
return this.pushStack(
k.grep(this, function (e, t) {
return (t + 1) % 2;
})
);
},
odd: function () {
return this.pushStack(
k.grep(this, function (e, t) {
return t % 2;
})
);
},
eq: function (e) {
var t = this.length,
e = +e + (e < 0 ? t : 0);
return this.pushStack(0 <= e && e < t ? [this[e]] : []);
},
end: function () {
return this.prevObject || this.constructor();
},
push: z,
sort: t.sort,
splice: t.splice,
}),
(k.extend = k.fn.extend =
function () {
var e,
t,
i,
n,
o,
s = arguments[0] || {},
r = 1,
l = arguments.length,
a = !1;
for (
"boolean" == typeof s &&
((a = s), (s = arguments[r] || {}), r++),
"object" == typeof s || m(s) || (s = {}),
r === l && ((s = this), r--);
r < l;
r++
)
if (null != (e = arguments[r]))
for (t in e)
(i = e[t]),
"__proto__" !== t &&
s !== i &&
(a &&
i &&
(k.isPlainObject(i) || (n = Array.isArray(i)))
? ((o = s[t]),
(o =
n && !Array.isArray(o)
? []
: n || k.isPlainObject(o)
? o
: {}),
(n = !1),
(s[t] = k.extend(a, o, i)))
: void 0 !== i && (s[t] = i));
return s;
}),
k.extend({
expando:
"jQuery" + ("3.7.1" + Math.random()).replace(/\D/g, ""),
isReady: !0,
error: function (e) {
throw new Error(e);
},
noop: function () {},
isPlainObject: function (e) {
return !(
!e ||
"[object Object]" !== X.call(e) ||
((e = M(e)) &&
("function" !=
typeof (e =
R.call(e, "constructor") && e.constructor) ||
B.call(e) !== Y))
);
},
isEmptyObject: function (e) {
for (var t in e) return !1;
return !0;
},
globalEval: function (e, t, i) {
U(e, { nonce: t && t.nonce }, i);
},
each: function (e, t) {
var i,
n = 0;
if (Z(e))
for (
i = e.length;
n < i && !1 !== t.call(e[n], n, e[n]);
n++
);
else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
return e;
},
text: function (e) {
var t,
i = "",
n = 0,
o = e.nodeType;
if (!o) for (; (t = e[n++]); ) i += k.text(t);
return 1 === o || 11 === o
? e.textContent
: 9 === o
? e.documentElement.textContent
: 3 === o || 4 === o
? e.nodeValue
: i;
},
makeArray: function (e, t) {
t = t || [];
return (
null != e &&
(Z(Object(e))
? k.merge(t, "string" == typeof e ? [e] : e)
: z.call(t, e)),
t
);
},
inArray: function (e, t, i) {
return null == t ? -1 : b.call(t, e, i);
},
isXMLDoc: function (e) {
var t = e && e.namespaceURI,
e = e && (e.ownerDocument || e).documentElement;
return !G.test(t || (e && e.nodeName) || "HTML");
},
merge: function (e, t) {
for (var i = +t.length, n = 0, o = e.length; n < i; n++)
e[o++] = t[n];
return (e.length = o), e;
},
grep: function (e, t, i) {
for (var n = [], o = 0, s = e.length, r = !i; o < s; o++)
!t(e[o], o) != r && n.push(e[o]);
return n;
},
map: function (e, t, i) {
var n,
o,
s = 0,
r = [];
if (Z(e))
for (n = e.length; s < n; s++)
null != (o = t(e[s], s, i)) && r.push(o);
else for (s in e) null != (o = t(e[s], s, i)) && r.push(o);
return I(r);
},
guid: 1,
support: g,
}),
"function" == typeof Symbol &&
(k.fn[Symbol.iterator] = t[Symbol.iterator]),
k.each(
"Boolean Number String Function Array Date RegExp Object Error Symbol".split(
" "
),
function (e, t) {
W["[object " + t + "]"] = t.toLowerCase();
}
);
var Q = t.pop,
J = t.sort,
K = t.splice,
i = "[\\x20\\t\\r\\n\\f]",
ee = new RegExp(
"^" + i + "+|((?:^|[^\\\\])(?:\\\\.)*)" + i + "+$",
"g"
),
te =
((k.contains = function (e, t) {
t = t && t.parentNode;
return (
e === t ||
!(
!t ||
1 !== t.nodeType ||
!(e.contains
? e.contains(t)
: e.compareDocumentPosition &&
16 & e.compareDocumentPosition(t))
)
);
}),
/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g);
function ie(e, t) {
return t
? "\0" === e
? "�"
: e.slice(0, -1) +
"\\" +
e.charCodeAt(e.length - 1).toString(16) +
" "
: "\\" + e;
}
k.escapeSelector = function (e) {
return (e + "").replace(te, ie);
};
var ne,
w,
oe,
se,
re,
C,
n,
A,
p,
le,
o = T,
ae = z,
E = ae,
L = k.expando,
$ = 0,
ce = 0,
de = $e(),
ue = $e(),
pe = $e(),
he = $e(),
fe = function (e, t) {
return e === t && (re = !0), 0;
},
ge =
"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
e =
"(?:\\\\[\\da-fA-F]{1,6}" +
i +
"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
s =
"\\[" +
i +
"*(" +
e +
")(?:" +
i +
"*([*^$|!~]?=)" +
i +
"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
e +
"))|)" +
i +
"*\\]",
r =
":(" +
e +
")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
s +
")*)|.*)\\)|)",
ve = new RegExp(i + "+", "g"),
ye = new RegExp("^" + i + "*," + i + "*"),
me = new RegExp("^" + i + "*([>+~]|" + i + ")" + i + "*"),
be = new RegExp(i + "|>"),
xe = new RegExp(r),
we = new RegExp("^" + e + "$"),
Se = {
ID: new RegExp("^#(" + e + ")"),
CLASS: new RegExp("^\\.(" + e + ")"),
TAG: new RegExp("^(" + e + "|[*])"),
ATTR: new RegExp("^" + s),
PSEUDO: new RegExp("^" + r),
CHILD: new RegExp(
"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
i +
"*(even|odd|(([+-]|)(\\d*)n|)" +
i +
"*(?:([+-]|)" +
i +
"*(\\d+)|))" +
i +
"*\\)|)",
"i"
),
bool: new RegExp("^(?:" + ge + ")$", "i"),
needsContext: new RegExp(
"^" +
i +
"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
i +
"*((?:-\\d)?\\d*)" +
i +
"*\\)|)(?=[^-]|$)",
"i"
),
},
Te = /^(?:input|select|textarea|button)$/i,
ke = /^h\d$/i,
Ce = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
Ae = /[+~]/,
u = new RegExp(
"\\\\[\\da-fA-F]{1,6}" + i + "?|\\\\([^\\r\\n\\f])",
"g"
),
h = function (e, t) {
e = "0x" + e.slice(1) - 65536;
return (
t ||
(e < 0
? String.fromCharCode(65536 + e)
: String.fromCharCode(
(e >> 10) | 55296,
(1023 & e) | 56320
))
);
},
Ee = function () {
Pe();
},
Le = Me(
function (e) {
return !0 === e.disabled && x(e, "fieldset");
},
{ dir: "parentNode", next: "legend" }
);
try {
E.apply((t = l.call(o.childNodes)), o.childNodes),
t[o.childNodes.length].nodeType;
} catch (ne) {
E = {
apply: function (e, t) {
ae.apply(e, l.call(t));
},
call: function (e) {
ae.apply(e, l.call(arguments, 1));
},
};
}
function _(e, t, i, n) {
var o,
s,
r,
l,
a,
c,
d = t && t.ownerDocument,
u = t ? t.nodeType : 9;
if (
((i = i || []),
"string" != typeof e ||
!e ||
(1 !== u && 9 !== u && 11 !== u))
)
return i;
if (!n && (Pe(t), (t = t || C), A)) {
if (11 !== u && (l = Ce.exec(e)))
if ((o = l[1])) {
if (9 === u) {
if (!(c = t.getElementById(o))) return i;
if (c.id === o) return E.call(i, c), i;
} else if (
d &&
(c = d.getElementById(o)) &&
_.contains(t, c) &&
c.id === o
)
return E.call(i, c), i;
} else {
if (l[2]) return E.apply(i, t.getElementsByTagName(e)), i;
if ((o = l[3]) && t.getElementsByClassName)
return E.apply(i, t.getElementsByClassName(o)), i;
}
if (!(he[e + " "] || (p && p.test(e)))) {
if (
((c = e), (d = t), 1 === u && (be.test(e) || me.test(e)))
) {
for (
((d = (Ae.test(e) && qe(t.parentNode)) || t) == t &&
g.scope) ||
((r = t.getAttribute("id"))
? (r = k.escapeSelector(r))
: t.setAttribute("id", (r = L))),
s = (a = je(e)).length;
s--;
)
a[s] = (r ? "#" + r : ":scope") + " " + He(a[s]);
c = a.join(",");
}
try {
return E.apply(i, d.querySelectorAll(c)), i;
} catch (t) {
he(e, !0);
} finally {
r === L && t.removeAttribute("id");
}
}
}
return Re(e.replace(ee, "$1"), t, i, n);
}
function $e() {
var n = [];
return function e(t, i) {
return (
n.push(t + " ") > w.cacheLength && delete e[n.shift()],
(e[t + " "] = i)
);
};
}
function O(e) {
return (e[L] = !0), e;
}
function _e(e) {
var t = C.createElement("fieldset");
try {
return !!e(t);
} catch (e) {
return !1;
} finally {
t.parentNode && t.parentNode.removeChild(t);
}
}
function Oe(t) {
return function (e) {
return "form" in e
? e.parentNode && !1 === e.disabled
? "label" in e
? "label" in e.parentNode
? e.parentNode.disabled === t
: e.disabled === t
: e.isDisabled === t ||
(e.isDisabled !== !t && Le(e) === t)
: e.disabled === t
: "label" in e && e.disabled === t;
};
}
function De(r) {
return O(function (s) {
return (
(s = +s),
O(function (e, t) {
for (var i, n = r([], e.length, s), o = n.length; o--; )
e[(i = n[o])] && (e[i] = !(t[i] = e[i]));
})
);
});
}
function qe(e) {
return e && void 0 !== e.getElementsByTagName && e;
}
function Pe(e) {
var e = e ? e.ownerDocument || e : o;
return (
e != C &&
9 === e.nodeType &&
e.documentElement &&
((n = (C = e).documentElement),
(A = !k.isXMLDoc(C)),
(le =
n.matches ||
n.webkitMatchesSelector ||
n.msMatchesSelector),
n.msMatchesSelector &&
o != C &&
(e = C.defaultView) &&
e.top !== e &&
e.addEventListener("unload", Ee),
(g.getById = _e(function (e) {
return (
(n.appendChild(e).id = k.expando),
!C.getElementsByName ||
!C.getElementsByName(k.expando).length
);
})),
(g.disconnectedMatch = _e(function (e) {
return le.call(e, "*");
})),
(g.scope = _e(function () {
return C.querySelectorAll(":scope");
})),
(g.cssHas = _e(function () {
try {
return C.querySelector(":has(*,:jqfake)"), 0;
} catch (e) {
return 1;
}
})),
g.getById
? ((w.filter.ID = function (e) {
var t = e.replace(u, h);
return function (e) {
return e.getAttribute("id") === t;
};
}),
(w.find.ID = function (e, t) {
if (void 0 !== t.getElementById && A)
return (t = t.getElementById(e)) ? [t] : [];
}))
: ((w.filter.ID = function (e) {
var t = e.replace(u, h);
return function (e) {
e =
void 0 !== e.getAttributeNode &&
e.getAttributeNode("id");
return e && e.value === t;
};
}),
(w.find.ID = function (e, t) {
if (void 0 !== t.getElementById && A) {
var i,
n,
o,
s = t.getElementById(e);
if (s) {
if (
(i = s.getAttributeNode("id")) &&
i.value === e
)
return [s];
for (
o = t.getElementsByName(e), n = 0;
(s = o[n++]);
)
if (
(i = s.getAttributeNode("id")) &&
i.value === e
)
return [s];
}
return [];
}
})),
(w.find.TAG = function (e, t) {
return void 0 !== t.getElementsByTagName
? t.getElementsByTagName(e)
: t.querySelectorAll(e);
}),
(w.find.CLASS = function (e, t) {
if (void 0 !== t.getElementsByClassName && A)
return t.getElementsByClassName(e);
}),
(p = []),
_e(function (e) {
var t;
(n.appendChild(e).innerHTML =
"<a id='" +
L +
"' href='' disabled='disabled'></a><select id='" +
L +
"-\r\\' disabled='disabled'><option selected=''></option></select>"),
e.querySelectorAll("[selected]").length ||
p.push("\\[" + i + "*(?:value|" + ge + ")"),
e.querySelectorAll("[id~=" + L + "-]").length ||
p.push("~="),
e.querySelectorAll("a#" + L + "+*").length ||
p.push(".#.+[+~]"),
e.querySelectorAll(":checked").length ||
p.push(":checked"),
(t = C.createElement("input")).setAttribute(
"type",
"hidden"
),
e.appendChild(t).setAttribute("name", "D"),
(n.appendChild(e).disabled = !0),
2 !== e.querySelectorAll(":disabled").length &&
p.push(":enabled", ":disabled"),
(t = C.createElement("input")).setAttribute("name", ""),
e.appendChild(t),
e.querySelectorAll("[name='']").length ||
p.push(
"\\[" + i + "*name" + i + "*=" + i + "*(?:''|\"\")"
);
}),
g.cssHas || p.push(":has"),
(p = p.length && new RegExp(p.join("|"))),
(fe = function (e, t) {
var i;
return e === t
? ((re = !0), 0)
: !e.compareDocumentPosition -
!t.compareDocumentPosition ||
(1 &
(i =
(e.ownerDocument || e) == (t.ownerDocument || t)
? e.compareDocumentPosition(t)
: 1) ||
(!g.sortDetached &&
t.compareDocumentPosition(e) === i)
? e === C ||
(e.ownerDocument == o && _.contains(o, e))
? -1
: t === C ||
(t.ownerDocument == o && _.contains(o, t))
? 1
: se
? b.call(se, e) - b.call(se, t)
: 0
: 4 & i
? -1
: 1);
})),
C
);
}
for (ne in ((_.matches = function (e, t) {
return _(e, null, null, t);
}),
(_.matchesSelector = function (e, t) {
if ((Pe(e), A && !he[t + " "] && (!p || !p.test(t))))
try {
var i = le.call(e, t);
if (
i ||
g.disconnectedMatch ||
(e.document && 11 !== e.document.nodeType)
)
return i;
} catch (e) {
he(t, !0);
}
return 0 < _(t, C, null, [e]).length;
}),
(_.contains = function (e, t) {
return (e.ownerDocument || e) != C && Pe(e), k.contains(e, t);
}),
(_.attr = function (e, t) {
(e.ownerDocument || e) != C && Pe(e);
var i = w.attrHandle[t.toLowerCase()],
i =
i && R.call(w.attrHandle, t.toLowerCase())
? i(e, t, !A)
: void 0;
return void 0 !== i ? i : e.getAttribute(t);
}),
(_.error = function (e) {
throw new Error("Syntax error, unrecognized expression: " + e);
}),
(k.uniqueSort = function (e) {
var t,
i = [],
n = 0,
o = 0;
if (
((re = !g.sortStable),
(se = !g.sortStable && l.call(e, 0)),
J.call(e, fe),
re)
) {
for (; (t = e[o++]); ) t === e[o] && (n = i.push(o));
for (; n--; ) K.call(e, i[n], 1);
}
return (se = null), e;
}),
(k.fn.uniqueSort = function () {
return this.pushStack(k.uniqueSort(l.apply(this)));
}),
((w = k.expr =
{
cacheLength: 50,
createPseudo: O,
match: Se,
attrHandle: {},
find: {},
relative: {
">": { dir: "parentNode", first: !0 },
" ": { dir: "parentNode" },
"+": { dir: "previousSibling", first: !0 },
"~": { dir: "previousSibling" },
},
preFilter: {
ATTR: function (e) {
return (
(e[1] = e[1].replace(u, h)),
(e[3] = (e[3] || e[4] || e[5] || "").replace(u, h)),
"~=" === e[2] && (e[3] = " " + e[3] + " "),
e.slice(0, 4)
);
},
CHILD: function (e) {
return (
(e[1] = e[1].toLowerCase()),
"nth" === e[1].slice(0, 3)
? (e[3] || _.error(e[0]),
(e[4] = +(e[4]
? e[5] + (e[6] || 1)
: 2 * ("even" === e[3] || "odd" === e[3]))),
(e[5] = +(e[7] + e[8] || "odd" === e[3])))
: e[3] && _.error(e[0]),
e
);
},
PSEUDO: function (e) {
var t,
i = !e[6] && e[2];
return Se.CHILD.test(e[0])
? null
: (e[3]
? (e[2] = e[4] || e[5] || "")
: i &&
xe.test(i) &&
(t =
(t = je(i, !0)) &&
i.indexOf(")", i.length - t) - i.length) &&
((e[0] = e[0].slice(0, t)),
(e[2] = i.slice(0, t))),
e.slice(0, 3));
},
},
filter: {
TAG: function (e) {
var t = e.replace(u, h).toLowerCase();
return "*" === e
? function () {
return !0;
}
: function (e) {
return x(e, t);
};
},
CLASS: function (e) {
var t = de[e + " "];
return (
t ||
((t = new RegExp(
"(^|" + i + ")" + e + "(" + i + "|$)"
)) &&
de(e, function (e) {
return t.test(
("string" == typeof e.className && e.className) ||
(void 0 !== e.getAttribute &&
e.getAttribute("class")) ||
""
);
}))
);
},
ATTR: function (t, i, n) {
return function (e) {
e = _.attr(e, t);
return null == e
? "!=" === i
: !i ||
((e += ""),
"=" === i
? e === n
: "!=" === i
? e !== n
: "^=" === i
? n && 0 === e.indexOf(n)
: "*=" === i
? n && -1 < e.indexOf(n)
: "$=" === i
? n && e.slice(-n.length) === n
: "~=" === i
? -1 <
(" " + e.replace(ve, " ") + " ").indexOf(n)
: "|=" === i &&
(e === n ||
e.slice(0, n.length + 1) === n + "-"));
};
},
CHILD: function (h, e, t, f, g) {
var v = "nth" !== h.slice(0, 3),
y = "last" !== h.slice(-4),
m = "of-type" === e;
return 1 === f && 0 === g
? function (e) {
return !!e.parentNode;
}
: function (e, t, i) {
var n,
o,
s,
r,
l,
a = v != y ? "nextSibling" : "previousSibling",
c = e.parentNode,
d = m && e.nodeName.toLowerCase(),
u = !i && !m,
p = !1;
if (c) {
if (v) {
for (; a; ) {
for (s = e; (s = s[a]); )
if (m ? x(s, d) : 1 === s.nodeType)
return !1;
l = a = "only" === h && !l && "nextSibling";
}
return !0;
}
if (
((l = [y ? c.firstChild : c.lastChild]), y && u)
) {
for (
p =
(r =
(n =
(o = c[L] || (c[L] = {}))[h] ||
[])[0] === $ && n[1]) && n[2],
s = r && c.childNodes[r];
(s =
(++r && s && s[a]) ||
((p = r = 0), l.pop()));
)
if (1 === s.nodeType && ++p && s === e) {
o[h] = [$, r, p];
break;
}
} else if (
!1 ===
(p = u
? (r =
(n =
(o = e[L] || (e[L] = {}))[h] ||
[])[0] === $ && n[1])
: p)
)
for (
;
(s =
(++r && s && s[a]) ||
((p = r = 0), l.pop())) &&
(!(m ? x(s, d) : 1 === s.nodeType) ||
!++p ||
(u &&
((o = s[L] || (s[L] = {}))[h] = [$, p]),
s !== e));
);
return (
(p -= g) === f || (p % f == 0 && 0 <= p / f)
);
}
};
},
PSEUDO: function (e, s) {
var t,
r =
w.pseudos[e] ||
w.setFilters[e.toLowerCase()] ||
_.error("unsupported pseudo: " + e);
return r[L]
? r(s)
: 1 < r.length
? ((t = [e, e, "", s]),
w.setFilters.hasOwnProperty(e.toLowerCase())
? O(function (e, t) {
for (var i, n = r(e, s), o = n.length; o--; )
e[(i = b.call(e, n[o]))] = !(t[i] = n[o]);
})
: function (e) {
return r(e, 0, t);
})
: r;
},
},
pseudos: {
not: O(function (e) {
var n = [],
o = [],
l = Xe(e.replace(ee, "$1"));
return l[L]
? O(function (e, t, i, n) {
for (
var o, s = l(e, null, n, []), r = e.length;
r--;
)
(o = s[r]) && (e[r] = !(t[r] = o));
})
: function (e, t, i) {
return (
(n[0] = e),
l(n, null, i, o),
(n[0] = null),
!o.pop()
);
};
}),
has: O(function (t) {
return function (e) {
return 0 < _(t, e).length;
};
}),
contains: O(function (t) {
return (
(t = t.replace(u, h)),
function (e) {
return -1 < (e.textContent || k.text(e)).indexOf(t);
}
);
}),
lang: O(function (i) {
return (
we.test(i || "") || _.error("unsupported lang: " + i),
(i = i.replace(u, h).toLowerCase()),
function (e) {
var t;
do {
if (
(t = A
? e.lang
: e.getAttribute("xml:lang") ||
e.getAttribute("lang"))
)
return (
(t = t.toLowerCase()) === i ||
0 === t.indexOf(i + "-")
);
} while ((e = e.parentNode) && 1 === e.nodeType);
return !1;
}
);
}),
target: function (e) {
var t = S.location && S.location.hash;
return t && t.slice(1) === e.id;
},
root: function (e) {
return e === n;
},
focus: function (e) {
return (
e ===
(function () {
try {
return C.activeElement;
} catch (e) {}
})() &&
C.hasFocus() &&
!!(e.type || e.href || ~e.tabIndex)
);
},
enabled: Oe(!1),
disabled: Oe(!0),
checked: function (e) {
return (
(x(e, "input") && !!e.checked) ||
(x(e, "option") && !!e.selected)
);
},
selected: function (e) {
return (
e.parentNode && e.parentNode.selectedIndex,
!0 === e.selected
);
},
empty: function (e) {
for (e = e.firstChild; e; e = e.nextSibling)
if (e.nodeType < 6) return !1;
return !0;
},
parent: function (e) {
return !w.pseudos.empty(e);
},
header: function (e) {
return ke.test(e.nodeName);
},
input: function (e) {
return Te.test(e.nodeName);
},
button: function (e) {
return (
(x(e, "input") && "button" === e.type) || x(e, "button")
);
},
text: function (e) {
return (
x(e, "input") &&
"text" === e.type &&
(null == (e = e.getAttribute("type")) ||
"text" === e.toLowerCase())
);
},
first: De(function () {
return [0];
}),
last: De(function (e, t) {
return [t - 1];
}),
eq: De(function (e, t, i) {
return [i < 0 ? i + t : i];
}),
even: De(function (e, t) {
for (var i = 0; i < t; i += 2) e.push(i);
return e;
}),
odd: De(function (e, t) {
for (var i = 1; i < t; i += 2) e.push(i);
return e;
}),
lt: De(function (e, t, i) {
for (var n = i < 0 ? i + t : t < i ? t : i; 0 <= --n; )
e.push(n);
return e;
}),
gt: De(function (e, t, i) {
for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
return e;
}),
},
}).pseudos.nth = w.pseudos.eq),
{ radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
w.pseudos[ne] = (function (t) {
return function (e) {
return x(e, "input") && e.type === t;
};
})(ne);
for (ne in { submit: !0, reset: !0 })
w.pseudos[ne] = (function (t) {
return function (e) {
return (x(e, "input") || x(e, "button")) && e.type === t;
};
})(ne);
function Ne() {}
function je(e, t) {
var i,
n,
o,
s,
r,
l,
a,
c = ue[e + " "];
if (c) return t ? 0 : c.slice(0);
for (r = e, l = [], a = w.preFilter; r; ) {
for (s in ((i && !(n = ye.exec(r))) ||
(n && (r = r.slice(n[0].length) || r), l.push((o = []))),
(i = !1),
(n = me.exec(r)) &&
((i = n.shift()),
o.push({ value: i, type: n[0].replace(ee, " ") }),
(r = r.slice(i.length))),
w.filter))
!(n = Se[s].exec(r)) ||
(a[s] && !(n = a[s](n))) ||
((i = n.shift()),
o.push({ value: i, type: s, matches: n }),
(r = r.slice(i.length)));
if (!i) break;
}
return t ? r.length : r ? _.error(e) : ue(e, l).slice(0);
}
function He(e) {
for (var t = 0, i = e.length, n = ""; t < i; t++)
n += e[t].value;
return n;
}
function Me(r, e, t) {
var l = e.dir,
a = e.next,
c = a || l,
d = t && "parentNode" === c,
u = ce++;
return e.first
? function (e, t, i) {
for (; (e = e[l]); )
if (1 === e.nodeType || d) return r(e, t, i);
return !1;
}
: function (e, t, i) {
var n,
o,
s = [$, u];
if (i) {
for (; (e = e[l]); )
if ((1 === e.nodeType || d) && r(e, t, i)) return !0;
} else
for (; (e = e[l]); )
if (1 === e.nodeType || d)
if (((o = e[L] || (e[L] = {})), a && x(e, a)))
e = e[l] || e;
else {
if ((n = o[c]) && n[0] === $ && n[1] === u)
return (s[2] = n[2]);
if (((o[c] = s)[2] = r(e, t, i))) return !0;
}
return !1;
};
}
function Ie(o) {
return 1 < o.length
? function (e, t, i) {
for (var n = o.length; n--; )
if (!o[n](e, t, i)) return !1;
return !0;
}
: o[0];
}
function ze(e, t, i, n, o) {
for (
var s, r = [], l = 0, a = e.length, c = null != t;
l < a;
l++
)
!(s = e[l]) ||
(i && !i(s, n, o)) ||
(r.push(s), c && t.push(l));
return r;
}
function We(e) {
for (
var n,
t,
i,
o = e.length,
s = w.relative[e[0].type],
r = s || w.relative[" "],
l = s ? 1 : 0,
a = Me(
function (e) {
return e === n;
},
r,
!0
),
c = Me(
function (e) {
return -1 < b.call(n, e);
},
r,
!0
),
d = [
function (e, t, i) {
e =
(!s && (i || t != oe)) ||
((n = t).nodeType ? a : c)(e, t, i);
return (n = null), e;
},
];
l < o;
l++
)
if ((t = w.relative[e[l].type])) d = [Me(Ie(d), t)];
else {
if (
(t = w.filter[e[l].type].apply(null, e[l].matches))[L]
) {
for (i = ++l; i < o && !w.relative[e[i].type]; i++);
return (function e(h, f, g, v, y, t) {
return (
v && !v[L] && (v = e(v)),
y && !y[L] && (y = e(y, t)),
O(function (e, t, i, n) {
var o,
s,
r,
l,
a = [],
c = [],
d = t.length,
u =
e ||
(function (e, t, i) {
for (var n = 0, o = t.length; n < o; n++)
_(e, t[n], i);
return i;
})(f || "*", i.nodeType ? [i] : i, []),
p = !h || (!e && f) ? u : ze(u, a, h, i, n);
if (
(g
? g(
p,
(l = y || (e ? h : d || v) ? [] : t),
i,
n
)
: (l = p),
v)
)
for (
o = ze(l, c), v(o, [], i, n), s = o.length;
s--;
)
(r = o[s]) && (l[c[s]] = !(p[c[s]] = r));
if (e) {
if (y || h) {
if (y) {
for (o = [], s = l.length; s--; )
(r = l[s]) && o.push((p[s] = r));
y(null, (l = []), o, n);
}
for (s = l.length; s--; )
(r = l[s]) &&
-1 < (o = y ? b.call(e, r) : a[s]) &&
(e[o] = !(t[o] = r));
}
} else (l = ze(l === t ? l.splice(d, l.length) : l)), y ? y(null, t, l, n) : E.apply(t, l);
})
);
})(
1 < l && Ie(d),
1 < l &&
He(
e.slice(0, l - 1).concat({
value: " " === e[l - 2].type ? "*" : "",
})
).replace(ee, "$1"),
t,
l < i && We(e.slice(l, i)),
i < o && We((e = e.slice(i))),
i < o && He(e)
);
}
d.push(t);
}
return Ie(d);
}
function Xe(e, t) {
var i,
v,
y,
m,
b,
n = [],
o = [],
s = pe[e + " "];
if (!s) {
for (i = (t = t || je(e)).length; i--; )
((s = We(t[i]))[L] ? n : o).push(s);
(s = pe(
e,
((v = o),
(m = 0 < (y = n).length),
(b = 0 < v.length),
m ? O(r) : r)
)).selector = e;
}
function r(e, t, i, n, o) {
var s,
r,
l,
a = 0,
c = "0",
d = e && [],
u = [],
p = oe,
h = e || (b && w.find.TAG("*", o)),
f = ($ += null == p ? 1 : Math.random() || 0.1),
g = h.length;
for (
o && (oe = t == C || t || o);
c !== g && null != (s = h[c]);
c++
) {
if (b && s) {
for (
r = 0, t || s.ownerDocument == C || (Pe(s), (i = !A));
(l = v[r++]);
)
if (l(s, t || C, i)) {
E.call(n, s);
break;
}
o && ($ = f);
}
m && ((s = !l && s) && a--, e) && d.push(s);
}
if (((a += c), m && c !== a)) {
for (r = 0; (l = y[r++]); ) l(d, u, t, i);
if (e) {
if (0 < a)
for (; c--; ) d[c] || u[c] || (u[c] = Q.call(n));
u = ze(u);
}
E.apply(n, u),
o &&
!e &&
0 < u.length &&
1 < a + y.length &&
k.uniqueSort(n);
}
return o && (($ = f), (oe = p)), d;
}
return s;
}
function Re(e, t, i, n) {
var o,
s,
r,
l,
a,
c = "function" == typeof e && e,
d = !n && je((e = c.selector || e));
if (((i = i || []), 1 === d.length)) {
if (
2 < (s = d[0] = d[0].slice(0)).length &&
"ID" === (r = s[0]).type &&
9 === t.nodeType &&
A &&
w.relative[s[1].type]
) {
if (
!(t = (w.find.ID(r.matches[0].replace(u, h), t) || [])[0])
)
return i;
c && (t = t.parentNode),
(e = e.slice(s.shift().value.length));
}
for (
o = Se.needsContext.test(e) ? 0 : s.length;
o-- && ((r = s[o]), !w.relative[(l = r.type)]);
)
if (
(a = w.find[l]) &&
(n = a(
r.matches[0].replace(u, h),
(Ae.test(s[0].type) && qe(t.parentNode)) || t
))
) {
if ((s.splice(o, 1), (e = n.length && He(s)))) break;
return E.apply(i, n), i;
}
}
return (
(c || Xe(e, d))(
n,
t,
!A,
i,
!t || (Ae.test(e) && qe(t.parentNode)) || t
),
i
);
}
(Ne.prototype = w.filters = w.pseudos),
(w.setFilters = new Ne()),
(g.sortStable = L.split("").sort(fe).join("") === L),
Pe(),
(g.sortDetached = _e(function (e) {
return (
1 & e.compareDocumentPosition(C.createElement("fieldset"))
);
})),
(k.find = _),
(k.expr[":"] = k.expr.pseudos),
(k.unique = k.uniqueSort),
(_.compile = Xe),
(_.select = Re),
(_.setDocument = Pe),
(_.tokenize = je),
(_.escape = k.escapeSelector),
(_.getText = k.text),
(_.isXML = k.isXMLDoc),
(_.selectors = k.expr),
(_.support = k.support),
(_.uniqueSort = k.uniqueSort);
function Be(e, t, i) {
for (
var n = [], o = void 0 !== i;
(e = e[t]) && 9 !== e.nodeType;
)
if (1 === e.nodeType) {
if (o && k(e).is(i)) break;
n.push(e);
}
return n;
}
function Ye(e, t) {
for (var i = []; e; e = e.nextSibling)
1 === e.nodeType && e !== t && i.push(e);
return i;
}
var Fe = k.expr.match.needsContext,
Ue =
/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
function Ve(e, i, n) {
return m(i)
? k.grep(e, function (e, t) {
return !!i.call(e, t, e) !== n;
})
: i.nodeType
? k.grep(e, function (e) {
return (e === i) !== n;
})
: "string" != typeof i
? k.grep(e, function (e) {
return -1 < b.call(i, e) !== n;
})
: k.filter(i, e, n);
}
(k.filter = function (e, t, i) {
var n = t[0];
return (
i && (e = ":not(" + e + ")"),
1 === t.length && 1 === n.nodeType
? k.find.matchesSelector(n, e)
? [n]
: []
: k.find.matches(
e,
k.grep(t, function (e) {
return 1 === e.nodeType;
})
)
);
}),
k.fn.extend({
find: function (e) {
var t,
i,
n = this.length,
o = this;
if ("string" != typeof e)
return this.pushStack(
k(e).filter(function () {
for (t = 0; t < n; t++)
if (k.contains(o[t], this)) return !0;
})
);
for (i = this.pushStack([]), t = 0; t < n; t++)
k.find(e, o[t], i);
return 1 < n ? k.uniqueSort(i) : i;
},
filter: function (e) {
return this.pushStack(Ve(this, e || [], !1));
},
not: function (e) {
return this.pushStack(Ve(this, e || [], !0));
},
is: function (e) {
return !!Ve(
this,
"string" == typeof e && Fe.test(e) ? k(e) : e || [],
!1
).length;
},
});
var Ge,
Ze = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
Qe =
(((k.fn.init = function (e, t, i) {
if (e) {
if (((i = i || Ge), "string" != typeof e))
return e.nodeType
? ((this[0] = e), (this.length = 1), this)
: m(e)
? void 0 !== i.ready
? i.ready(e)
: e(k)
: k.makeArray(e, this);
if (
!(n =
"<" === e[0] &&
">" === e[e.length - 1] &&
3 <= e.length
? [null, e, null]
: Ze.exec(e)) ||
(!n[1] && t)
)
return (
!t || t.jquery ? t || i : this.constructor(t)
).find(e);
if (n[1]) {
if (
((t = t instanceof k ? t[0] : t),
k.merge(
this,
k.parseHTML(
n[1],
t && t.nodeType ? t.ownerDocument || t : T,
!0
)
),
Ue.test(n[1]) && k.isPlainObject(t))
)
for (var n in t)
m(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
} else
(i = T.getElementById(n[2])) &&
((this[0] = i), (this.length = 1));
}
return this;
}).prototype = k.fn),
(Ge = k(T)),
/^(?:parents|prev(?:Until|All))/),
Je = { children: !0, contents: !0, next: !0, prev: !0 };
function Ke(e, t) {
for (; (e = e[t]) && 1 !== e.nodeType; );
return e;
}
k.fn.extend({
has: function (e) {
var t = k(e, this),
i = t.length;
return this.filter(function () {
for (var e = 0; e < i; e++)
if (k.contains(this, t[e])) return !0;
});
},
closest: function (e, t) {
var i,
n = 0,
o = this.length,
s = [],
r = "string" != typeof e && k(e);
if (!Fe.test(e))
for (; n < o; n++)
for (i = this[n]; i && i !== t; i = i.parentNode)
if (
i.nodeType < 11 &&
(r
? -1 < r.index(i)
: 1 === i.nodeType && k.find.matchesSelector(i, e))
) {
s.push(i);
break;
}
return this.pushStack(1 < s.length ? k.uniqueSort(s) : s);
},
index: function (e) {
return e
? "string" == typeof e
? b.call(k(e), this[0])
: b.call(this, e.jquery ? e[0] : e)
: this[0] && this[0].parentNode
? this.first().prevAll().length
: -1;
},
add: function (e, t) {
return this.pushStack(
k.uniqueSort(k.merge(this.get(), k(e, t)))
);
},
addBack: function (e) {
return this.add(
null == e ? this.prevObject : this.prevObject.filter(e)
);
},
}),
k.each(
{
parent: function (e) {
e = e.parentNode;
return e && 11 !== e.nodeType ? e : null;
},
parents: function (e) {
return Be(e, "parentNode");
},
parentsUntil: function (e, t, i) {
return Be(e, "parentNode", i);
},
next: function (e) {
return Ke(e, "nextSibling");
},
prev: function (e) {
return Ke(e, "previousSibling");
},
nextAll: function (e) {
return Be(e, "nextSibling");
},
prevAll: function (e) {
return Be(e, "previousSibling");
},
nextUntil: function (e, t, i) {
return Be(e, "nextSibling", i);
},
prevUntil: function (e, t, i) {
return Be(e, "previousSibling", i);
},
siblings: function (e) {
return Ye((e.parentNode || {}).firstChild, e);
},
children: function (e) {
return Ye(e.firstChild);
},
contents: function (e) {
return null != e.contentDocument && M(e.contentDocument)
? e.contentDocument
: (x(e, "template") && (e = e.content || e),
k.merge([], e.childNodes));
},
},
function (n, o) {
k.fn[n] = function (e, t) {
var i = k.map(this, o, e);
return (
(t = "Until" !== n.slice(-5) ? e : t) &&
"string" == typeof t &&
(i = k.filter(t, i)),
1 < this.length &&
(Je[n] || k.uniqueSort(i), Qe.test(n)) &&
i.reverse(),
this.pushStack(i)
);
};
}
);
var D = /[^\x20\t\r\n\f]+/g;
function et(e) {
return e;
}
function tt(e) {
throw e;
}
function it(e, t, i, n) {
var o;
try {
e && m((o = e.promise))
? o.call(e).done(t).fail(i)
: e && m((o = e.then))
? o.call(e, t, i)
: t.apply(void 0, [e].slice(n));
} catch (e) {
i.apply(void 0, [e]);
}
}
(k.Callbacks = function (n) {
var e, i;
n =
"string" == typeof n
? ((e = n),
(i = {}),
k.each(e.match(D) || [], function (e, t) {
i[t] = !0;
}),
i)
: k.extend({}, n);
function o() {
for (l = l || n.once, r = s = !0; c.length; d = -1)
for (t = c.shift(); ++d < a.length; )
!1 === a[d].apply(t[0], t[1]) &&
n.stopOnFalse &&
((d = a.length), (t = !1));
n.memory || (t = !1), (s = !1), l && (a = t ? [] : "");
}
var s,
t,
r,
l,
a = [],
c = [],
d = -1,
u = {
add: function () {
return (
a &&
(t && !s && ((d = a.length - 1), c.push(t)),
(function i(e) {
k.each(e, function (e, t) {
m(t)
? (n.unique && u.has(t)) || a.push(t)
: t && t.length && "string" !== V(t) && i(t);
});
})(arguments),
t) &&
!s &&
o(),
this
);
},
remove: function () {
return (
k.each(arguments, function (e, t) {
for (var i; -1 < (i = k.inArray(t, a, i)); )
a.splice(i, 1), i <= d && d--;
}),
this
);
},
has: function (e) {
return e ? -1 < k.inArray(e, a) : 0 < a.length;
},
empty: function () {
return (a = a && []), this;
},
disable: function () {
return (l = c = []), (a = t = ""), this;
},
disabled: function () {
return !a;
},
lock: function () {
return (l = c = []), t || s || (a = t = ""), this;
},
locked: function () {
return !!l;
},
fireWith: function (e, t) {
return (
l ||
((t = [e, (t = t || []).slice ? t.slice() : t]),
c.push(t),
s) ||
o(),
this
);
},
fire: function () {
return u.fireWith(this, arguments), this;
},
fired: function () {
return !!r;
},
};
return u;
}),
k.extend({
Deferred: function (e) {
var s = [
[
"notify",
"progress",
k.Callbacks("memory"),
k.Callbacks("memory"),
2,
],
[
"resolve",
"done",
k.Callbacks("once memory"),
k.Callbacks("once memory"),
0,
"resolved",
],
[
"reject",
"fail",
k.Callbacks("once memory"),
k.Callbacks("once memory"),
1,
"rejected",
],
],
o = "pending",
r = {
state: function () {
return o;
},
always: function () {
return l.done(arguments).fail(arguments), this;
},
catch: function (e) {
return r.then(null, e);
},
pipe: function () {
var o = arguments;
return k
.Deferred(function (n) {
k.each(s, function (e, t) {
var i = m(o[t[4]]) && o[t[4]];
l[t[1]](function () {
var e = i && i.apply(this, arguments);
e && m(e.promise)
? e
.promise()
.progress(n.notify)
.done(n.resolve)
.fail(n.reject)
: n[t[0] + "With"](
this,
i ? [e] : arguments
);
});
}),
(o = null);
})
.promise();
},
then: function (t, i, n) {
var a = 0;
function c(o, s, r, l) {
return function () {
function e() {
var e, t;
if (!(o < a)) {
if ((e = r.apply(i, n)) === s.promise())
throw new TypeError(
"Thenable self-resolution"
);
(t =
e &&
("object" == typeof e ||
"function" == typeof e) &&
e.then),
m(t)
? l
? t.call(
e,
c(a, s, et, l),
c(a, s, tt, l)
)
: (a++,
t.call(
e,
c(a, s, et, l),
c(a, s, tt, l),
c(a, s, et, s.notifyWith)
))
: (r !== et && ((i = void 0), (n = [e])),
(l || s.resolveWith)(i, n));
}
}
var i = this,
n = arguments,
t = l
? e
: function () {
try {
e();
} catch (e) {
k.Deferred.exceptionHook &&
k.Deferred.exceptionHook(e, t.error),
a <= o + 1 &&
(r !== tt &&
((i = void 0), (n = [e])),
s.rejectWith(i, n));
}
};
o
? t()
: (k.Deferred.getErrorHook
? (t.error = k.Deferred.getErrorHook())
: k.Deferred.getStackHook &&
(t.error = k.Deferred.getStackHook()),
S.setTimeout(t));
};
}
return k
.Deferred(function (e) {
s[0][3].add(c(0, e, m(n) ? n : et, e.notifyWith)),
s[1][3].add(c(0, e, m(t) ? t : et)),
s[2][3].add(c(0, e, m(i) ? i : tt));
})
.promise();
},
promise: function (e) {
return null != e ? k.extend(e, r) : r;
},
},
l = {};
return (
k.each(s, function (e, t) {
var i = t[2],
n = t[5];
(r[t[1]] = i.add),
n &&
i.add(
function () {
o = n;
},
s[3 - e][2].disable,
s[3 - e][3].disable,
s[0][2].lock,
s[0][3].lock
),
i.add(t[3].fire),
(l[t[0]] = function () {
return (
l[t[0] + "With"](
this === l ? void 0 : this,
arguments
),
this
);
}),
(l[t[0] + "With"] = i.fireWith);
}),
r.promise(l),
e && e.call(l, l),
l
);
},
when: function (e) {
function t(t) {
return function (e) {
(o[t] = this),
(s[t] = 1 < arguments.length ? l.call(arguments) : e),
--i || r.resolveWith(o, s);
};
}
var i = arguments.length,
n = i,
o = Array(n),
s = l.call(arguments),
r = k.Deferred();
if (
i <= 1 &&
(it(e, r.done(t(n)).resolve, r.reject, !i),
"pending" === r.state() || m(s[n] && s[n].then))
)
return r.then();
for (; n--; ) it(s[n], t(n), r.reject);
return r.promise();
},
});
var nt = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/,
ot =
((k.Deferred.exceptionHook = function (e, t) {
S.console &&
S.console.warn &&
e &&
nt.test(e.name) &&
S.console.warn(
"jQuery.Deferred exception: " + e.message,
e.stack,
t
);
}),
(k.readyException = function (e) {
S.setTimeout(function () {
throw e;
});
}),
k.Deferred());
function st() {
T.removeEventListener("DOMContentLoaded", st),
S.removeEventListener("load", st),
k.ready();
}
(k.fn.ready = function (e) {
return (
ot.then(e).catch(function (e) {
k.readyException(e);
}),
this
);
}),
k.extend({
isReady: !1,
readyWait: 1,
ready: function (e) {
(!0 === e ? --k.readyWait : k.isReady) ||
((k.isReady = !0) !== e && 0 < --k.readyWait) ||
ot.resolveWith(T, [k]);
},
}),
(k.ready.then = ot.then),
"complete" === T.readyState ||
("loading" !== T.readyState && !T.documentElement.doScroll)
? S.setTimeout(k.ready)
: (T.addEventListener("DOMContentLoaded", st),
S.addEventListener("load", st));
function d(e, t, i, n, o, s, r) {
var l = 0,
a = e.length,
c = null == i;
if ("object" === V(i))
for (l in ((o = !0), i)) d(e, t, l, i[l], !0, s, r);
else if (
void 0 !== n &&
((o = !0),
m(n) || (r = !0),
(t = c
? r
? (t.call(e, n), null)
: ((c = t),
function (e, t, i) {
return c.call(k(e), i);
})
: t))
)
for (; l < a; l++)
t(e[l], i, r ? n : n.call(e[l], l, t(e[l], i)));
return o ? e : c ? t.call(e) : a ? t(e[0], i) : s;
}
var rt = /^-ms-/,
lt = /-([a-z])/g;
function at(e, t) {
return t.toUpperCase();
}
function q(e) {
return e.replace(rt, "ms-").replace(lt, at);
}
function ct(e) {
return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
}
function dt() {
this.expando = k.expando + dt.uid++;
}
(dt.uid = 1),
(dt.prototype = {
cache: function (e) {
var t = e[this.expando];
return (
t ||
((t = {}),
ct(e) &&
(e.nodeType
? (e[this.expando] = t)
: Object.defineProperty(e, this.expando, {
value: t,
configurable: !0,
}))),
t
);
},
set: function (e, t, i) {
var n,
o = this.cache(e);
if ("string" == typeof t) o[q(t)] = i;
else for (n in t) o[q(n)] = t[n];
return o;
},
get: function (e, t) {
return void 0 === t
? this.cache(e)
: e[this.expando] && e[this.expando][q(t)];
},
access: function (e, t, i) {
return void 0 === t ||
(t && "string" == typeof t && void 0 === i)
? this.get(e, t)
: (this.set(e, t, i), void 0 !== i ? i : t);
},
remove: function (e, t) {
var i,
n = e[this.expando];
if (void 0 !== n) {
if (void 0 !== t) {
i = (t = Array.isArray(t)
? t.map(q)
: (t = q(t)) in n
? [t]
: t.match(D) || []).length;
for (; i--; ) delete n[t[i]];
}
(void 0 !== t && !k.isEmptyObject(n)) ||
(e.nodeType
? (e[this.expando] = void 0)
: delete e[this.expando]);
}
},
hasData: function (e) {
e = e[this.expando];
return void 0 !== e && !k.isEmptyObject(e);
},
});
var y = new dt(),
a = new dt(),
ut = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
pt = /[A-Z]/g;
function ht(e, t, i) {
var n, o;
if (void 0 === i && 1 === e.nodeType)
if (
((n = "data-" + t.replace(pt, "-$&").toLowerCase()),
"string" == typeof (i = e.getAttribute(n)))
) {
try {
i =
"true" === (o = i) ||
("false" !== o &&
("null" === o
? null
: o === +o + ""
? +o
: ut.test(o)
? JSON.parse(o)
: o));
} catch (e) {}
a.set(e, t, i);
} else i = void 0;
return i;
}
k.extend({
hasData: function (e) {
return a.hasData(e) || y.hasData(e);
},
data: function (e, t, i) {
return a.access(e, t, i);
},
removeData: function (e, t) {
a.remove(e, t);
},
_data: function (e, t, i) {
return y.access(e, t, i);
},
_removeData: function (e, t) {
y.remove(e, t);
},
}),
k.fn.extend({
data: function (i, e) {
var t,
n,
o,
s = this[0],
r = s && s.attributes;
if (void 0 !== i)
return "object" == typeof i
? this.each(function () {
a.set(this, i);
})
: d(
this,
function (e) {
var t;
if (s && void 0 === e)
return void 0 !== (t = a.get(s, i)) ||
void 0 !== (t = ht(s, i))
? t
: void 0;
this.each(function () {
a.set(this, i, e);
});
},
null,
e,
1 < arguments.length,
null,
!0
);
if (
this.length &&
((o = a.get(s)), 1 === s.nodeType) &&
!y.get(s, "hasDataAttrs")
) {
for (t = r.length; t--; )
r[t] &&
0 === (n = r[t].name).indexOf("data-") &&
((n = q(n.slice(5))), ht(s, n, o[n]));
y.set(s, "hasDataAttrs", !0);
}
return o;
},
removeData: function (e) {
return this.each(function () {
a.remove(this, e);
});
},
}),
k.extend({
queue: function (e, t, i) {
var n;
if (e)
return (
(n = y.get(e, (t = (t || "fx") + "queue"))),
i &&
(!n || Array.isArray(i)
? (n = y.access(e, t, k.makeArray(i)))
: n.push(i)),
n || []
);
},
dequeue: function (e, t) {
t = t || "fx";
var i = k.queue(e, t),
n = i.length,
o = i.shift(),
s = k._queueHooks(e, t);
"inprogress" === o && ((o = i.shift()), n--),
o &&
("fx" === t && i.unshift("inprogress"),
delete s.stop,
o.call(
e,
function () {
k.dequeue(e, t);
},
s
)),
!n && s && s.empty.fire();
},
_queueHooks: function (e, t) {
var i = t + "queueHooks";
return (
y.get(e, i) ||
y.access(e, i, {
empty: k.Callbacks("once memory").add(function () {
y.remove(e, [t + "queue", i]);
}),
})
);
},
}),
k.fn.extend({
queue: function (t, i) {
var e = 2;
return (
"string" != typeof t && ((i = t), (t = "fx"), e--),
arguments.length < e
? k.queue(this[0], t)
: void 0 === i
? this
: this.each(function () {
var e = k.queue(this, t, i);
k._queueHooks(this, t),
"fx" === t &&
"inprogress" !== e[0] &&
k.dequeue(this, t);
})
);
},
dequeue: function (e) {
return this.each(function () {
k.dequeue(this, e);
});
},
clearQueue: function (e) {
return this.queue(e || "fx", []);
},
promise: function (e, t) {
function i() {
--o || s.resolveWith(r, [r]);
}
var n,
o = 1,
s = k.Deferred(),
r = this,
l = this.length;
for (
"string" != typeof e && ((t = e), (e = void 0)),
e = e || "fx";
l--;
)
(n = y.get(r[l], e + "queueHooks")) &&
n.empty &&
(o++, n.empty.add(i));
return i(), s.promise(t);
},
});
function ft(e, t) {
return (
"none" === (e = t || e).style.display ||
("" === e.style.display &&
mt(e) &&
"none" === k.css(e, "display"))
);
}
var e = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
gt = new RegExp("^(?:([+-])=|)(" + e + ")([a-z%]*)$", "i"),
vt = ["Top", "Right", "Bottom", "Left"],
yt = T.documentElement,
mt = function (e) {
return k.contains(e.ownerDocument, e);
},
bt = { composed: !0 };
yt.getRootNode &&
(mt = function (e) {
return (
k.contains(e.ownerDocument, e) ||
e.getRootNode(bt) === e.ownerDocument
);
});
function xt(e, t, i, n) {
var o,
s,
r = 20,
l = n
? function () {
return n.cur();
}
: function () {
return k.css(e, t, "");
},
a = l(),
c = (i && i[3]) || (k.cssNumber[t] ? "" : "px"),
d =
e.nodeType &&
(k.cssNumber[t] || ("px" !== c && +a)) &&
gt.exec(k.css(e, t));
if (d && d[3] !== c) {
for (c = c || d[3], d = +(a /= 2) || 1; r--; )
k.style(e, t, d + c),
(1 - s) * (1 - (s = l() / a || 0.5)) <= 0 && (r = 0),
(d /= s);
k.style(e, t, (d *= 2) + c), (i = i || []);
}
return (
i &&
((d = +d || +a || 0),
(o = i[1] ? d + (i[1] + 1) * i[2] : +i[2]),
n) &&
((n.unit = c), (n.start = d), (n.end = o)),
o
);
}
var wt = {};
function St(e, t) {
for (var i, n, o, s, r, l = [], a = 0, c = e.length; a < c; a++)
(n = e[a]).style &&
((i = n.style.display),
t
? ("none" === i &&
((l[a] = y.get(n, "display") || null),
l[a] || (n.style.display = "")),
"" === n.style.display &&
ft(n) &&
(l[a] =
((r = s = void 0),
(s = (o = n).ownerDocument),
(r = wt[(o = o.nodeName)]) ||
((s = s.body.appendChild(s.createElement(o))),
(r = k.css(s, "display")),
s.parentNode.removeChild(s),
(wt[o] = r = "none" === r ? "block" : r)))))
: "none" !== i &&
((l[a] = "none"), y.set(n, "display", i)));
for (a = 0; a < c; a++)
null != l[a] && (e[a].style.display = l[a]);
return e;
}
k.fn.extend({
show: function () {
return St(this, !0);
},
hide: function () {
return St(this);
},
toggle: function (e) {
return "boolean" == typeof e
? e
? this.show()
: this.hide()
: this.each(function () {
ft(this) ? k(this).show() : k(this).hide();
});
},
});
var Tt = /^(?:checkbox|radio)$/i,
kt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
Ct = /^$|^module$|\/(?:java|ecma)script/i,
s = T.createDocumentFragment().appendChild(
T.createElement("div")
),
f =
((r = T.createElement("input")).setAttribute("type", "radio"),
r.setAttribute("checked", "checked"),
r.setAttribute("name", "t"),
s.appendChild(r),
(g.checkClone = s
.cloneNode(!0)
.cloneNode(!0).lastChild.checked),
(s.innerHTML = "<textarea>x</textarea>"),
(g.noCloneChecked = !!s.cloneNode(!0).lastChild.defaultValue),
(s.innerHTML = "<option></option>"),
(g.option = !!s.lastChild),
{
thead: [1, "<table>", "</table>"],
col: [2, "<table><colgroup>", "</colgroup></table>"],
tr: [2, "<table><tbody>", "</tbody></table>"],
td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
_default: [0, "", ""],
});
function v(e, t) {
var i =
void 0 !== e.getElementsByTagName
? e.getElementsByTagName(t || "*")
: void 0 !== e.querySelectorAll
? e.querySelectorAll(t || "*")
: [];
return void 0 === t || (t && x(e, t)) ? k.merge([e], i) : i;
}
function At(e, t) {
for (var i = 0, n = e.length; i < n; i++)
y.set(e[i], "globalEval", !t || y.get(t[i], "globalEval"));
}
(f.tbody = f.tfoot = f.colgroup = f.caption = f.thead),
(f.th = f.td),
g.option ||
(f.optgroup = f.option =
[1, "<select multiple='multiple'>", "</select>"]);
var Et = /<|&#?\w+;/;
function Lt(e, t, i, n, o) {
for (
var s,
r,
l,
a,
c,
d = t.createDocumentFragment(),
u = [],
p = 0,
h = e.length;
p < h;
p++
)
if ((s = e[p]) || 0 === s)
if ("object" === V(s)) k.merge(u, s.nodeType ? [s] : s);
else if (Et.test(s)) {
for (
r = r || d.appendChild(t.createElement("div")),
l = (kt.exec(s) || ["", ""])[1].toLowerCase(),
l = f[l] || f._default,
r.innerHTML = l[1] + k.htmlPrefilter(s) + l[2],
c = l[0];
c--;
)
r = r.lastChild;
k.merge(u, r.childNodes),
((r = d.firstChild).textContent = "");
} else u.push(t.createTextNode(s));
for (d.textContent = "", p = 0; (s = u[p++]); )
if (n && -1 < k.inArray(s, n)) o && o.push(s);
else if (
((a = mt(s)),
(r = v(d.appendChild(s), "script")),
a && At(r),
i)
)
for (c = 0; (s = r[c++]); )
Ct.test(s.type || "") && i.push(s);
return d;
}
var $t = /^([^.]*)(?:\.(.+)|)/;
function _t() {
return !0;
}
function Ot() {
return !1;
}
function Dt(e, t, i, n, o, s) {
var r, l;
if ("object" == typeof t) {
for (l in ("string" != typeof i &&
((n = n || i), (i = void 0)),
t))
Dt(e, l, i, n, t[l], s);
return e;
}
if (
(null == n && null == o
? ((o = i), (n = i = void 0))
: null == o &&
("string" == typeof i
? ((o = n), (n = void 0))
: ((o = n), (n = i), (i = void 0))),
!1 === o)
)
o = Ot;
else if (!o) return e;
return (
1 === s &&
((r = o),
((o = function (e) {
return k().off(e), r.apply(this, arguments);
}).guid = r.guid || (r.guid = k.guid++))),
e.each(function () {
k.event.add(this, t, o, n, i);
})
);
}
function qt(e, n, t) {
t
? (y.set(e, n, !1),
k.event.add(e, n, {
namespace: !1,
handler: function (e) {
var t,
i = y.get(this, n);
if (1 & e.isTrigger && this[n]) {
if (i)
(k.event.special[n] || {}).delegateType &&
e.stopPropagation();
else if (
((i = l.call(arguments)),
y.set(this, n, i),
this[n](),
(t = y.get(this, n)),
y.set(this, n, !1),
i !== t)
)
return (
e.stopImmediatePropagation(),
e.preventDefault(),
t
);
} else
i &&
(y.set(
this,
n,
k.event.trigger(i[0], i.slice(1), this)
),
e.stopPropagation(),
(e.isImmediatePropagationStopped = _t));
},
}))
: void 0 === y.get(e, n) && k.event.add(e, n, _t);
}
(k.event = {
global: {},
add: function (t, e, i, n, o) {
var s,
r,
l,
a,
c,
d,
u,
p,
h,
f = y.get(t);
if (ct(t))
for (
i.handler && ((i = (s = i).handler), (o = s.selector)),
o && k.find.matchesSelector(yt, o),
i.guid || (i.guid = k.guid++),
l = (l = f.events) || (f.events = Object.create(null)),
r =
(r = f.handle) ||
(f.handle = function (e) {
return void 0 !== k && k.event.triggered !== e.type
? k.event.dispatch.apply(t, arguments)
: void 0;
}),
a = (e = (e || "").match(D) || [""]).length;
a--;
)
(u = h = (p = $t.exec(e[a]) || [])[1]),
(p = (p[2] || "").split(".").sort()),
u &&
((c = k.event.special[u] || {}),
(u = (o ? c.delegateType : c.bindType) || u),
(c = k.event.special[u] || {}),
(h = k.extend(
{
type: u,
origType: h,
data: n,
handler: i,
guid: i.guid,
selector: o,
needsContext:
o && k.expr.match.needsContext.test(o),
namespace: p.join("."),
},
s
)),
(d = l[u]) ||
(((d = l[u] = []).delegateCount = 0),
c.setup && !1 !== c.setup.call(t, n, p, r)) ||
(t.addEventListener && t.addEventListener(u, r)),
c.add &&
(c.add.call(t, h),
h.handler.guid || (h.handler.guid = i.guid)),
o ? d.splice(d.delegateCount++, 0, h) : d.push(h),
(k.event.global[u] = !0));
},
remove: function (e, t, i, n, o) {
var s,
r,
l,
a,
c,
d,
u,
p,
h,
f,
g,
v = y.hasData(e) && y.get(e);
if (v && (a = v.events)) {
for (c = (t = (t || "").match(D) || [""]).length; c--; )
if (
((h = g = (l = $t.exec(t[c]) || [])[1]),
(f = (l[2] || "").split(".").sort()),
h)
) {
for (
u = k.event.special[h] || {},
p =
a[(h = (n ? u.delegateType : u.bindType) || h)] ||
[],
l =
l[2] &&
new RegExp(
"(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"
),
r = s = p.length;
s--;
)
(d = p[s]),
(!o && g !== d.origType) ||
(i && i.guid !== d.guid) ||
(l && !l.test(d.namespace)) ||
(n &&
n !== d.selector &&
("**" !== n || !d.selector)) ||
(p.splice(s, 1),
d.selector && p.delegateCount--,
u.remove && u.remove.call(e, d));
r &&
!p.length &&
((u.teardown &&
!1 !== u.teardown.call(e, f, v.handle)) ||
k.removeEvent(e, h, v.handle),
delete a[h]);
} else for (h in a) k.event.remove(e, h + t[c], i, n, !0);
k.isEmptyObject(a) && y.remove(e, "handle events");
}
},
dispatch: function (e) {
var t,
i,
n,
o,
s,
r = new Array(arguments.length),
l = k.event.fix(e),
e =
(y.get(this, "events") || Object.create(null))[l.type] ||
[],
a = k.event.special[l.type] || {};
for (r[0] = l, t = 1; t < arguments.length; t++)
r[t] = arguments[t];
if (
((l.delegateTarget = this),
!a.preDispatch || !1 !== a.preDispatch.call(this, l))
) {
for (
s = k.event.handlers.call(this, l, e), t = 0;
(n = s[t++]) && !l.isPropagationStopped();
)
for (
l.currentTarget = n.elem, i = 0;
(o = n.handlers[i++]) &&
!l.isImmediatePropagationStopped();
)
(l.rnamespace &&
!1 !== o.namespace &&
!l.rnamespace.test(o.namespace)) ||
((l.handleObj = o),
(l.data = o.data),
void 0 !==
(o = (
(k.event.special[o.origType] || {}).handle ||
o.handler
).apply(n.elem, r)) &&
!1 === (l.result = o) &&
(l.preventDefault(), l.stopPropagation()));
return (
a.postDispatch && a.postDispatch.call(this, l), l.result
);
}
},
handlers: function (e, t) {
var i,
n,
o,
s,
r,
l = [],
a = t.delegateCount,
c = e.target;
if (a && c.nodeType && !("click" === e.type && 1 <= e.button))
for (; c !== this; c = c.parentNode || this)
if (
1 === c.nodeType &&
("click" !== e.type || !0 !== c.disabled)
) {
for (s = [], r = {}, i = 0; i < a; i++)
void 0 === r[(o = (n = t[i]).selector + " ")] &&
(r[o] = n.needsContext
? -1 < k(o, this).index(c)
: k.find(o, this, null, [c]).length),
r[o] && s.push(n);
s.length && l.push({ elem: c, handlers: s });
}
return (
(c = this),
a < t.length && l.push({ elem: c, handlers: t.slice(a) }),
l
);
},
addProp: function (t, e) {
Object.defineProperty(k.Event.prototype, t, {
enumerable: !0,
configurable: !0,
get: m(e)
? function () {
if (this.originalEvent) return e(this.originalEvent);
}
: function () {
if (this.originalEvent) return this.originalEvent[t];
},
set: function (e) {
Object.defineProperty(this, t, {
enumerable: !0,
configurable: !0,
writable: !0,
value: e,
});
},
});
},
fix: function (e) {
return e[k.expando] ? e : new k.Event(e);
},
special: {
load: { noBubble: !0 },
click: {
setup: function (e) {
e = this || e;
return (
Tt.test(e.type) &&
e.click &&
x(e, "input") &&
qt(e, "click", !0),
!1
);
},
trigger: function (e) {
e = this || e;
return (
Tt.test(e.type) &&
e.click &&
x(e, "input") &&
qt(e, "click"),
!0
);
},
_default: function (e) {
e = e.target;
return (
(Tt.test(e.type) &&
e.click &&
x(e, "input") &&
y.get(e, "click")) ||
x(e, "a")
);
},
},
beforeunload: {
postDispatch: function (e) {
void 0 !== e.result &&
e.originalEvent &&
(e.originalEvent.returnValue = e.result);
},
},
},
}),
(k.removeEvent = function (e, t, i) {
e.removeEventListener && e.removeEventListener(t, i);
}),
(k.Event = function (e, t) {
if (!(this instanceof k.Event)) return new k.Event(e, t);
e && e.type
? ((this.originalEvent = e),
(this.type = e.type),
(this.isDefaultPrevented =
e.defaultPrevented ||
(void 0 === e.defaultPrevented && !1 === e.returnValue)
? _t
: Ot),
(this.target =
e.target && 3 === e.target.nodeType
? e.target.parentNode
: e.target),
(this.currentTarget = e.currentTarget),
(this.relatedTarget = e.relatedTarget))
: (this.type = e),
t && k.extend(this, t),
(this.timeStamp = (e && e.timeStamp) || Date.now()),
(this[k.expando] = !0);
}),
(k.Event.prototype = {
constructor: k.Event,
isDefaultPrevented: Ot,
isPropagationStopped: Ot,
isImmediatePropagationStopped: Ot,
isSimulated: !1,
preventDefault: function () {
var e = this.originalEvent;
(this.isDefaultPrevented = _t),
e && !this.isSimulated && e.preventDefault();
},
stopPropagation: function () {
var e = this.originalEvent;
(this.isPropagationStopped = _t),
e && !this.isSimulated && e.stopPropagation();
},
stopImmediatePropagation: function () {
var e = this.originalEvent;
(this.isImmediatePropagationStopped = _t),
e && !this.isSimulated && e.stopImmediatePropagation(),
this.stopPropagation();
},
}),
k.each(
{
altKey: !0,
bubbles: !0,
cancelable: !0,
changedTouches: !0,
ctrlKey: !0,
detail: !0,
eventPhase: !0,
metaKey: !0,
pageX: !0,
pageY: !0,
shiftKey: !0,
view: !0,
char: !0,
code: !0,
charCode: !0,
key: !0,
keyCode: !0,
button: !0,
buttons: !0,
clientX: !0,
clientY: !0,
offsetX: !0,
offsetY: !0,
pointerId: !0,
pointerType: !0,
screenX: !0,
screenY: !0,
targetTouches: !0,
toElement: !0,
touches: !0,
which: !0,
},
k.event.addProp
),
k.each({ focus: "focusin", blur: "focusout" }, function (n, o) {
function s(e) {
var t, i;
T.documentMode
? ((t = y.get(this, "handle")),
((i = k.event.fix(e)).type =
"focusin" === e.type ? "focus" : "blur"),
(i.isSimulated = !0),
t(e),
i.target === i.currentTarget && t(i))
: k.event.simulate(o, e.target, k.event.fix(e));
}
(k.event.special[n] = {
setup: function () {
var e;
if ((qt(this, n, !0), !T.documentMode)) return !1;
(e = y.get(this, o)) || this.addEventListener(o, s),
y.set(this, o, (e || 0) + 1);
},
trigger: function () {
return qt(this, n), !0;
},
teardown: function () {
var e;
if (!T.documentMode) return !1;
(e = y.get(this, o) - 1)
? y.set(this, o, e)
: (this.removeEventListener(o, s), y.remove(this, o));
},
_default: function (e) {
return y.get(e.target, n);
},
delegateType: o,
}),
(k.event.special[o] = {
setup: function () {
var e = this.ownerDocument || this.document || this,
t = T.documentMode ? this : e,
i = y.get(t, o);
i ||
(T.documentMode
? this.addEventListener(o, s)
: e.addEventListener(n, s, !0)),
y.set(t, o, (i || 0) + 1);
},
teardown: function () {
var e = this.ownerDocument || this.document || this,
t = T.documentMode ? this : e,
i = y.get(t, o) - 1;
i
? y.set(t, o, i)
: (T.documentMode
? this.removeEventListener(o, s)
: e.removeEventListener(n, s, !0),
y.remove(t, o));
},
});
}),
k.each(
{
mouseenter: "mouseover",
mouseleave: "mouseout",
pointerenter: "pointerover",
pointerleave: "pointerout",
},
function (e, o) {
k.event.special[e] = {
delegateType: o,
bindType: o,
handle: function (e) {
var t,
i = e.relatedTarget,
n = e.handleObj;
return (
(i && (i === this || k.contains(this, i))) ||
((e.type = n.origType),
(t = n.handler.apply(this, arguments)),
(e.type = o)),
t
);
},
};
}
),
k.fn.extend({
on: function (e, t, i, n) {
return Dt(this, e, t, i, n);
},
one: function (e, t, i, n) {
return Dt(this, e, t, i, n, 1);
},
off: function (e, t, i) {
var n, o;
if (e && e.preventDefault && e.handleObj)
(n = e.handleObj),
k(e.delegateTarget).off(
n.namespace
? n.origType + "." + n.namespace
: n.origType,
n.selector,
n.handler
);
else {
if ("object" != typeof e)
return (
(!1 !== t && "function" != typeof t) ||
((i = t), (t = void 0)),
!1 === i && (i = Ot),
this.each(function () {
k.event.remove(this, e, i, t);
})
);
for (o in e) this.off(o, t, e[o]);
}
return this;
},
});
var Pt = /<script|<style|<link/i,
Nt = /checked\s*(?:[^=]|=\s*.checked.)/i,
jt = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
function Ht(e, t) {
return (
(x(e, "table") &&
x(11 !== t.nodeType ? t : t.firstChild, "tr") &&
k(e).children("tbody")[0]) ||
e
);
}
function Mt(e) {
return (
(e.type = (null !== e.getAttribute("type")) + "/" + e.type), e
);
}
function It(e) {
return (
"true/" === (e.type || "").slice(0, 5)
? (e.type = e.type.slice(5))
: e.removeAttribute("type"),
e
);
}
function zt(e, t) {
var i, n, o, s;
if (1 === t.nodeType) {
if (y.hasData(e) && (s = y.get(e).events))
for (o in (y.remove(t, "handle events"), s))
for (i = 0, n = s[o].length; i < n; i++)
k.event.add(t, o, s[o][i]);
a.hasData(e) &&
((e = a.access(e)), (e = k.extend({}, e)), a.set(t, e));
}
}
function Wt(i, n, o, s) {
n = I(n);
var e,
t,
r,
l,
a,
c,
d = 0,
u = i.length,
p = u - 1,
h = n[0],
f = m(h);
if (
f ||
(1 < u && "string" == typeof h && !g.checkClone && Nt.test(h))
)
return i.each(function (e) {
var t = i.eq(e);
f && (n[0] = h.call(this, e, t.html())), Wt(t, n, o, s);
});
if (
u &&
((t = (e = Lt(n, i[0].ownerDocument, !1, i, s)).firstChild),
1 === e.childNodes.length && (e = t),
t || s)
) {
for (l = (r = k.map(v(e, "script"), Mt)).length; d < u; d++)
(a = e),
d !== p &&
((a = k.clone(a, !0, !0)), l) &&
k.merge(r, v(a, "script")),
o.call(i[d], a, d);
if (l)
for (
c = r[r.length - 1].ownerDocument, k.map(r, It), d = 0;
d < l;
d++
)
(a = r[d]),
Ct.test(a.type || "") &&
!y.access(a, "globalEval") &&
k.contains(c, a) &&
(a.src && "module" !== (a.type || "").toLowerCase()
? k._evalUrl &&
!a.noModule &&
k._evalUrl(
a.src,
{ nonce: a.nonce || a.getAttribute("nonce") },
c
)
: U(a.textContent.replace(jt, ""), a, c));
}
return i;
}
function Xt(e, t, i) {
for (
var n, o = t ? k.filter(t, e) : e, s = 0;
null != (n = o[s]);
s++
)
i || 1 !== n.nodeType || k.cleanData(v(n)),
n.parentNode &&
(i && mt(n) && At(v(n, "script")),
n.parentNode.removeChild(n));
return e;
}
k.extend({
htmlPrefilter: function (e) {
return e;
},
clone: function (e, t, i) {
var n,
o,
s,
r,
l,
a,
c,
d = e.cloneNode(!0),
u = mt(e);
if (
!(
g.noCloneChecked ||
(1 !== e.nodeType && 11 !== e.nodeType) ||
k.isXMLDoc(e)
)
)
for (r = v(d), n = 0, o = (s = v(e)).length; n < o; n++)
(l = s[n]),
(a = r[n]),
(c = void 0),
"input" === (c = a.nodeName.toLowerCase()) &&
Tt.test(l.type)
? (a.checked = l.checked)
: ("input" !== c && "textarea" !== c) ||
(a.defaultValue = l.defaultValue);
if (t)
if (i)
for (
s = s || v(e), r = r || v(d), n = 0, o = s.length;
n < o;
n++
)
zt(s[n], r[n]);
else zt(e, d);
return (
0 < (r = v(d, "script")).length &&
At(r, !u && v(e, "script")),
d
);
},
cleanData: function (e) {
for (
var t, i, n, o = k.event.special, s = 0;
void 0 !== (i = e[s]);
s++
)
if (ct(i)) {
if ((t = i[y.expando])) {
if (t.events)
for (n in t.events)
o[n]
? k.event.remove(i, n)
: k.removeEvent(i, n, t.handle);
i[y.expando] = void 0;
}
i[a.expando] && (i[a.expando] = void 0);
}
},
}),
k.fn.extend({
detach: function (e) {
return Xt(this, e, !0);
},
remove: function (e) {
return Xt(this, e);
},
text: function (e) {
return d(
this,
function (e) {
return void 0 === e
? k.text(this)
: this.empty().each(function () {
(1 !== this.nodeType &&
11 !== this.nodeType &&
9 !== this.nodeType) ||
(this.textContent = e);
});
},
null,
e,
arguments.length
);
},
append: function () {
return Wt(this, arguments, function (e) {
(1 !== this.nodeType &&
11 !== this.nodeType &&
9 !== this.nodeType) ||
Ht(this, e).appendChild(e);
});
},
prepend: function () {
return Wt(this, arguments, function (e) {
var t;
(1 !== this.nodeType &&
11 !== this.nodeType &&
9 !== this.nodeType) ||
(t = Ht(this, e)).insertBefore(e, t.firstChild);
});
},
before: function () {
return Wt(this, arguments, function (e) {
this.parentNode && this.parentNode.insertBefore(e, this);
});
},
after: function () {
return Wt(this, arguments, function (e) {
this.parentNode &&
this.parentNode.insertBefore(e, this.nextSibling);
});
},
empty: function () {
for (var e, t = 0; null != (e = this[t]); t++)
1 === e.nodeType &&
(k.cleanData(v(e, !1)), (e.textContent = ""));
return this;
},
clone: function (e, t) {
return (
(e = null != e && e),
(t = null == t ? e : t),
this.map(function () {
return k.clone(this, e, t);
})
);
},
html: function (e) {
return d(
this,
function (e) {
var t = this[0] || {},
i = 0,
n = this.length;
if (void 0 === e && 1 === t.nodeType)
return t.innerHTML;
if (
"string" == typeof e &&
!Pt.test(e) &&
!f[(kt.exec(e) || ["", ""])[1].toLowerCase()]
) {
e = k.htmlPrefilter(e);
try {
for (; i < n; i++)
1 === (t = this[i] || {}).nodeType &&
(k.cleanData(v(t, !1)), (t.innerHTML = e));
t = 0;
} catch (e) {}
}
t && this.empty().append(e);
},
null,
e,
arguments.length
);
},
replaceWith: function () {
var i = [];
return Wt(
this,
arguments,
function (e) {
var t = this.parentNode;
k.inArray(this, i) < 0 &&
(k.cleanData(v(this)), t) &&
t.replaceChild(e, this);
},
i
);
},
}),
k.each(
{
appendTo: "append",
prependTo: "prepend",
insertBefore: "before",
insertAfter: "after",
replaceAll: "replaceWith",
},
function (e, r) {
k.fn[e] = function (e) {
for (
var t, i = [], n = k(e), o = n.length - 1, s = 0;
s <= o;
s++
)
(t = s === o ? this : this.clone(!0)),
k(n[s])[r](t),
z.apply(i, t.get());
return this.pushStack(i);
};
}
);
function Rt(e) {
var t = e.ownerDocument.defaultView;
return (t = t && t.opener ? t : S).getComputedStyle(e);
}
function Bt(e, t, i) {
var n,
o = {};
for (n in t) (o[n] = e.style[n]), (e.style[n] = t[n]);
for (n in ((i = i.call(e)), t)) e.style[n] = o[n];
return i;
}
var Yt,
Ft,
Ut,
Vt,
Gt,
Zt,
Qt,
c,
Jt = new RegExp("^(" + e + ")(?!px)[a-z%]+$", "i"),
Kt = /^--/,
ei = new RegExp(vt.join("|"), "i");
function ti(e, t, i) {
var n,
o = Kt.test(t),
s = e.style;
return (
(i = i || Rt(e)) &&
((n = i.getPropertyValue(t) || i[t]),
"" !== (n = o ? n && (n.replace(ee, "$1") || void 0) : n) ||
mt(e) ||
(n = k.style(e, t)),
!g.pixelBoxStyles()) &&
Jt.test(n) &&
ei.test(t) &&
((o = s.width),
(e = s.minWidth),
(t = s.maxWidth),
(s.minWidth = s.maxWidth = s.width = n),
(n = i.width),
(s.width = o),
(s.minWidth = e),
(s.maxWidth = t)),
void 0 !== n ? n + "" : n
);
}
function ii(e, t) {
return {
get: function () {
if (!e()) return (this.get = t).apply(this, arguments);
delete this.get;
},
};
}
function ni() {
var e;
c &&
((Qt.style.cssText =
"position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
(c.style.cssText =
"position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
yt.appendChild(Qt).appendChild(c),
(e = S.getComputedStyle(c)),
(Yt = "1%" !== e.top),
(Zt = 12 === oi(e.marginLeft)),
(c.style.right = "60%"),
(Vt = 36 === oi(e.right)),
(Ft = 36 === oi(e.width)),
(c.style.position = "absolute"),
(Ut = 12 === oi(c.offsetWidth / 3)),
yt.removeChild(Qt),
(c = null));
}
function oi(e) {
return Math.round(parseFloat(e));
}
(Qt = T.createElement("div")),
(c = T.createElement("div")).style &&
((c.style.backgroundClip = "content-box"),
(c.cloneNode(!0).style.backgroundClip = ""),
(g.clearCloneStyle =
"content-box" === c.style.backgroundClip),
k.extend(g, {
boxSizingReliable: function () {
return ni(), Ft;
},
pixelBoxStyles: function () {
return ni(), Vt;
},
pixelPosition: function () {
return ni(), Yt;
},
reliableMarginLeft: function () {
return ni(), Zt;
},
scrollboxSize: function () {
return ni(), Ut;
},
reliableTrDimensions: function () {
var e, t, i;
return (
null == Gt &&
((e = T.createElement("table")),
(t = T.createElement("tr")),
(i = T.createElement("div")),
(e.style.cssText =
"position:absolute;left:-11111px;border-collapse:separate"),
(t.style.cssText =
"box-sizing:content-box;border:1px solid"),
(t.style.height = "1px"),
(i.style.height = "9px"),
(i.style.display = "block"),
yt.appendChild(e).appendChild(t).appendChild(i),
(i = S.getComputedStyle(t)),
(Gt =
parseInt(i.height, 10) +
parseInt(i.borderTopWidth, 10) +
parseInt(i.borderBottomWidth, 10) ===
t.offsetHeight),
yt.removeChild(e)),
Gt
);
},
}));
var si = ["Webkit", "Moz", "ms"],
ri = T.createElement("div").style,
li = {};
function ai(e) {
return (
k.cssProps[e] ||
li[e] ||
(e in ri
? e
: (li[e] =
(function (e) {
for (
var t = e[0].toUpperCase() + e.slice(1),
i = si.length;
i--;
)
if ((e = si[i] + t) in ri) return e;
})(e) || e))
);
}
var ci = /^(none|table(?!-c[ea]).+)/,
di = {
position: "absolute",
visibility: "hidden",
display: "block",
},
ui = { letterSpacing: "0", fontWeight: "400" };
function pi(e, t, i) {
var n = gt.exec(t);
return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t;
}
function hi(e, t, i, n, o, s) {
var r = "width" === t ? 1 : 0,
l = 0,
a = 0,
c = 0;
if (i === (n ? "border" : "content")) return 0;
for (; r < 4; r += 2)
"margin" === i && (c += k.css(e, i + vt[r], !0, o)),
n
? ("content" === i &&
(a -= k.css(e, "padding" + vt[r], !0, o)),
"margin" !== i &&
(a -= k.css(e, "border" + vt[r] + "Width", !0, o)))
: ((a += k.css(e, "padding" + vt[r], !0, o)),
"padding" !== i
? (a += k.css(e, "border" + vt[r] + "Width", !0, o))
: (l += k.css(e, "border" + vt[r] + "Width", !0, o)));
return (
!n &&
0 <= s &&
(a +=
Math.max(
0,
Math.ceil(
e["offset" + t[0].toUpperCase() + t.slice(1)] -
s -
a -
l -
0.5
)
) || 0),
a + c
);
}
function fi(e, t, i) {
var n = Rt(e),
o =
(!g.boxSizingReliable() || i) &&
"border-box" === k.css(e, "boxSizing", !1, n),
s = o,
r = ti(e, t, n),
l = "offset" + t[0].toUpperCase() + t.slice(1);
if (Jt.test(r)) {
if (!i) return r;
r = "auto";
}
return (
((!g.boxSizingReliable() && o) ||
(!g.reliableTrDimensions() && x(e, "tr")) ||
"auto" === r ||
(!parseFloat(r) &&
"inline" === k.css(e, "display", !1, n))) &&
e.getClientRects().length &&
((o = "border-box" === k.css(e, "boxSizing", !1, n)),
(s = l in e)) &&
(r = e[l]),
(r = parseFloat(r) || 0) +
hi(e, t, i || (o ? "border" : "content"), s, n, r) +
"px"
);
}
function P(e, t, i, n, o) {
return new P.prototype.init(e, t, i, n, o);
}
k.extend({
cssHooks: {
opacity: {
get: function (e, t) {
if (t) return "" === (t = ti(e, "opacity")) ? "1" : t;
},
},
},
cssNumber: {
animationIterationCount: !0,
aspectRatio: !0,
borderImageSlice: !0,
columnCount: !0,
flexGrow: !0,
flexShrink: !0,
fontWeight: !0,
gridArea: !0,
gridColumn: !0,
gridColumnEnd: !0,
gridColumnStart: !0,
gridRow: !0,
gridRowEnd: !0,
gridRowStart: !0,
lineHeight: !0,
opacity: !0,
order: !0,
orphans: !0,
scale: !0,
widows: !0,
zIndex: !0,
zoom: !0,
fillOpacity: !0,
floodOpacity: !0,
stopOpacity: !0,
strokeMiterlimit: !0,
strokeOpacity: !0,
},
cssProps: {},
style: function (e, t, i, n) {
if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
var o,
s,
r,
l = q(t),
a = Kt.test(t),
c = e.style;
if (
(a || (t = ai(l)),
(r = k.cssHooks[t] || k.cssHooks[l]),
void 0 === i)
)
return r && "get" in r && void 0 !== (o = r.get(e, !1, n))
? o
: c[t];
"string" == (s = typeof i) &&
(o = gt.exec(i)) &&
o[1] &&
((i = xt(e, t, o)), (s = "number")),
null != i &&
i == i &&
("number" !== s ||
a ||
(i += (o && o[3]) || (k.cssNumber[l] ? "" : "px")),
g.clearCloneStyle ||
"" !== i ||
0 !== t.indexOf("background") ||
(c[t] = "inherit"),
(r && "set" in r && void 0 === (i = r.set(e, i, n))) ||
(a ? c.setProperty(t, i) : (c[t] = i)));
}
},
css: function (e, t, i, n) {
var o,
s = q(t);
return (
Kt.test(t) || (t = ai(s)),
"normal" ===
(o =
void 0 ===
(o =
(s = k.cssHooks[t] || k.cssHooks[s]) && "get" in s
? s.get(e, !0, i)
: o)
? ti(e, t, n)
: o) &&
t in ui &&
(o = ui[t]),
("" === i || i) &&
((s = parseFloat(o)), !0 === i || isFinite(s))
? s || 0
: o
);
},
}),
k.each(["height", "width"], function (e, r) {
k.cssHooks[r] = {
get: function (e, t, i) {
if (t)
return !ci.test(k.css(e, "display")) ||
(e.getClientRects().length &&
e.getBoundingClientRect().width)
? fi(e, r, i)
: Bt(e, di, function () {
return fi(e, r, i);
});
},
set: function (e, t, i) {
var n = Rt(e),
o = !g.scrollboxSize() && "absolute" === n.position,
s =
(o || i) &&
"border-box" === k.css(e, "boxSizing", !1, n),
i = i ? hi(e, r, i, s, n) : 0;
return (
s &&
o &&
(i -= Math.ceil(
e["offset" + r[0].toUpperCase() + r.slice(1)] -
parseFloat(n[r]) -
hi(e, r, "border", !1, n) -
0.5
)),
i &&
(s = gt.exec(t)) &&
"px" !== (s[3] || "px") &&
((e.style[r] = t), (t = k.css(e, r))),
pi(0, t, i)
);
},
};
}),
(k.cssHooks.marginLeft = ii(
g.reliableMarginLeft,
function (e, t) {
if (t)
return (
(parseFloat(ti(e, "marginLeft")) ||
e.getBoundingClientRect().left -
Bt(e, { marginLeft: 0 }, function () {
return e.getBoundingClientRect().left;
})) + "px"
);
}
)),
k.each(
{ margin: "", padding: "", border: "Width" },
function (o, s) {
(k.cssHooks[o + s] = {
expand: function (e) {
for (
var t = 0,
i = {},
n = "string" == typeof e ? e.split(" ") : [e];
t < 4;
t++
)
i[o + vt[t] + s] = n[t] || n[t - 2] || n[0];
return i;
},
}),
"margin" !== o && (k.cssHooks[o + s].set = pi);
}
),
k.fn.extend({
css: function (e, t) {
return d(
this,
function (e, t, i) {
var n,
o,
s = {},
r = 0;
if (Array.isArray(t)) {
for (n = Rt(e), o = t.length; r < o; r++)
s[t[r]] = k.css(e, t[r], !1, n);
return s;
}
return void 0 !== i ? k.style(e, t, i) : k.css(e, t);
},
e,
t,
1 < arguments.length
);
},
}),
(((k.Tween = P).prototype = {
constructor: P,
init: function (e, t, i, n, o, s) {
(this.elem = e),
(this.prop = i),
(this.easing = o || k.easing._default),
(this.options = t),
(this.start = this.now = this.cur()),
(this.end = n),
(this.unit = s || (k.cssNumber[i] ? "" : "px"));
},
cur: function () {
var e = P.propHooks[this.prop];
return (e && e.get ? e : P.propHooks._default).get(this);
},
run: function (e) {
var t,
i = P.propHooks[this.prop];
return (
this.options.duration
? (this.pos = t =
k.easing[this.easing](
e,
this.options.duration * e,
0,
1,
this.options.duration
))
: (this.pos = t = e),
(this.now = (this.end - this.start) * t + this.start),
this.options.step &&
this.options.step.call(this.elem, this.now, this),
(i && i.set ? i : P.propHooks._default).set(this),
this
);
},
}).init.prototype = P.prototype),
((P.propHooks = {
_default: {
get: function (e) {
return 1 !== e.elem.nodeType ||
(null != e.elem[e.prop] && null == e.elem.style[e.prop])
? e.elem[e.prop]
: (e = k.css(e.elem, e.prop, "")) && "auto" !== e
? e
: 0;
},
set: function (e) {
k.fx.step[e.prop]
? k.fx.step[e.prop](e)
: 1 !== e.elem.nodeType ||
(!k.cssHooks[e.prop] &&
null == e.elem.style[ai(e.prop)])
? (e.elem[e.prop] = e.now)
: k.style(e.elem, e.prop, e.now + e.unit);
},
},
}).scrollTop = P.propHooks.scrollLeft =
{
set: function (e) {
e.elem.nodeType &&
e.elem.parentNode &&
(e.elem[e.prop] = e.now);
},
}),
(k.easing = {
linear: function (e) {
return e;
},
swing: function (e) {
return 0.5 - Math.cos(e * Math.PI) / 2;
},
_default: "swing",
}),
(k.fx = P.prototype.init),
(k.fx.step = {});
var gi,
vi,
yi = /^(?:toggle|show|hide)$/,
mi = /queueHooks$/;
function bi() {
vi &&
(!1 === T.hidden && S.requestAnimationFrame
? S.requestAnimationFrame(bi)
: S.setTimeout(bi, k.fx.interval),
k.fx.tick());
}
function xi() {
return (
S.setTimeout(function () {
gi = void 0;
}),
(gi = Date.now())
);
}
function wi(e, t) {
var i,
n = 0,
o = { height: e };
for (t = t ? 1 : 0; n < 4; n += 2 - t)
o["margin" + (i = vt[n])] = o["padding" + i] = e;
return t && (o.opacity = o.width = e), o;
}
function Si(e, t, i) {
for (
var n,
o = (N.tweeners[t] || []).concat(N.tweeners["*"]),
s = 0,
r = o.length;
s < r;
s++
)
if ((n = o[s].call(i, t, e))) return n;
}
function N(o, e, t) {
var i,
s,
n,
r,
l,
a,
c,
d = 0,
u = N.prefilters.length,
p = k.Deferred().always(function () {
delete h.elem;
}),
h = function () {
if (s) return !1;
for (
var e = gi || xi(),
e = Math.max(0, f.startTime + f.duration - e),
t = 1 - (e / f.duration || 0),
i = 0,
n = f.tweens.length;
i < n;
i++
)
f.tweens[i].run(t);
return (
p.notifyWith(o, [f, t, e]),
t < 1 && n
? e
: (n || p.notifyWith(o, [f, 1, 0]),
p.resolveWith(o, [f]),
!1)
);
},
f = p.promise({
elem: o,
props: k.extend({}, e),
opts: k.extend(
!0,
{ specialEasing: {}, easing: k.easing._default },
t
),
originalProperties: e,
originalOptions: t,
startTime: gi || xi(),
duration: t.duration,
tweens: [],
createTween: function (e, t) {
t = k.Tween(
o,
f.opts,
e,
t,
f.opts.specialEasing[e] || f.opts.easing
);
return f.tweens.push(t), t;
},
stop: function (e) {
var t = 0,
i = e ? f.tweens.length : 0;
if (!s) {
for (s = !0; t < i; t++) f.tweens[t].run(1);
e
? (p.notifyWith(o, [f, 1, 0]),
p.resolveWith(o, [f, e]))
: p.rejectWith(o, [f, e]);
}
return this;
},
}),
g = f.props,
v = g,
y = f.opts.specialEasing;
for (n in v)
if (
((l = y[(r = q(n))]),
(a = v[n]),
Array.isArray(a) && ((l = a[1]), (a = v[n] = a[0])),
n !== r && ((v[r] = a), delete v[n]),
(c = k.cssHooks[r]) && "expand" in c)
)
for (n in ((a = c.expand(a)), delete v[r], a))
n in v || ((v[n] = a[n]), (y[n] = l));
else y[r] = l;
for (; d < u; d++)
if ((i = N.prefilters[d].call(f, o, g, f.opts)))
return (
m(i.stop) &&
(k._queueHooks(f.elem, f.opts.queue).stop =
i.stop.bind(i)),
i
);
return (
k.map(g, Si, f),
m(f.opts.start) && f.opts.start.call(o, f),
f
.progress(f.opts.progress)
.done(f.opts.done, f.opts.complete)
.fail(f.opts.fail)
.always(f.opts.always),
k.fx.timer(
k.extend(h, { elem: o, anim: f, queue: f.opts.queue })
),
f
);
}
(k.Animation = k.extend(N, {
tweeners: {
"*": [
function (e, t) {
var i = this.createTween(e, t);
return xt(i.elem, e, gt.exec(t), i), i;
},
],
},
tweener: function (e, t) {
for (
var i,
n = 0,
o = (e = m(e) ? ((t = e), ["*"]) : e.match(D)).length;
n < o;
n++
)
(i = e[n]),
(N.tweeners[i] = N.tweeners[i] || []),
N.tweeners[i].unshift(t);
},
prefilters: [
function (e, t, i) {
var n,
o,
s,
r,
l,
a,
c,
d = "width" in t || "height" in t,
u = this,
p = {},
h = e.style,
f = e.nodeType && ft(e),
g = y.get(e, "fxshow");
for (n in (i.queue ||
(null == (r = k._queueHooks(e, "fx")).unqueued &&
((r.unqueued = 0),
(l = r.empty.fire),
(r.empty.fire = function () {
r.unqueued || l();
})),
r.unqueued++,
u.always(function () {
u.always(function () {
r.unqueued--,
k.queue(e, "fx").length || r.empty.fire();
});
})),
t))
if (((o = t[n]), yi.test(o))) {
if (
(delete t[n],
(s = s || "toggle" === o),
o === (f ? "hide" : "show"))
) {
if ("show" !== o || !g || void 0 === g[n]) continue;
f = !0;
}
p[n] = (g && g[n]) || k.style(e, n);
}
if ((a = !k.isEmptyObject(t)) || !k.isEmptyObject(p))
for (n in (d &&
1 === e.nodeType &&
((i.overflow = [h.overflow, h.overflowX, h.overflowY]),
null == (c = g && g.display) &&
(c = y.get(e, "display")),
"none" === (d = k.css(e, "display")) &&
(c
? (d = c)
: (St([e], !0),
(c = e.style.display || c),
(d = k.css(e, "display")),
St([e]))),
"inline" === d ||
("inline-block" === d && null != c)) &&
"none" === k.css(e, "float") &&
(a ||
(u.done(function () {
h.display = c;
}),
null == c &&
((d = h.display), (c = "none" === d ? "" : d))),
(h.display = "inline-block")),
i.overflow &&
((h.overflow = "hidden"),
u.always(function () {
(h.overflow = i.overflow[0]),
(h.overflowX = i.overflow[1]),
(h.overflowY = i.overflow[2]);
})),
(a = !1),
p))
a ||
(g
? "hidden" in g && (f = g.hidden)
: (g = y.access(e, "fxshow", { display: c })),
s && (g.hidden = !f),
f && St([e], !0),
u.done(function () {
for (n in (f || St([e]), y.remove(e, "fxshow"), p))
k.style(e, n, p[n]);
})),
(a = Si(f ? g[n] : 0, n, u)),
n in g ||
((g[n] = a.start),
f && ((a.end = a.start), (a.start = 0)));
},
],
prefilter: function (e, t) {
t ? N.prefilters.unshift(e) : N.prefilters.push(e);
},
})),
(k.speed = function (e, t, i) {
var n =
e && "object" == typeof e
? k.extend({}, e)
: {
complete: i || (!i && t) || (m(e) && e),
duration: e,
easing: (i && t) || (t && !m(t) && t),
};
return (
k.fx.off
? (n.duration = 0)
: "number" != typeof n.duration &&
(n.duration in k.fx.speeds
? (n.duration = k.fx.speeds[n.duration])
: (n.duration = k.fx.speeds._default)),
(null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
(n.old = n.complete),
(n.complete = function () {
m(n.old) && n.old.call(this),
n.queue && k.dequeue(this, n.queue);
}),
n
);
}),
k.fn.extend({
fadeTo: function (e, t, i, n) {
return this.filter(ft)
.css("opacity", 0)
.show()
.end()
.animate({ opacity: t }, e, i, n);
},
animate: function (t, e, i, n) {
function o() {
var e = N(this, k.extend({}, t), r);
(s || y.get(this, "finish")) && e.stop(!0);
}
var s = k.isEmptyObject(t),
r = k.speed(e, i, n);
return (
(o.finish = o),
s || !1 === r.queue
? this.each(o)
: this.queue(r.queue, o)
);
},
stop: function (o, e, s) {
function r(e) {
var t = e.stop;
delete e.stop, t(s);
}
return (
"string" != typeof o && ((s = e), (e = o), (o = void 0)),
e && this.queue(o || "fx", []),
this.each(function () {
var e = !0,
t = null != o && o + "queueHooks",
i = k.timers,
n = y.get(this);
if (t) n[t] && n[t].stop && r(n[t]);
else
for (t in n)
n[t] && n[t].stop && mi.test(t) && r(n[t]);
for (t = i.length; t--; )
i[t].elem !== this ||
(null != o && i[t].queue !== o) ||
(i[t].anim.stop(s), (e = !1), i.splice(t, 1));
(!e && s) || k.dequeue(this, o);
})
);
},
finish: function (r) {
return (
!1 !== r && (r = r || "fx"),
this.each(function () {
var e,
t = y.get(this),
i = t[r + "queue"],
n = t[r + "queueHooks"],
o = k.timers,
s = i ? i.length : 0;
for (
t.finish = !0,
k.queue(this, r, []),
n && n.stop && n.stop.call(this, !0),
e = o.length;
e--;
)
o[e].elem === this &&
o[e].queue === r &&
(o[e].anim.stop(!0), o.splice(e, 1));
for (e = 0; e < s; e++)
i[e] && i[e].finish && i[e].finish.call(this);
delete t.finish;
})
);
},
}),
k.each(["toggle", "show", "hide"], function (e, n) {
var o = k.fn[n];
k.fn[n] = function (e, t, i) {
return null == e || "boolean" == typeof e
? o.apply(this, arguments)
: this.animate(wi(n, !0), e, t, i);
};
}),
k.each(
{
slideDown: wi("show"),
slideUp: wi("hide"),
slideToggle: wi("toggle"),
fadeIn: { opacity: "show" },
fadeOut: { opacity: "hide" },
fadeToggle: { opacity: "toggle" },
},
function (e, n) {
k.fn[e] = function (e, t, i) {
return this.animate(n, e, t, i);
};
}
),
(k.timers = []),
(k.fx.tick = function () {
var e,
t = 0,
i = k.timers;
for (gi = Date.now(); t < i.length; t++)
(e = i[t])() || i[t] !== e || i.splice(t--, 1);
i.length || k.fx.stop(), (gi = void 0);
}),
(k.fx.timer = function (e) {
k.timers.push(e), k.fx.start();
}),
(k.fx.interval = 13),
(k.fx.start = function () {
vi || ((vi = !0), bi());
}),
(k.fx.stop = function () {
vi = null;
}),
(k.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
(k.fn.delay = function (n, e) {
return (
(n = (k.fx && k.fx.speeds[n]) || n),
this.queue((e = e || "fx"), function (e, t) {
var i = S.setTimeout(e, n);
t.stop = function () {
S.clearTimeout(i);
};
})
);
}),
(r = T.createElement("input")),
(s = T.createElement("select").appendChild(
T.createElement("option")
)),
(r.type = "checkbox"),
(g.checkOn = "" !== r.value),
(g.optSelected = s.selected),
((r = T.createElement("input")).value = "t"),
(r.type = "radio"),
(g.radioValue = "t" === r.value);
var Ti,
ki = k.expr.attrHandle,
Ci =
(k.fn.extend({
attr: function (e, t) {
return d(this, k.attr, e, t, 1 < arguments.length);
},
removeAttr: function (e) {
return this.each(function () {
k.removeAttr(this, e);
});
},
}),
k.extend({
attr: function (e, t, i) {
var n,
o,
s = e.nodeType;
if (3 !== s && 8 !== s && 2 !== s)
return void 0 === e.getAttribute
? k.prop(e, t, i)
: ((1 === s && k.isXMLDoc(e)) ||
(o =
k.attrHooks[t.toLowerCase()] ||
(k.expr.match.bool.test(t) ? Ti : void 0)),
void 0 !== i
? null === i
? void k.removeAttr(e, t)
: o &&
"set" in o &&
void 0 !== (n = o.set(e, i, t))
? n
: (e.setAttribute(t, i + ""), i)
: !(
o &&
"get" in o &&
null !== (n = o.get(e, t))
) && null == (n = k.find.attr(e, t))
? void 0
: n);
},
attrHooks: {
type: {
set: function (e, t) {
var i;
if (!g.radioValue && "radio" === t && x(e, "input"))
return (
(i = e.value),
e.setAttribute("type", t),
i && (e.value = i),
t
);
},
},
},
removeAttr: function (e, t) {
var i,
n = 0,
o = t && t.match(D);
if (o && 1 === e.nodeType)
for (; (i = o[n++]); ) e.removeAttribute(i);
},
}),
(Ti = {
set: function (e, t, i) {
return (
!1 === t ? k.removeAttr(e, i) : e.setAttribute(i, i), i
);
},
}),
k.each(
k.expr.match.bool.source.match(/\w+/g),
function (e, t) {
var r = ki[t] || k.find.attr;
ki[t] = function (e, t, i) {
var n,
o,
s = t.toLowerCase();
return (
i ||
((o = ki[s]),
(ki[s] = n),
(n = null != r(e, t, i) ? s : null),
(ki[s] = o)),
n
);
};
}
),
/^(?:input|select|textarea|button)$/i),
Ai = /^(?:a|area)$/i;
function Ei(e) {
return (e.match(D) || []).join(" ");
}
function Li(e) {
return (e.getAttribute && e.getAttribute("class")) || "";
}
function $i(e) {
return Array.isArray(e)
? e
: ("string" == typeof e && e.match(D)) || [];
}
k.fn.extend({
prop: function (e, t) {
return d(this, k.prop, e, t, 1 < arguments.length);
},
removeProp: function (e) {
return this.each(function () {
delete this[k.propFix[e] || e];
});
},
}),
k.extend({
prop: function (e, t, i) {
var n,
o,
s = e.nodeType;
if (3 !== s && 8 !== s && 2 !== s)
return (
(1 === s && k.isXMLDoc(e)) ||
((t = k.propFix[t] || t), (o = k.propHooks[t])),
void 0 !== i
? o && "set" in o && void 0 !== (n = o.set(e, i, t))
? n
: (e[t] = i)
: o && "get" in o && null !== (n = o.get(e, t))
? n
: e[t]
);
},
propHooks: {
tabIndex: {
get: function (e) {
var t = k.find.attr(e, "tabindex");
return t
? parseInt(t, 10)
: Ci.test(e.nodeName) ||
(Ai.test(e.nodeName) && e.href)
? 0
: -1;
},
},
},
propFix: { for: "htmlFor", class: "className" },
}),
g.optSelected ||
(k.propHooks.selected = {
get: function (e) {
e = e.parentNode;
return (
e && e.parentNode && e.parentNode.selectedIndex, null
);
},
set: function (e) {
e = e.parentNode;
e &&
(e.selectedIndex, e.parentNode) &&
e.parentNode.selectedIndex;
},
}),
k.each(
[
"tabIndex",
"readOnly",
"maxLength",
"cellSpacing",
"cellPadding",
"rowSpan",
"colSpan",
"useMap",
"frameBorder",
"contentEditable",
],
function () {
k.propFix[this.toLowerCase()] = this;
}
),
k.fn.extend({
addClass: function (t) {
var e, i, n, o, s, r;
return m(t)
? this.each(function (e) {
k(this).addClass(t.call(this, e, Li(this)));
})
: (e = $i(t)).length
? this.each(function () {
if (
((n = Li(this)),
(i = 1 === this.nodeType && " " + Ei(n) + " "))
) {
for (s = 0; s < e.length; s++)
(o = e[s]),
i.indexOf(" " + o + " ") < 0 && (i += o + " ");
(r = Ei(i)),
n !== r && this.setAttribute("class", r);
}
})
: this;
},
removeClass: function (t) {
var e, i, n, o, s, r;
return m(t)
? this.each(function (e) {
k(this).removeClass(t.call(this, e, Li(this)));
})
: arguments.length
? (e = $i(t)).length
? this.each(function () {
if (
((n = Li(this)),
(i = 1 === this.nodeType && " " + Ei(n) + " "))
) {
for (s = 0; s < e.length; s++)
for (o = e[s]; -1 < i.indexOf(" " + o + " "); )
i = i.replace(" " + o + " ", " ");
(r = Ei(i)),
n !== r && this.setAttribute("class", r);
}
})
: this
: this.attr("class", "");
},
toggleClass: function (t, i) {
var e,
n,
o,
s,
r = typeof t,
l = "string" == r || Array.isArray(t);
return m(t)
? this.each(function (e) {
k(this).toggleClass(t.call(this, e, Li(this), i), i);
})
: "boolean" == typeof i && l
? i
? this.addClass(t)
: this.removeClass(t)
: ((e = $i(t)),
this.each(function () {
if (l)
for (s = k(this), o = 0; o < e.length; o++)
(n = e[o]),
s.hasClass(n)
? s.removeClass(n)
: s.addClass(n);
else
(void 0 !== t && "boolean" != r) ||
((n = Li(this)) &&
y.set(this, "__className__", n),
this.setAttribute &&
this.setAttribute(
"class",
(!n &&
!1 !== t &&
y.get(this, "__className__")) ||
""
));
}));
},
hasClass: function (e) {
for (var t, i = 0, n = " " + e + " "; (t = this[i++]); )
if (
1 === t.nodeType &&
-1 < (" " + Ei(Li(t)) + " ").indexOf(n)
)
return !0;
return !1;
},
});
function _i(e) {
e.stopPropagation();
}
var Oi = /\r/g,
Di =
(k.fn.extend({
val: function (t) {
var i,
e,
n,
o = this[0];
return arguments.length
? ((n = m(t)),
this.each(function (e) {
1 === this.nodeType &&
(null ==
(e = n ? t.call(this, e, k(this).val()) : t)
? (e = "")
: "number" == typeof e
? (e += "")
: Array.isArray(e) &&
(e = k.map(e, function (e) {
return null == e ? "" : e + "";
})),
((i =
k.valHooks[this.type] ||
k.valHooks[this.nodeName.toLowerCase()]) &&
"set" in i &&
void 0 !== i.set(this, e, "value")) ||
(this.value = e));
}))
: o
? (i =
k.valHooks[o.type] ||
k.valHooks[o.nodeName.toLowerCase()]) &&
"get" in i &&
void 0 !== (e = i.get(o, "value"))
? e
: "string" == typeof (e = o.value)
? e.replace(Oi, "")
: null == e
? ""
: e
: void 0;
},
}),
k.extend({
valHooks: {
option: {
get: function (e) {
var t = k.find.attr(e, "value");
return null != t ? t : Ei(k.text(e));
},
},
select: {
get: function (e) {
for (
var t,
i = e.options,
n = e.selectedIndex,
o = "select-one" === e.type,
s = o ? null : [],
r = o ? n + 1 : i.length,
l = n < 0 ? r : o ? n : 0;
l < r;
l++
)
if (
((t = i[l]).selected || l === n) &&
!t.disabled &&
(!t.parentNode.disabled ||
!x(t.parentNode, "optgroup"))
) {
if (((t = k(t).val()), o)) return t;
s.push(t);
}
return s;
},
set: function (e, t) {
for (
var i,
n,
o = e.options,
s = k.makeArray(t),
r = o.length;
r--;
)
((n = o[r]).selected =
-1 < k.inArray(k.valHooks.option.get(n), s)) &&
(i = !0);
return i || (e.selectedIndex = -1), s;
},
},
},
}),
k.each(["radio", "checkbox"], function () {
(k.valHooks[this] = {
set: function (e, t) {
if (Array.isArray(t))
return (e.checked = -1 < k.inArray(k(e).val(), t));
},
}),
g.checkOn ||
(k.valHooks[this].get = function (e) {
return null === e.getAttribute("value")
? "on"
: e.value;
});
}),
S.location),
qi = { guid: Date.now() },
Pi = /\?/,
Ni =
((k.parseXML = function (e) {
var t, i;
if (!e || "string" != typeof e) return null;
try {
t = new S.DOMParser().parseFromString(e, "text/xml");
} catch (e) {}
return (
(i = t && t.getElementsByTagName("parsererror")[0]),
(t && !i) ||
k.error(
"Invalid XML: " +
(i
? k
.map(i.childNodes, function (e) {
return e.textContent;
})
.join("\n")
: e)
),
t
);
}),
/^(?:focusinfocus|focusoutblur)$/),
ji =
(k.extend(k.event, {
trigger: function (e, t, i, n) {
var o,
s,
r,
l,
a,
c,
d,
u = [i || T],
p = R.call(e, "type") ? e.type : e,
h = R.call(e, "namespace")
? e.namespace.split(".")
: [],
f = (d = s = i = i || T);
if (
3 !== i.nodeType &&
8 !== i.nodeType &&
!Ni.test(p + k.event.triggered) &&
(-1 < p.indexOf(".") &&
((p = (h = p.split(".")).shift()), h.sort()),
(l = p.indexOf(":") < 0 && "on" + p),
((e = e[k.expando]
? e
: new k.Event(
p,
"object" == typeof e && e
)).isTrigger = n ? 2 : 3),
(e.namespace = h.join(".")),
(e.rnamespace = e.namespace
? new RegExp(
"(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"
)
: null),
(e.result = void 0),
e.target || (e.target = i),
(t = null == t ? [e] : k.makeArray(t, [e])),
(c = k.event.special[p] || {}),
n || !c.trigger || !1 !== c.trigger.apply(i, t))
) {
if (!n && !c.noBubble && !H(i)) {
for (
r = c.delegateType || p,
Ni.test(r + p) || (f = f.parentNode);
f;
f = f.parentNode
)
u.push(f), (s = f);
s === (i.ownerDocument || T) &&
u.push(s.defaultView || s.parentWindow || S);
}
for (o = 0; (f = u[o++]) && !e.isPropagationStopped(); )
(d = f),
(e.type = 1 < o ? r : c.bindType || p),
(a =
(y.get(f, "events") || Object.create(null))[
e.type
] && y.get(f, "handle")) && a.apply(f, t),
(a = l && f[l]) &&
a.apply &&
ct(f) &&
((e.result = a.apply(f, t)), !1 === e.result) &&
e.preventDefault();
return (
(e.type = p),
n ||
e.isDefaultPrevented() ||
(c._default &&
!1 !== c._default.apply(u.pop(), t)) ||
!ct(i) ||
(l &&
m(i[p]) &&
!H(i) &&
((s = i[l]) && (i[l] = null),
(k.event.triggered = p),
e.isPropagationStopped() &&
d.addEventListener(p, _i),
i[p](),
e.isPropagationStopped() &&
d.removeEventListener(p, _i),
(k.event.triggered = void 0),
s) &&
(i[l] = s)),
e.result
);
}
},
simulate: function (e, t, i) {
i = k.extend(new k.Event(), i, {
type: e,
isSimulated: !0,
});
k.event.trigger(i, null, t);
},
}),
k.fn.extend({
trigger: function (e, t) {
return this.each(function () {
k.event.trigger(e, t, this);
});
},
triggerHandler: function (e, t) {
var i = this[0];
if (i) return k.event.trigger(e, t, i, !0);
},
}),
/\[\]$/),
Hi = /\r?\n/g,
Mi = /^(?:submit|button|image|reset|file)$/i,
Ii = /^(?:input|select|textarea|keygen)/i;
(k.param = function (e, t) {
function i(e, t) {
(t = m(t) ? t() : t),
(o[o.length] =
encodeURIComponent(e) +
"=" +
encodeURIComponent(null == t ? "" : t));
}
var n,
o = [];
if (null == e) return "";
if (Array.isArray(e) || (e.jquery && !k.isPlainObject(e)))
k.each(e, function () {
i(this.name, this.value);
});
else
for (n in e)
!(function i(n, e, o, s) {
if (Array.isArray(e))
k.each(e, function (e, t) {
o || ji.test(n)
? s(n, t)
: i(
n +
"[" +
("object" == typeof t && null != t ? e : "") +
"]",
t,
o,
s
);
});
else if (o || "object" !== V(e)) s(n, e);
else for (var t in e) i(n + "[" + t + "]", e[t], o, s);
})(n, e[n], t, i);
return o.join("&");
}),
k.fn.extend({
serialize: function () {
return k.param(this.serializeArray());
},
serializeArray: function () {
return this.map(function () {
var e = k.prop(this, "elements");
return e ? k.makeArray(e) : this;
})
.filter(function () {
var e = this.type;
return (
this.name &&
!k(this).is(":disabled") &&
Ii.test(this.nodeName) &&
!Mi.test(e) &&
(this.checked || !Tt.test(e))
);
})
.map(function (e, t) {
var i = k(this).val();
return null == i
? null
: Array.isArray(i)
? k.map(i, function (e) {
return {
name: t.name,
value: e.replace(Hi, "\r\n"),
};
})
: { name: t.name, value: i.replace(Hi, "\r\n") };
})
.get();
},
});
var zi = /%20/g,
Wi = /#.*$/,
Xi = /([?&])_=[^&]*/,
Ri = /^(.*?):[ \t]*([^\r\n]*)$/gm,
Bi = /^(?:GET|HEAD)$/,
Yi = /^\/\//,
Fi = {},
Ui = {},
Vi = "*/".concat("*"),
Gi = T.createElement("a");
function Zi(s) {
return function (e, t) {
"string" != typeof e && ((t = e), (e = "*"));
var i,
n = 0,
o = e.toLowerCase().match(D) || [];
if (m(t))
for (; (i = o[n++]); )
"+" === i[0]
? ((i = i.slice(1) || "*"),
(s[i] = s[i] || []).unshift(t))
: (s[i] = s[i] || []).push(t);
};
}
function Qi(t, n, o, s) {
var r = {},
l = t === Ui;
function a(e) {
var i;
return (
(r[e] = !0),
k.each(t[e] || [], function (e, t) {
t = t(n, o, s);
return "string" != typeof t || l || r[t]
? l
? !(i = t)
: void 0
: (n.dataTypes.unshift(t), a(t), !1);
}),
i
);
}
return a(n.dataTypes[0]) || (!r["*"] && a("*"));
}
function Ji(e, t) {
var i,
n,
o = k.ajaxSettings.flatOptions || {};
for (i in t)
void 0 !== t[i] && ((o[i] ? e : (n = n || {}))[i] = t[i]);
return n && k.extend(!0, e, n), e;
}
(Gi.href = Di.href),
k.extend({
active: 0,
lastModified: {},
etag: {},
ajaxSettings: {
url: Di.href,
type: "GET",
isLocal:
/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
Di.protocol
),
global: !0,
processData: !0,
async: !0,
contentType:
"application/x-www-form-urlencoded; charset=UTF-8",
accepts: {
"*": Vi,
text: "text/plain",
html: "text/html",
xml: "application/xml, text/xml",
json: "application/json, text/javascript",
},
contents: {
xml: /\bxml\b/,
html: /\bhtml/,
json: /\bjson\b/,
},
responseFields: {
xml: "responseXML",
text: "responseText",
json: "responseJSON",
},
converters: {
"* text": String,
"text html": !0,
"text json": JSON.parse,
"text xml": k.parseXML,
},
flatOptions: { url: !0, context: !0 },
},
ajaxSetup: function (e, t) {
return t
? Ji(Ji(e, k.ajaxSettings), t)
: Ji(k.ajaxSettings, e);
},
ajaxPrefilter: Zi(Fi),
ajaxTransport: Zi(Ui),
ajax: function (e, t) {
"object" == typeof e && ((t = e), (e = void 0));
var a,
c,
d,
i,
u,
p,
h,
n,
o,
f = k.ajaxSetup({}, (t = t || {})),
g = f.context || f,
v =
f.context && (g.nodeType || g.jquery) ? k(g) : k.event,
y = k.Deferred(),
m = k.Callbacks("once memory"),
b = f.statusCode || {},
s = {},
r = {},
l = "canceled",
x = {
readyState: 0,
getResponseHeader: function (e) {
var t;
if (p) {
if (!i)
for (i = {}; (t = Ri.exec(d)); )
i[t[1].toLowerCase() + " "] = (
i[t[1].toLowerCase() + " "] || []
).concat(t[2]);
t = i[e.toLowerCase() + " "];
}
return null == t ? null : t.join(", ");
},
getAllResponseHeaders: function () {
return p ? d : null;
},
setRequestHeader: function (e, t) {
return (
null == p &&
((e = r[e.toLowerCase()] =
r[e.toLowerCase()] || e),
(s[e] = t)),
this
);
},
overrideMimeType: function (e) {
return null == p && (f.mimeType = e), this;
},
statusCode: function (e) {
if (e)
if (p) x.always(e[x.status]);
else for (var t in e) b[t] = [b[t], e[t]];
return this;
},
abort: function (e) {
e = e || l;
return a && a.abort(e), w(0, e), this;
},
};
if (
(y.promise(x),
(f.url = ((e || f.url || Di.href) + "").replace(
Yi,
Di.protocol + "//"
)),
(f.type = t.method || t.type || f.method || f.type),
(f.dataTypes = (f.dataType || "*")
.toLowerCase()
.match(D) || [""]),
null == f.crossDomain)
) {
o = T.createElement("a");
try {
(o.href = f.url),
(o.href = o.href),
(f.crossDomain =
Gi.protocol + "//" + Gi.host !=
o.protocol + "//" + o.host);
} catch (e) {
f.crossDomain = !0;
}
}
if (
(f.data &&
f.processData &&
"string" != typeof f.data &&
(f.data = k.param(f.data, f.traditional)),
Qi(Fi, f, t, x),
!p)
) {
for (n in ((h = k.event && f.global) &&
0 == k.active++ &&
k.event.trigger("ajaxStart"),
(f.type = f.type.toUpperCase()),
(f.hasContent = !Bi.test(f.type)),
(c = f.url.replace(Wi, "")),
f.hasContent
? f.data &&
f.processData &&
0 ===
(f.contentType || "").indexOf(
"application/x-www-form-urlencoded"
) &&
(f.data = f.data.replace(zi, "+"))
: ((o = f.url.slice(c.length)),
f.data &&
(f.processData || "string" == typeof f.data) &&
((c += (Pi.test(c) ? "&" : "?") + f.data),
delete f.data),
!1 === f.cache &&
((c = c.replace(Xi, "$1")),
(o =
(Pi.test(c) ? "&" : "?") + "_=" + qi.guid++ + o)),
(f.url = c + o)),
f.ifModified &&
(k.lastModified[c] &&
x.setRequestHeader(
"If-Modified-Since",
k.lastModified[c]
),
k.etag[c]) &&
x.setRequestHeader("If-None-Match", k.etag[c]),
((f.data && f.hasContent && !1 !== f.contentType) ||
t.contentType) &&
x.setRequestHeader("Content-Type", f.contentType),
x.setRequestHeader(
"Accept",
f.dataTypes[0] && f.accepts[f.dataTypes[0]]
? f.accepts[f.dataTypes[0]] +
("*" !== f.dataTypes[0]
? ", " + Vi + "; q=0.01"
: "")
: f.accepts["*"]
),
f.headers))
x.setRequestHeader(n, f.headers[n]);
if (
f.beforeSend &&
(!1 === f.beforeSend.call(g, x, f) || p)
)
return x.abort();
if (
((l = "abort"),
m.add(f.complete),
x.done(f.success),
x.fail(f.error),
(a = Qi(Ui, f, t, x)))
) {
if (
((x.readyState = 1),
h && v.trigger("ajaxSend", [x, f]),
p)
)
return x;
f.async &&
0 < f.timeout &&
(u = S.setTimeout(function () {
x.abort("timeout");
}, f.timeout));
try {
(p = !1), a.send(s, w);
} catch (e) {
if (p) throw e;
w(-1, e);
}
} else w(-1, "No Transport");
}
return x;
function w(e, t, i, n) {
var o,
s,
r,
l = t;
p ||
((p = !0),
u && S.clearTimeout(u),
(a = void 0),
(d = n || ""),
(x.readyState = 0 < e ? 4 : 0),
(n = (200 <= e && e < 300) || 304 === e),
i &&
(r = (function (e, t, i) {
for (
var n, o, s, r, l = e.contents, a = e.dataTypes;
"*" === a[0];
)
a.shift(),
void 0 === n &&
(n =
e.mimeType ||
t.getResponseHeader("Content-Type"));
if (n)
for (o in l)
if (l[o] && l[o].test(n)) {
a.unshift(o);
break;
}
if (a[0] in i) s = a[0];
else {
for (o in i) {
if (!a[0] || e.converters[o + " " + a[0]]) {
s = o;
break;
}
r = r || o;
}
s = s || r;
}
if (s) return s !== a[0] && a.unshift(s), i[s];
})(f, x, i)),
!n &&
-1 < k.inArray("script", f.dataTypes) &&
k.inArray("json", f.dataTypes) < 0 &&
(f.converters["text script"] = function () {}),
(r = (function (e, t, i, n) {
var o,
s,
r,
l,
a,
c = {},
d = e.dataTypes.slice();
if (d[1])
for (r in e.converters)
c[r.toLowerCase()] = e.converters[r];
for (s = d.shift(); s; )
if (
(e.responseFields[s] &&
(i[e.responseFields[s]] = t),
!a &&
n &&
e.dataFilter &&
(t = e.dataFilter(t, e.dataType)),
(a = s),
(s = d.shift()))
)
if ("*" === s) s = a;
else if ("*" !== a && a !== s) {
if (!(r = c[a + " " + s] || c["* " + s]))
for (o in c)
if (
(l = o.split(" "))[1] === s &&
(r = c[a + " " + l[0]] || c["* " + l[0]])
) {
!0 === r
? (r = c[o])
: !0 !== c[o] &&
((s = l[0]), d.unshift(l[1]));
break;
}
if (!0 !== r)
if (r && e.throws) t = r(t);
else
try {
t = r(t);
} catch (e) {
return {
state: "parsererror",
error: r
? e
: "No conversion from " +
a +
" to " +
s,
};
}
}
return { state: "success", data: t };
})(f, r, x, n)),
n
? (f.ifModified &&
((i = x.getResponseHeader("Last-Modified")) &&
(k.lastModified[c] = i),
(i = x.getResponseHeader("etag"))) &&
(k.etag[c] = i),
204 === e || "HEAD" === f.type
? (l = "nocontent")
: 304 === e
? (l = "notmodified")
: ((l = r.state),
(o = r.data),
(n = !(s = r.error))))
: ((s = l),
(!e && l) || ((l = "error"), e < 0 && (e = 0))),
(x.status = e),
(x.statusText = (t || l) + ""),
n
? y.resolveWith(g, [o, l, x])
: y.rejectWith(g, [x, l, s]),
x.statusCode(b),
(b = void 0),
h &&
v.trigger(n ? "ajaxSuccess" : "ajaxError", [
x,
f,
n ? o : s,
]),
m.fireWith(g, [x, l]),
h &&
(v.trigger("ajaxComplete", [x, f]),
--k.active || k.event.trigger("ajaxStop")));
}
},
getJSON: function (e, t, i) {
return k.get(e, t, i, "json");
},
getScript: function (e, t) {
return k.get(e, void 0, t, "script");
},
}),
k.each(["get", "post"], function (e, o) {
k[o] = function (e, t, i, n) {
return (
m(t) && ((n = n || i), (i = t), (t = void 0)),
k.ajax(
k.extend(
{ url: e, type: o, dataType: n, data: t, success: i },
k.isPlainObject(e) && e
)
)
);
};
}),
k.ajaxPrefilter(function (e) {
for (var t in e.headers)
"content-type" === t.toLowerCase() &&
(e.contentType = e.headers[t] || "");
}),
(k._evalUrl = function (e, t, i) {
return k.ajax({
url: e,
type: "GET",
dataType: "script",
cache: !0,
async: !1,
global: !1,
converters: { "text script": function () {} },
dataFilter: function (e) {
k.globalEval(e, t, i);
},
});
}),
k.fn.extend({
wrapAll: function (e) {
return (
this[0] &&
(m(e) && (e = e.call(this[0])),
(e = k(e, this[0].ownerDocument).eq(0).clone(!0)),
this[0].parentNode && e.insertBefore(this[0]),
e
.map(function () {
for (var e = this; e.firstElementChild; )
e = e.firstElementChild;
return e;
})
.append(this)),
this
);
},
wrapInner: function (i) {
return m(i)
? this.each(function (e) {
k(this).wrapInner(i.call(this, e));
})
: this.each(function () {
var e = k(this),
t = e.contents();
t.length ? t.wrapAll(i) : e.append(i);
});
},
wrap: function (t) {
var i = m(t);
return this.each(function (e) {
k(this).wrapAll(i ? t.call(this, e) : t);
});
},
unwrap: function (e) {
return (
this.parent(e)
.not("body")
.each(function () {
k(this).replaceWith(this.childNodes);
}),
this
);
},
}),
(k.expr.pseudos.hidden = function (e) {
return !k.expr.pseudos.visible(e);
}),
(k.expr.pseudos.visible = function (e) {
return !!(
e.offsetWidth ||
e.offsetHeight ||
e.getClientRects().length
);
}),
(k.ajaxSettings.xhr = function () {
try {
return new S.XMLHttpRequest();
} catch (e) {}
});
var Ki = { 0: 200, 1223: 204 },
en = k.ajaxSettings.xhr();
(g.cors = !!en && "withCredentials" in en),
(g.ajax = en = !!en),
k.ajaxTransport(function (o) {
var s, r;
if (g.cors || (en && !o.crossDomain))
return {
send: function (e, t) {
var i,
n = o.xhr();
if (
(n.open(
o.type,
o.url,
o.async,
o.username,
o.password
),
o.xhrFields)
)
for (i in o.xhrFields) n[i] = o.xhrFields[i];
for (i in (o.mimeType &&
n.overrideMimeType &&
n.overrideMimeType(o.mimeType),
o.crossDomain ||
e["X-Requested-With"] ||
(e["X-Requested-With"] = "XMLHttpRequest"),
e))
n.setRequestHeader(i, e[i]);
(s = function (e) {
return function () {
s &&
((s =
r =
n.onload =
n.onerror =
n.onabort =
n.ontimeout =
n.onreadystatechange =
null),
"abort" === e
? n.abort()
: "error" === e
? "number" != typeof n.status
? t(0, "error")
: t(n.status, n.statusText)
: t(
Ki[n.status] || n.status,
n.statusText,
"text" !== (n.responseType || "text") ||
"string" != typeof n.responseText
? { binary: n.response }
: { text: n.responseText },
n.getAllResponseHeaders()
));
};
}),
(n.onload = s()),
(r = n.onerror = n.ontimeout = s("error")),
void 0 !== n.onabort
? (n.onabort = r)
: (n.onreadystatechange = function () {
4 === n.readyState &&
S.setTimeout(function () {
s && r();
});
}),
(s = s("abort"));
try {
n.send((o.hasContent && o.data) || null);
} catch (e) {
if (s) throw e;
}
},
abort: function () {
s && s();
},
};
}),
k.ajaxPrefilter(function (e) {
e.crossDomain && (e.contents.script = !1);
}),
k.ajaxSetup({
accepts: {
script:
"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
},
contents: { script: /\b(?:java|ecma)script\b/ },
converters: {
"text script": function (e) {
return k.globalEval(e), e;
},
},
}),
k.ajaxPrefilter("script", function (e) {
void 0 === e.cache && (e.cache = !1),
e.crossDomain && (e.type = "GET");
}),
k.ajaxTransport("script", function (i) {
var n, o;
if (i.crossDomain || i.scriptAttrs)
return {
send: function (e, t) {
(n = k("<script>")
.attr(i.scriptAttrs || {})
.prop({ charset: i.scriptCharset, src: i.url })
.on(
"load error",
(o = function (e) {
n.remove(),
(o = null),
e && t("error" === e.type ? 404 : 200, e.type);
})
)),
T.head.appendChild(n[0]);
},
abort: function () {
o && o();
},
};
});
var tn = [],
nn = /(=)\?(?=&|$)|\?\?/,
on =
(k.ajaxSetup({
jsonp: "callback",
jsonpCallback: function () {
var e = tn.pop() || k.expando + "_" + qi.guid++;
return (this[e] = !0), e;
},
}),
k.ajaxPrefilter("json jsonp", function (e, t, i) {
var n,
o,
s,
r =
!1 !== e.jsonp &&
(nn.test(e.url)
? "url"
: "string" == typeof e.data &&
0 ===
(e.contentType || "").indexOf(
"application/x-www-form-urlencoded"
) &&
nn.test(e.data) &&
"data");
if (r || "jsonp" === e.dataTypes[0])
return (
(n = e.jsonpCallback =
m(e.jsonpCallback)
? e.jsonpCallback()
: e.jsonpCallback),
r
? (e[r] = e[r].replace(nn, "$1" + n))
: !1 !== e.jsonp &&
(e.url +=
(Pi.test(e.url) ? "&" : "?") + e.jsonp + "=" + n),
(e.converters["script json"] = function () {
return s || k.error(n + " was not called"), s[0];
}),
(e.dataTypes[0] = "json"),
(o = S[n]),
(S[n] = function () {
s = arguments;
}),
i.always(function () {
void 0 === o ? k(S).removeProp(n) : (S[n] = o),
e[n] &&
((e.jsonpCallback = t.jsonpCallback), tn.push(n)),
s && m(o) && o(s[0]),
(s = o = void 0);
}),
"script"
);
}),
(g.createHTMLDocument =
(((e =
T.implementation.createHTMLDocument("").body).innerHTML =
"<form></form><form></form>"),
2 === e.childNodes.length)),
(k.parseHTML = function (e, t, i) {
return "string" != typeof e
? []
: ("boolean" == typeof t && ((i = t), (t = !1)),
t ||
(g.createHTMLDocument
? (((n = (t =
T.implementation.createHTMLDocument(
""
)).createElement("base")).href =
T.location.href),
t.head.appendChild(n))
: (t = T)),
(n = !i && []),
(i = Ue.exec(e))
? [t.createElement(i[1])]
: ((i = Lt([e], t, n)),
n && n.length && k(n).remove(),
k.merge([], i.childNodes)));
var n;
}),
(k.fn.load = function (e, t, i) {
var n,
o,
s,
r = this,
l = e.indexOf(" ");
return (
-1 < l && ((n = Ei(e.slice(l))), (e = e.slice(0, l))),
m(t)
? ((i = t), (t = void 0))
: t && "object" == typeof t && (o = "POST"),
0 < r.length &&
k
.ajax({
url: e,
type: o || "GET",
dataType: "html",
data: t,
})
.done(function (e) {
(s = arguments),
r.html(
n
? k("<div>").append(k.parseHTML(e)).find(n)
: e
);
})
.always(
i &&
function (e, t) {
r.each(function () {
i.apply(this, s || [e.responseText, t, e]);
});
}
),
this
);
}),
(k.expr.pseudos.animated = function (t) {
return k.grep(k.timers, function (e) {
return t === e.elem;
}).length;
}),
(k.offset = {
setOffset: function (e, t, i) {
var n,
o,
s,
r,
l = k.css(e, "position"),
a = k(e),
c = {};
"static" === l && (e.style.position = "relative"),
(s = a.offset()),
(n = k.css(e, "top")),
(r = k.css(e, "left")),
(l =
("absolute" === l || "fixed" === l) &&
-1 < (n + r).indexOf("auto")
? ((o = (l = a.position()).top), l.left)
: ((o = parseFloat(n) || 0), parseFloat(r) || 0)),
null !=
(t = m(t) ? t.call(e, i, k.extend({}, s)) : t).top &&
(c.top = t.top - s.top + o),
null != t.left && (c.left = t.left - s.left + l),
"using" in t ? t.using.call(e, c) : a.css(c);
},
}),
k.fn.extend({
offset: function (t) {
var e, i;
return arguments.length
? void 0 === t
? this
: this.each(function (e) {
k.offset.setOffset(this, t, e);
})
: (i = this[0])
? i.getClientRects().length
? ((e = i.getBoundingClientRect()),
(i = i.ownerDocument.defaultView),
{
top: e.top + i.pageYOffset,
left: e.left + i.pageXOffset,
})
: { top: 0, left: 0 }
: void 0;
},
position: function () {
if (this[0]) {
var e,
t,
i,
n = this[0],
o = { top: 0, left: 0 };
if ("fixed" === k.css(n, "position"))
t = n.getBoundingClientRect();
else {
for (
t = this.offset(),
i = n.ownerDocument,
e = n.offsetParent || i.documentElement;
e &&
(e === i.body || e === i.documentElement) &&
"static" === k.css(e, "position");
)
e = e.parentNode;
e &&
e !== n &&
1 === e.nodeType &&
(((o = k(e).offset()).top += k.css(
e,
"borderTopWidth",
!0
)),
(o.left += k.css(e, "borderLeftWidth", !0)));
}
return {
top: t.top - o.top - k.css(n, "marginTop", !0),
left: t.left - o.left - k.css(n, "marginLeft", !0),
};
}
},
offsetParent: function () {
return this.map(function () {
for (
var e = this.offsetParent;
e && "static" === k.css(e, "position");
)
e = e.offsetParent;
return e || yt;
});
},
}),
k.each(
{ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
function (t, o) {
var s = "pageYOffset" === o;
k.fn[t] = function (e) {
return d(
this,
function (e, t, i) {
var n;
if (
(H(e)
? (n = e)
: 9 === e.nodeType && (n = e.defaultView),
void 0 === i)
)
return n ? n[o] : e[t];
n
? n.scrollTo(
s ? n.pageXOffset : i,
s ? i : n.pageYOffset
)
: (e[t] = i);
},
t,
e,
arguments.length
);
};
}
),
k.each(["top", "left"], function (e, i) {
k.cssHooks[i] = ii(g.pixelPosition, function (e, t) {
if (t)
return (
(t = ti(e, i)),
Jt.test(t) ? k(e).position()[i] + "px" : t
);
});
}),
k.each({ Height: "height", Width: "width" }, function (r, l) {
k.each(
{ padding: "inner" + r, content: l, "": "outer" + r },
function (n, s) {
k.fn[s] = function (e, t) {
var i =
arguments.length && (n || "boolean" != typeof e),
o =
n || (!0 === e || !0 === t ? "margin" : "border");
return d(
this,
function (e, t, i) {
var n;
return H(e)
? 0 === s.indexOf("outer")
? e["inner" + r]
: e.document.documentElement["client" + r]
: 9 === e.nodeType
? ((n = e.documentElement),
Math.max(
e.body["scroll" + r],
n["scroll" + r],
e.body["offset" + r],
n["offset" + r],
n["client" + r]
))
: void 0 === i
? k.css(e, t, o)
: k.style(e, t, i, o);
},
l,
i ? e : void 0,
i
);
};
}
);
}),
k.each(
[
"ajaxStart",
"ajaxStop",
"ajaxComplete",
"ajaxError",
"ajaxSuccess",
"ajaxSend",
],
function (e, t) {
k.fn[t] = function (e) {
return this.on(t, e);
};
}
),
k.fn.extend({
bind: function (e, t, i) {
return this.on(e, null, t, i);
},
unbind: function (e, t) {
return this.off(e, null, t);
},
delegate: function (e, t, i, n) {
return this.on(t, e, i, n);
},
undelegate: function (e, t, i) {
return 1 === arguments.length
? this.off(e, "**")
: this.off(t, e || "**", i);
},
hover: function (e, t) {
return this.on("mouseenter", e).on("mouseleave", t || e);
},
}),
k.each(
"blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
" "
),
function (e, i) {
k.fn[i] = function (e, t) {
return 0 < arguments.length
? this.on(i, null, e, t)
: this.trigger(i);
};
}
),
/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g),
sn =
((k.proxy = function (e, t) {
var i, n;
if (
("string" == typeof t && ((n = e[t]), (t = e), (e = n)),
m(e))
)
return (
(i = l.call(arguments, 2)),
((n = function () {
return e.apply(
t || this,
i.concat(l.call(arguments))
);
}).guid = e.guid =
e.guid || k.guid++),
n
);
}),
(k.holdReady = function (e) {
e ? k.readyWait++ : k.ready(!0);
}),
(k.isArray = Array.isArray),
(k.parseJSON = JSON.parse),
(k.nodeName = x),
(k.isFunction = m),
(k.isWindow = H),
(k.camelCase = q),
(k.type = V),
(k.now = Date.now),
(k.isNumeric = function (e) {
var t = k.type(e);
return (
("number" === t || "string" === t) &&
!isNaN(e - parseFloat(e))
);
}),
(k.trim = function (e) {
return null == e ? "" : (e + "").replace(on, "$1");
}),
void 0 !==
(cn = function () {
return k;
}.apply(an, [])) && (ln.exports = cn),
S.jQuery),
rn = S.$;
return (
(k.noConflict = function (e) {
return (
S.$ === k && (S.$ = rn),
e && S.jQuery === k && (S.jQuery = sn),
k
);
}),
void 0 === j && (S.jQuery = S.$ = k),
k
);
}),
"object" == typeof ln.exports
? (ln.exports = e.document
? t(e, !0)
: function (e) {
if (e.document) return t(e);
throw new Error(
"jQuery requires a window with a document"
);
})
: t(e);
},
483: function (e, t, i) {
(i = [i(616)]),
void 0 !==
(t = function (c) {
window.Slick;
var r,
n = 0;
((r = function (e, t) {
var i = this;
(i.defaults = {
accessibility: !0,
adaptiveHeight: !1,
appendArrows: c(e),
appendDots: c(e),
arrows: !0,
asNavFor: null,
prevArrow:
'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
nextArrow:
'<button class="slick-next" aria-label="Next" type="button">Next</button>',
autoplay: !1,
autoplaySpeed: 3e3,
centerMode: !1,
centerPadding: "50px",
cssEase: "ease",
customPaging: function (e, t) {
return c('<button type="button" />').text(t + 1);
},
dots: !1,
dotsClass: "slick-dots",
draggable: !0,
easing: "linear",
edgeFriction: 0.35,
fade: !1,
focusOnSelect: !1,
focusOnChange: !1,
infinite: !0,
initialSlide: 0,
lazyLoad: "ondemand",
mobileFirst: !1,
pauseOnHover: !0,
pauseOnFocus: !0,
pauseOnDotsHover: !1,
respondTo: "window",
responsive: null,
rows: 1,
rtl: !1,
slide: "",
slidesPerRow: 1,
slidesToShow: 1,
slidesToScroll: 1,
speed: 500,
swipe: !0,
swipeToSlide: !1,
touchMove: !0,
touchThreshold: 5,
useCSS: !0,
useTransform: !0,
variableWidth: !1,
vertical: !1,
verticalSwiping: !1,
waitForAnimate: !0,
zIndex: 1e3,
}),
(i.initials = {
animating: !1,
dragging: !1,
autoPlayTimer: null,
currentDirection: 0,
currentLeft: null,
currentSlide: 0,
direction: 1,
$dots: null,
listWidth: null,
listHeight: null,
loadIndex: 0,
$nextArrow: null,
$prevArrow: null,
scrolling: !1,
slideCount: null,
slideWidth: null,
$slideTrack: null,
$slides: null,
sliding: !1,
slideOffset: 0,
swipeLeft: null,
swiping: !1,
$list: null,
touchObject: {},
transformsEnabled: !1,
unslicked: !1,
}),
c.extend(i, i.initials),
(i.activeBreakpoint = null),
(i.animType = null),
(i.animProp = null),
(i.breakpoints = []),
(i.breakpointSettings = []),
(i.cssTransitions = !1),
(i.focussed = !1),
(i.interrupted = !1),
(i.hidden = "hidden"),
(i.paused = !0),
(i.positionProp = null),
(i.respondTo = null),
(i.rowCount = 1),
(i.shouldClick = !0),
(i.$slider = c(e)),
(i.$slidesCache = null),
(i.transformType = null),
(i.transitionType = null),
(i.visibilityChange = "visibilitychange"),
(i.windowWidth = 0),
(i.windowTimer = null),
(e = c(e).data("slick") || {}),
(i.options = c.extend({}, i.defaults, t, e)),
(i.currentSlide = i.options.initialSlide),
(i.originalSettings = i.options),
void 0 !== document.mozHidden
? ((i.hidden = "mozHidden"),
(i.visibilityChange = "mozvisibilitychange"))
: void 0 !== document.webkitHidden &&
((i.hidden = "webkitHidden"),
(i.visibilityChange = "webkitvisibilitychange")),
(i.autoPlay = c.proxy(i.autoPlay, i)),
(i.autoPlayClear = c.proxy(i.autoPlayClear, i)),
(i.autoPlayIterator = c.proxy(i.autoPlayIterator, i)),
(i.changeSlide = c.proxy(i.changeSlide, i)),
(i.clickHandler = c.proxy(i.clickHandler, i)),
(i.selectHandler = c.proxy(i.selectHandler, i)),
(i.setPosition = c.proxy(i.setPosition, i)),
(i.swipeHandler = c.proxy(i.swipeHandler, i)),
(i.dragHandler = c.proxy(i.dragHandler, i)),
(i.keyHandler = c.proxy(i.keyHandler, i)),
(i.instanceUid = n++),
(i.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
i.registerBreakpoints(),
i.init(!0);
}).prototype.activateADA = function () {
this.$slideTrack
.find(".slick-active")
.attr({ "aria-hidden": "false" })
.find("a, input, button, select")
.attr({ tabindex: "0" });
}),
(r.prototype.addSlide = r.prototype.slickAdd =
function (e, t, i) {
var n = this;
if ("boolean" == typeof t) (i = t), (t = null);
else if (t < 0 || t >= n.slideCount) return !1;
n.unload(),
"number" == typeof t
? 0 === t && 0 === n.$slides.length
? c(e).appendTo(n.$slideTrack)
: i
? c(e).insertBefore(n.$slides.eq(t))
: c(e).insertAfter(n.$slides.eq(t))
: !0 === i
? c(e).prependTo(n.$slideTrack)
: c(e).appendTo(n.$slideTrack),
(n.$slides = n.$slideTrack.children(
this.options.slide
)),
n.$slideTrack.children(this.options.slide).detach(),
n.$slideTrack.append(n.$slides),
n.$slides.each(function (e, t) {
c(t).attr("data-slick-index", e);
}),
(n.$slidesCache = n.$slides),
n.reinit();
}),
(r.prototype.animateHeight = function () {
var e,
t = this;
1 === t.options.slidesToShow &&
!0 === t.options.adaptiveHeight &&
!1 === t.options.vertical &&
((e = t.$slides.eq(t.currentSlide).outerHeight(!0)),
t.$list.animate({ height: e }, t.options.speed));
}),
(r.prototype.animateSlide = function (e, t) {
var i = {},
n = this;
n.animateHeight(),
!0 === n.options.rtl &&
!1 === n.options.vertical &&
(e = -e),
!1 === n.transformsEnabled
? !1 === n.options.vertical
? n.$slideTrack.animate(
{ left: e },
n.options.speed,
n.options.easing,
t
)
: n.$slideTrack.animate(
{ top: e },
n.options.speed,
n.options.easing,
t
)
: !1 === n.cssTransitions
? (!0 === n.options.rtl &&
(n.currentLeft = -n.currentLeft),
c({ animStart: n.currentLeft }).animate(
{ animStart: e },
{
duration: n.options.speed,
easing: n.options.easing,
step: function (e) {
(e = Math.ceil(e)),
!1 === n.options.vertical
? (i[n.animType] =
"translate(" + e + "px, 0px)")
: (i[n.animType] =
"translate(0px," + e + "px)"),
n.$slideTrack.css(i);
},
complete: function () {
t && t.call();
},
}
))
: (n.applyTransition(),
(e = Math.ceil(e)),
!1 === n.options.vertical
? (i[n.animType] =
"translate3d(" + e + "px, 0px, 0px)")
: (i[n.animType] =
"translate3d(0px," + e + "px, 0px)"),
n.$slideTrack.css(i),
t &&
setTimeout(function () {
n.disableTransition(), t.call();
}, n.options.speed));
}),
(r.prototype.getNavTarget = function () {
var e = this.options.asNavFor;
return (e = e && null !== e ? c(e).not(this.$slider) : e);
}),
(r.prototype.asNavFor = function (t) {
var e = this.getNavTarget();
null !== e &&
"object" == typeof e &&
e.each(function () {
var e = c(this).slick("getSlick");
e.unslicked || e.slideHandler(t, !0);
});
}),
(r.prototype.applyTransition = function (e) {
var t = this,
i = {};
!1 === t.options.fade
? (i[t.transitionType] =
t.transformType +
" " +
t.options.speed +
"ms " +
t.options.cssEase)
: (i[t.transitionType] =
"opacity " +
t.options.speed +
"ms " +
t.options.cssEase),
(!1 === t.options.fade
? t.$slideTrack
: t.$slides.eq(e)
).css(i);
}),
(r.prototype.autoPlay = function () {
var e = this;
e.autoPlayClear(),
e.slideCount > e.options.slidesToShow &&
(e.autoPlayTimer = setInterval(
e.autoPlayIterator,
e.options.autoplaySpeed
));
}),
(r.prototype.autoPlayClear = function () {
this.autoPlayTimer && clearInterval(this.autoPlayTimer);
}),
(r.prototype.autoPlayIterator = function () {
var e = this,
t = e.currentSlide + e.options.slidesToScroll;
e.paused ||
e.interrupted ||
e.focussed ||
(!1 === e.options.infinite &&
(1 === e.direction &&
e.currentSlide + 1 === e.slideCount - 1
? (e.direction = 0)
: 0 === e.direction &&
((t = e.currentSlide - e.options.slidesToScroll),
e.currentSlide - 1 == 0) &&
(e.direction = 1)),
e.slideHandler(t));
}),
(r.prototype.buildArrows = function () {
var e = this;
!0 === e.options.arrows &&
((e.$prevArrow = c(e.options.prevArrow).addClass(
"slick-arrow"
)),
(e.$nextArrow = c(e.options.nextArrow).addClass(
"slick-arrow"
)),
e.slideCount > e.options.slidesToShow
? (e.$prevArrow
.removeClass("slick-hidden")
.removeAttr("aria-hidden tabindex"),
e.$nextArrow
.removeClass("slick-hidden")
.removeAttr("aria-hidden tabindex"),
e.htmlExpr.test(e.options.prevArrow) &&
e.$prevArrow.prependTo(e.options.appendArrows),
e.htmlExpr.test(e.options.nextArrow) &&
e.$nextArrow.appendTo(e.options.appendArrows),
!0 !== e.options.infinite &&
e.$prevArrow
.addClass("slick-disabled")
.attr("aria-disabled", "true"))
: e.$prevArrow
.add(e.$nextArrow)
.addClass("slick-hidden")
.attr({ "aria-disabled": "true", tabindex: "-1" }));
}),
(r.prototype.buildDots = function () {
var e,
t,
i = this;
if (
!0 === i.options.dots &&
i.slideCount > i.options.slidesToShow
) {
for (
i.$slider.addClass("slick-dotted"),
t = c("<ul />").addClass(i.options.dotsClass),
e = 0;
e <= i.getDotCount();
e += 1
)
t.append(
c("<li />").append(
i.options.customPaging.call(this, i, e)
)
);
(i.$dots = t.appendTo(i.options.appendDots)),
i.$dots.find("li").first().addClass("slick-active");
}
}),
(r.prototype.buildOut = function () {
var e = this;
(e.$slides = e.$slider
.children(e.options.slide + ":not(.slick-cloned)")
.addClass("slick-slide")),
(e.slideCount = e.$slides.length),
e.$slides.each(function (e, t) {
c(t)
.attr("data-slick-index", e)
.data("originalStyling", c(t).attr("style") || "");
}),
e.$slider.addClass("slick-slider"),
(e.$slideTrack =
0 === e.slideCount
? c('<div class="slick-track"/>').appendTo(e.$slider)
: e.$slides
.wrapAll('<div class="slick-track"/>')
.parent()),
(e.$list = e.$slideTrack
.wrap('<div class="slick-list"/>')
.parent()),
e.$slideTrack.css("opacity", 0),
(!0 !== e.options.centerMode &&
!0 !== e.options.swipeToSlide) ||
(e.options.slidesToScroll = 1),
c("img[data-lazy]", e.$slider)
.not("[src]")
.addClass("slick-loading"),
e.setupInfinite(),
e.buildArrows(),
e.buildDots(),
e.updateDots(),
e.setSlideClasses(
"number" == typeof e.currentSlide ? e.currentSlide : 0
),
!0 === e.options.draggable &&
e.$list.addClass("draggable");
}),
(r.prototype.buildRows = function () {
var e,
t,
i,
n = this,
o = document.createDocumentFragment(),
s = n.$slider.children();
if (0 < n.options.rows) {
for (
i = n.options.slidesPerRow * n.options.rows,
t = Math.ceil(s.length / i),
e = 0;
e < t;
e++
) {
for (
var r = document.createElement("div"), l = 0;
l < n.options.rows;
l++
) {
for (
var a = document.createElement("div"), c = 0;
c < n.options.slidesPerRow;
c++
) {
var d = e * i + (l * n.options.slidesPerRow + c);
s.get(d) && a.appendChild(s.get(d));
}
r.appendChild(a);
}
o.appendChild(r);
}
n.$slider.empty().append(o),
n.$slider
.children()
.children()
.children()
.css({
width: 100 / n.options.slidesPerRow + "%",
display: "inline-block",
});
}
}),
(r.prototype.checkResponsive = function (e, t) {
var i,
n,
o,
s = this,
r = !1,
l = s.$slider.width(),
a = window.innerWidth || c(window).width();
if (
("window" === s.respondTo
? (o = a)
: "slider" === s.respondTo
? (o = l)
: "min" === s.respondTo && (o = Math.min(a, l)),
s.options.responsive &&
s.options.responsive.length &&
null !== s.options.responsive)
) {
for (i in ((n = null), s.breakpoints))
s.breakpoints.hasOwnProperty(i) &&
(!1 === s.originalSettings.mobileFirst
? o < s.breakpoints[i] && (n = s.breakpoints[i])
: o > s.breakpoints[i] && (n = s.breakpoints[i]));
null !== n
? (null !== s.activeBreakpoint &&
n === s.activeBreakpoint &&
!t) ||
((s.activeBreakpoint = n),
"unslick" === s.breakpointSettings[n]
? s.unslick(n)
: ((s.options = c.extend(
{},
s.originalSettings,
s.breakpointSettings[n]
)),
!0 === e &&
(s.currentSlide = s.options.initialSlide),
s.refresh(e)),
(r = n))
: null !== s.activeBreakpoint &&
((s.activeBreakpoint = null),
(s.options = s.originalSettings),
!0 === e && (s.currentSlide = s.options.initialSlide),
s.refresh(e),
(r = n)),
e ||
!1 === r ||
s.$slider.trigger("breakpoint", [s, r]);
}
}),
(r.prototype.changeSlide = function (e, t) {
var i,
n = this,
o = c(e.currentTarget);
switch (
(o.is("a") && e.preventDefault(),
o.is("li") || (o = o.closest("li")),
(i =
n.slideCount % n.options.slidesToScroll != 0
? 0
: (n.slideCount - n.currentSlide) %
n.options.slidesToScroll),
e.data.message)
) {
case "previous":
(s =
0 == i
? n.options.slidesToScroll
: n.options.slidesToShow - i),
n.slideCount > n.options.slidesToShow &&
n.slideHandler(n.currentSlide - s, !1, t);
break;
case "next":
(s = 0 == i ? n.options.slidesToScroll : i),
n.slideCount > n.options.slidesToShow &&
n.slideHandler(n.currentSlide + s, !1, t);
break;
case "index":
var s =
0 === e.data.index
? 0
: e.data.index ||
o.index() * n.options.slidesToScroll;
n.slideHandler(n.checkNavigable(s), !1, t),
o.children().trigger("focus");
break;
default:
return;
}
}),
(r.prototype.checkNavigable = function (e) {
var t,
i = 0;
if (e > (t = this.getNavigableIndexes())[t.length - 1])
e = t[t.length - 1];
else
for (var n in t) {
if (e < t[n]) {
e = i;
break;
}
i = t[n];
}
return e;
}),
(r.prototype.cleanUpEvents = function () {
var e = this;
e.options.dots &&
null !== e.$dots &&
(c("li", e.$dots)
.off("click.slick", e.changeSlide)
.off("mouseenter.slick", c.proxy(e.interrupt, e, !0))
.off("mouseleave.slick", c.proxy(e.interrupt, e, !1)),
!0 === e.options.accessibility) &&
e.$dots.off("keydown.slick", e.keyHandler),
e.$slider.off("focus.slick blur.slick"),
!0 === e.options.arrows &&
e.slideCount > e.options.slidesToShow &&
(e.$prevArrow &&
e.$prevArrow.off("click.slick", e.changeSlide),
e.$nextArrow &&
e.$nextArrow.off("click.slick", e.changeSlide),
!0 === e.options.accessibility) &&
(e.$prevArrow &&
e.$prevArrow.off("keydown.slick", e.keyHandler),
e.$nextArrow) &&
e.$nextArrow.off("keydown.slick", e.keyHandler),
e.$list.off(
"touchstart.slick mousedown.slick",
e.swipeHandler
),
e.$list.off(
"touchmove.slick mousemove.slick",
e.swipeHandler
),
e.$list.off(
"touchend.slick mouseup.slick",
e.swipeHandler
),
e.$list.off(
"touchcancel.slick mouseleave.slick",
e.swipeHandler
),
e.$list.off("click.slick", e.clickHandler),
c(document).off(e.visibilityChange, e.visibility),
e.cleanUpSlideEvents(),
!0 === e.options.accessibility &&
e.$list.off("keydown.slick", e.keyHandler),
!0 === e.options.focusOnSelect &&
c(e.$slideTrack)
.children()
.off("click.slick", e.selectHandler),
c(window).off(
"orientationchange.slick.slick-" + e.instanceUid,
e.orientationChange
),
c(window).off(
"resize.slick.slick-" + e.instanceUid,
e.resize
),
c("[draggable!=true]", e.$slideTrack).off(
"dragstart",
e.preventDefault
),
c(window).off(
"load.slick.slick-" + e.instanceUid,
e.setPosition
);
}),
(r.prototype.cleanUpSlideEvents = function () {
var e = this;
e.$list.off(
"mouseenter.slick",
c.proxy(e.interrupt, e, !0)
),
e.$list.off(
"mouseleave.slick",
c.proxy(e.interrupt, e, !1)
);
}),
(r.prototype.cleanUpRows = function () {
var e;
0 < this.options.rows &&
((e = this.$slides.children().children()).removeAttr(
"style"
),
this.$slider.empty().append(e));
}),
(r.prototype.clickHandler = function (e) {
!1 === this.shouldClick &&
(e.stopImmediatePropagation(),
e.stopPropagation(),
e.preventDefault());
}),
(r.prototype.destroy = function (e) {
var t = this;
t.autoPlayClear(),
(t.touchObject = {}),
t.cleanUpEvents(),
c(".slick-cloned", t.$slider).detach(),
t.$dots && t.$dots.remove(),
t.$prevArrow &&
t.$prevArrow.length &&
(t.$prevArrow
.removeClass(
"slick-disabled slick-arrow slick-hidden"
)
.removeAttr("aria-hidden aria-disabled tabindex")
.css("display", ""),
t.htmlExpr.test(t.options.prevArrow)) &&
t.$prevArrow.remove(),
t.$nextArrow &&
t.$nextArrow.length &&
(t.$nextArrow
.removeClass(
"slick-disabled slick-arrow slick-hidden"
)
.removeAttr("aria-hidden aria-disabled tabindex")
.css("display", ""),
t.htmlExpr.test(t.options.nextArrow)) &&
t.$nextArrow.remove(),
t.$slides &&
(t.$slides
.removeClass(
"slick-slide slick-active slick-center slick-visible slick-current"
)
.removeAttr("aria-hidden")
.removeAttr("data-slick-index")
.each(function () {
c(this).attr(
"style",
c(this).data("originalStyling")
);
}),
t.$slideTrack.children(this.options.slide).detach(),
t.$slideTrack.detach(),
t.$list.detach(),
t.$slider.append(t.$slides)),
t.cleanUpRows(),
t.$slider.removeClass("slick-slider"),
t.$slider.removeClass("slick-initialized"),
t.$slider.removeClass("slick-dotted"),
(t.unslicked = !0),
e || t.$slider.trigger("destroy", [t]);
}),
(r.prototype.disableTransition = function (e) {
var t = {};
(t[this.transitionType] = ""),
(!1 === this.options.fade
? this.$slideTrack
: this.$slides.eq(e)
).css(t);
}),
(r.prototype.fadeSlide = function (e, t) {
var i = this;
!1 === i.cssTransitions
? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }),
i.$slides
.eq(e)
.animate(
{ opacity: 1 },
i.options.speed,
i.options.easing,
t
))
: (i.applyTransition(e),
i.$slides
.eq(e)
.css({ opacity: 1, zIndex: i.options.zIndex }),
t &&
setTimeout(function () {
i.disableTransition(e), t.call();
}, i.options.speed));
}),
(r.prototype.fadeSlideOut = function (e) {
var t = this;
!1 === t.cssTransitions
? t.$slides
.eq(e)
.animate(
{ opacity: 0, zIndex: t.options.zIndex - 2 },
t.options.speed,
t.options.easing
)
: (t.applyTransition(e),
t.$slides
.eq(e)
.css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
}),
(r.prototype.filterSlides = r.prototype.slickFilter =
function (e) {
var t = this;
null !== e &&
((t.$slidesCache = t.$slides),
t.unload(),
t.$slideTrack.children(this.options.slide).detach(),
t.$slidesCache.filter(e).appendTo(t.$slideTrack),
t.reinit());
}),
(r.prototype.focusHandler = function () {
var i = this;
i.$slider
.off("focus.slick blur.slick")
.on("focus.slick blur.slick", "*", function (e) {
e.stopImmediatePropagation();
var t = c(this);
setTimeout(function () {
i.options.pauseOnFocus &&
((i.focussed = t.is(":focus")), i.autoPlay());
}, 0);
});
}),
(r.prototype.getCurrent = r.prototype.slickCurrentSlide =
function () {
return this.currentSlide;
}),
(r.prototype.getDotCount = function () {
var e = this,
t = 0,
i = 0,
n = 0;
if (!0 === e.options.infinite)
if (e.slideCount <= e.options.slidesToShow) ++n;
else
for (; t < e.slideCount; )
++n,
(t = i + e.options.slidesToScroll),
(i +=
e.options.slidesToScroll <= e.options.slidesToShow
? e.options.slidesToScroll
: e.options.slidesToShow);
else if (!0 === e.options.centerMode) n = e.slideCount;
else if (e.options.asNavFor)
for (; t < e.slideCount; )
++n,
(t = i + e.options.slidesToScroll),
(i +=
e.options.slidesToScroll <= e.options.slidesToShow
? e.options.slidesToScroll
: e.options.slidesToShow);
else
n =
1 +
Math.ceil(
(e.slideCount - e.options.slidesToShow) /
e.options.slidesToScroll
);
return n - 1;
}),
(r.prototype.getLeft = function (e) {
var t,
i,
n = this,
o = 0;
return (
(n.slideOffset = 0),
(t = n.$slides.first().outerHeight(!0)),
!0 === n.options.infinite
? (n.slideCount > n.options.slidesToShow &&
((n.slideOffset =
n.slideWidth * n.options.slidesToShow * -1),
(i = -1),
!0 === n.options.vertical &&
!0 === n.options.centerMode &&
(2 === n.options.slidesToShow
? (i = -1.5)
: 1 === n.options.slidesToShow && (i = -2)),
(o = t * n.options.slidesToShow * i)),
n.slideCount % n.options.slidesToScroll != 0 &&
e + n.options.slidesToScroll > n.slideCount &&
n.slideCount > n.options.slidesToShow &&
(o =
e > n.slideCount
? ((n.slideOffset =
(n.options.slidesToShow -
(e - n.slideCount)) *
n.slideWidth *
-1),
(n.options.slidesToShow -
(e - n.slideCount)) *
t *
-1)
: ((n.slideOffset =
(n.slideCount % n.options.slidesToScroll) *
n.slideWidth *
-1),
(n.slideCount % n.options.slidesToScroll) *
t *
-1)))
: e + n.options.slidesToShow > n.slideCount &&
((n.slideOffset =
(e + n.options.slidesToShow - n.slideCount) *
n.slideWidth),
(o =
(e + n.options.slidesToShow - n.slideCount) * t)),
n.slideCount <= n.options.slidesToShow &&
(o = n.slideOffset = 0),
!0 === n.options.centerMode &&
n.slideCount <= n.options.slidesToShow
? (n.slideOffset =
(n.slideWidth *
Math.floor(n.options.slidesToShow)) /
2 -
(n.slideWidth * n.slideCount) / 2)
: !0 === n.options.centerMode &&
!0 === n.options.infinite
? (n.slideOffset +=
n.slideWidth *
Math.floor(n.options.slidesToShow / 2) -
n.slideWidth)
: !0 === n.options.centerMode &&
((n.slideOffset = 0),
(n.slideOffset +=
n.slideWidth *
Math.floor(n.options.slidesToShow / 2))),
(i =
!1 === n.options.vertical
? e * n.slideWidth * -1 + n.slideOffset
: e * t * -1 + o),
!0 === n.options.variableWidth &&
((t =
n.slideCount <= n.options.slidesToShow ||
!1 === n.options.infinite
? n.$slideTrack.children(".slick-slide").eq(e)
: n.$slideTrack
.children(".slick-slide")
.eq(e + n.options.slidesToShow)),
(i =
!0 === n.options.rtl
? t[0]
? -1 *
(n.$slideTrack.width() -
t[0].offsetLeft -
t.width())
: 0
: t[0]
? -1 * t[0].offsetLeft
: 0),
!0 === n.options.centerMode) &&
((t =
n.slideCount <= n.options.slidesToShow ||
!1 === n.options.infinite
? n.$slideTrack.children(".slick-slide").eq(e)
: n.$slideTrack
.children(".slick-slide")
.eq(e + n.options.slidesToShow + 1)),
(i =
!0 === n.options.rtl
? t[0]
? -1 *
(n.$slideTrack.width() -
t[0].offsetLeft -
t.width())
: 0
: t[0]
? -1 * t[0].offsetLeft
: 0),
(i += (n.$list.width() - t.outerWidth()) / 2)),
i
);
}),
(r.prototype.getOption = r.prototype.slickGetOption =
function (e) {
return this.options[e];
}),
(r.prototype.getNavigableIndexes = function () {
for (
var e = this,
t = 0,
i = 0,
n = [],
o =
!1 === e.options.infinite
? e.slideCount
: ((t = -1 * e.options.slidesToScroll),
(i = -1 * e.options.slidesToScroll),
2 * e.slideCount);
t < o;
)
n.push(t),
(t = i + e.options.slidesToScroll),
(i +=
e.options.slidesToScroll <= e.options.slidesToShow
? e.options.slidesToScroll
: e.options.slidesToShow);
return n;
}),
(r.prototype.getSlick = function () {
return this;
}),
(r.prototype.getSlideCount = function () {
var i,
n = this,
o =
!0 === n.options.centerMode
? n.slideWidth *
Math.floor(n.options.slidesToShow / 2)
: 0;
return !0 === n.options.swipeToSlide
? (n.$slideTrack
.find(".slick-slide")
.each(function (e, t) {
if (
t.offsetLeft - o + c(t).outerWidth() / 2 >
-1 * n.swipeLeft
)
return (i = t), !1;
}),
Math.abs(
c(i).attr("data-slick-index") - n.currentSlide
) || 1)
: n.options.slidesToScroll;
}),
(r.prototype.goTo = r.prototype.slickGoTo =
function (e, t) {
this.changeSlide(
{ data: { message: "index", index: parseInt(e) } },
t
);
}),
(r.prototype.init = function (e) {
var t = this;
c(t.$slider).hasClass("slick-initialized") ||
(c(t.$slider).addClass("slick-initialized"),
t.buildRows(),
t.buildOut(),
t.setProps(),
t.startLoad(),
t.loadSlider(),
t.initializeEvents(),
t.updateArrows(),
t.updateDots(),
t.checkResponsive(!0),
t.focusHandler()),
e && t.$slider.trigger("init", [t]),
!0 === t.options.accessibility && t.initADA(),
t.options.autoplay && ((t.paused = !1), t.autoPlay());
}),
(r.prototype.initADA = function () {
var i = this,
n = Math.ceil(i.slideCount / i.options.slidesToShow),
o = i.getNavigableIndexes().filter(function (e) {
return 0 <= e && e < i.slideCount;
});
i.$slides
.add(i.$slideTrack.find(".slick-cloned"))
.attr({ "aria-hidden": "true", tabindex: "-1" })
.find("a, input, button, select")
.attr({ tabindex: "-1" }),
null !== i.$dots &&
(i.$slides
.not(i.$slideTrack.find(".slick-cloned"))
.each(function (e) {
var t = o.indexOf(e);
c(this).attr({
role: "tabpanel",
id: "slick-slide" + i.instanceUid + e,
tabindex: -1,
}),
-1 !== t &&
((e =
"slick-slide-control" + i.instanceUid + t),
c("#" + e).length) &&
c(this).attr({ "aria-describedby": e });
}),
i.$dots
.attr("role", "tablist")
.find("li")
.each(function (e) {
var t = o[e];
c(this).attr({ role: "presentation" }),
c(this)
.find("button")
.first()
.attr({
role: "tab",
id: "slick-slide-control" + i.instanceUid + e,
"aria-controls":
"slick-slide" + i.instanceUid + t,
"aria-label": e + 1 + " of " + n,
"aria-selected": null,
tabindex: "-1",
});
})
.eq(i.currentSlide)
.find("button")
.attr({ "aria-selected": "true", tabindex: "0" })
.end());
for (
var e = i.currentSlide, t = e + i.options.slidesToShow;
e < t;
e++
)
i.options.focusOnChange
? i.$slides.eq(e).attr({ tabindex: "0" })
: i.$slides.eq(e).removeAttr("tabindex");
i.activateADA();
}),
(r.prototype.initArrowEvents = function () {
var e = this;
!0 === e.options.arrows &&
e.slideCount > e.options.slidesToShow &&
(e.$prevArrow
.off("click.slick")
.on(
"click.slick",
{ message: "previous" },
e.changeSlide
),
e.$nextArrow
.off("click.slick")
.on("click.slick", { message: "next" }, e.changeSlide),
!0 === e.options.accessibility) &&
(e.$prevArrow.on("keydown.slick", e.keyHandler),
e.$nextArrow.on("keydown.slick", e.keyHandler));
}),
(r.prototype.initDotEvents = function () {
var e = this;
!0 === e.options.dots &&
e.slideCount > e.options.slidesToShow &&
(c("li", e.$dots).on(
"click.slick",
{ message: "index" },
e.changeSlide
),
!0 === e.options.accessibility) &&
e.$dots.on("keydown.slick", e.keyHandler),
!0 === e.options.dots &&
!0 === e.options.pauseOnDotsHover &&
e.slideCount > e.options.slidesToShow &&
c("li", e.$dots)
.on("mouseenter.slick", c.proxy(e.interrupt, e, !0))
.on("mouseleave.slick", c.proxy(e.interrupt, e, !1));
}),
(r.prototype.initSlideEvents = function () {
var e = this;
e.options.pauseOnHover &&
(e.$list.on(
"mouseenter.slick",
c.proxy(e.interrupt, e, !0)
),
e.$list.on(
"mouseleave.slick",
c.proxy(e.interrupt, e, !1)
));
}),
(r.prototype.initializeEvents = function () {
var e = this;
e.initArrowEvents(),
e.initDotEvents(),
e.initSlideEvents(),
e.$list.on(
"touchstart.slick mousedown.slick",
{ action: "start" },
e.swipeHandler
),
e.$list.on(
"touchmove.slick mousemove.slick",
{ action: "move" },
e.swipeHandler
),
e.$list.on(
"touchend.slick mouseup.slick",
{ action: "end" },
e.swipeHandler
),
e.$list.on(
"touchcancel.slick mouseleave.slick",
{ action: "end" },
e.swipeHandler
),
e.$list.on("click.slick", e.clickHandler),
c(document).on(
e.visibilityChange,
c.proxy(e.visibility, e)
),
!0 === e.options.accessibility &&
e.$list.on("keydown.slick", e.keyHandler),
!0 === e.options.focusOnSelect &&
c(e.$slideTrack)
.children()
.on("click.slick", e.selectHandler),
c(window).on(
"orientationchange.slick.slick-" + e.instanceUid,
c.proxy(e.orientationChange, e)
),
c(window).on(
"resize.slick.slick-" + e.instanceUid,
c.proxy(e.resize, e)
),
c("[draggable!=true]", e.$slideTrack).on(
"dragstart",
e.preventDefault
),
c(window).on(
"load.slick.slick-" + e.instanceUid,
e.setPosition
),
c(e.setPosition);
}),
(r.prototype.initUI = function () {
var e = this;
!0 === e.options.arrows &&
e.slideCount > e.options.slidesToShow &&
(e.$prevArrow.show(), e.$nextArrow.show()),
!0 === e.options.dots &&
e.slideCount > e.options.slidesToShow &&
e.$dots.show();
}),
(r.prototype.keyHandler = function (e) {
var t = this;
e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
(37 === e.keyCode && !0 === t.options.accessibility
? t.changeSlide({
data: {
message:
!0 === t.options.rtl ? "next" : "previous",
},
})
: 39 === e.keyCode &&
!0 === t.options.accessibility &&
t.changeSlide({
data: {
message:
!0 === t.options.rtl ? "previous" : "next",
},
}));
}),
(r.prototype.lazyLoad = function () {
var e,
t,
i,
s = this;
function n(e) {
c("img[data-lazy]", e).each(function () {
var e = c(this),
t = c(this).attr("data-lazy"),
i = c(this).attr("data-srcset"),
n =
c(this).attr("data-sizes") ||
s.$slider.attr("data-sizes"),
o = document.createElement("img");
(o.onload = function () {
e.animate({ opacity: 0 }, 100, function () {
i && (e.attr("srcset", i), n) && e.attr("sizes", n),
e
.attr("src", t)
.animate({ opacity: 1 }, 200, function () {
e.removeAttr(
"data-lazy data-srcset data-sizes"
).removeClass("slick-loading");
}),
s.$slider.trigger("lazyLoaded", [s, e, t]);
});
}),
(o.onerror = function () {
e
.removeAttr("data-lazy")
.removeClass("slick-loading")
.addClass("slick-lazyload-error"),
s.$slider.trigger("lazyLoadError", [s, e, t]);
}),
(o.src = t);
});
}
if (
(!0 === s.options.centerMode
? (i =
!0 === s.options.infinite
? (t =
s.currentSlide +
(s.options.slidesToShow / 2 + 1)) +
s.options.slidesToShow +
2
: ((t = Math.max(
0,
s.currentSlide -
(s.options.slidesToShow / 2 + 1)
)),
s.options.slidesToShow / 2 +
1 +
2 +
s.currentSlide))
: ((t = s.options.infinite
? s.options.slidesToShow + s.currentSlide
: s.currentSlide),
(i = Math.ceil(t + s.options.slidesToShow)),
!0 === s.options.fade &&
(0 < t && t--, i <= s.slideCount) &&
i++),
(e = s.$slider.find(".slick-slide").slice(t, i)),
"anticipated" === s.options.lazyLoad)
)
for (
var o = t - 1,
r = i,
l = s.$slider.find(".slick-slide"),
a = 0;
a < s.options.slidesToScroll;
a++
)
o < 0 && (o = s.slideCount - 1),
(e = (e = e.add(l.eq(o))).add(l.eq(r))),
o--,
r++;
n(e),
s.slideCount <= s.options.slidesToShow
? n(s.$slider.find(".slick-slide"))
: s.currentSlide >=
s.slideCount - s.options.slidesToShow
? n(
s.$slider
.find(".slick-cloned")
.slice(0, s.options.slidesToShow)
)
: 0 === s.currentSlide &&
n(
s.$slider
.find(".slick-cloned")
.slice(-1 * s.options.slidesToShow)
);
}),
(r.prototype.loadSlider = function () {
var e = this;
e.setPosition(),
e.$slideTrack.css({ opacity: 1 }),
e.$slider.removeClass("slick-loading"),
e.initUI(),
"progressive" === e.options.lazyLoad &&
e.progressiveLazyLoad();
}),
(r.prototype.next = r.prototype.slickNext =
function () {
this.changeSlide({ data: { message: "next" } });
}),
(r.prototype.orientationChange = function () {
this.checkResponsive(), this.setPosition();
}),
(r.prototype.pause = r.prototype.slickPause =
function () {
this.autoPlayClear(), (this.paused = !0);
}),
(r.prototype.play = r.prototype.slickPlay =
function () {
var e = this;
e.autoPlay(),
(e.options.autoplay = !0),
(e.paused = !1),
(e.focussed = !1),
(e.interrupted = !1);
}),
(r.prototype.postSlide = function (e) {
var t = this;
t.unslicked ||
(t.$slider.trigger("afterChange", [t, e]),
(t.animating = !1),
t.slideCount > t.options.slidesToShow && t.setPosition(),
(t.swipeLeft = null),
t.options.autoplay && t.autoPlay(),
!0 === t.options.accessibility &&
(t.initADA(), t.options.focusOnChange) &&
c(t.$slides.get(t.currentSlide))
.attr("tabindex", 0)
.focus());
}),
(r.prototype.prev = r.prototype.slickPrev =
function () {
this.changeSlide({ data: { message: "previous" } });
}),
(r.prototype.preventDefault = function (e) {
e.preventDefault();
}),
(r.prototype.progressiveLazyLoad = function (e) {
e = e || 1;
var t,
i,
n,
o,
s = this,
r = c("img[data-lazy]", s.$slider);
r.length
? ((t = r.first()),
(i = t.attr("data-lazy")),
(n = t.attr("data-srcset")),
(o =
t.attr("data-sizes") || s.$slider.attr("data-sizes")),
((r = document.createElement("img")).onload =
function () {
n && (t.attr("srcset", n), o) && t.attr("sizes", o),
t
.attr("src", i)
.removeAttr("data-lazy data-srcset data-sizes")
.removeClass("slick-loading"),
!0 === s.options.adaptiveHeight &&
s.setPosition(),
s.$slider.trigger("lazyLoaded", [s, t, i]),
s.progressiveLazyLoad();
}),
(r.onerror = function () {
e < 3
? setTimeout(function () {
s.progressiveLazyLoad(e + 1);
}, 500)
: (t
.removeAttr("data-lazy")
.removeClass("slick-loading")
.addClass("slick-lazyload-error"),
s.$slider.trigger("lazyLoadError", [s, t, i]),
s.progressiveLazyLoad());
}),
(r.src = i))
: s.$slider.trigger("allImagesLoaded", [s]);
}),
(r.prototype.refresh = function (e) {
var t = this,
i = t.slideCount - t.options.slidesToShow;
!t.options.infinite &&
i < t.currentSlide &&
(t.currentSlide = i),
t.slideCount <= t.options.slidesToShow &&
(t.currentSlide = 0),
(i = t.currentSlide),
t.destroy(!0),
c.extend(t, t.initials, { currentSlide: i }),
t.init(),
e ||
t.changeSlide(
{ data: { message: "index", index: i } },
!1
);
}),
(r.prototype.registerBreakpoints = function () {
var e,
t,
i,
n = this,
o = n.options.responsive || null;
if ("array" === c.type(o) && o.length) {
for (e in ((n.respondTo =
n.options.respondTo || "window"),
o))
if (
((i = n.breakpoints.length - 1), o.hasOwnProperty(e))
) {
for (t = o[e].breakpoint; 0 <= i; )
n.breakpoints[i] &&
n.breakpoints[i] === t &&
n.breakpoints.splice(i, 1),
i--;
n.breakpoints.push(t),
(n.breakpointSettings[t] = o[e].settings);
}
n.breakpoints.sort(function (e, t) {
return n.options.mobileFirst ? e - t : t - e;
});
}
}),
(r.prototype.reinit = function () {
var e = this;
(e.$slides = e.$slideTrack
.children(e.options.slide)
.addClass("slick-slide")),
(e.slideCount = e.$slides.length),
e.currentSlide >= e.slideCount &&
0 !== e.currentSlide &&
(e.currentSlide =
e.currentSlide - e.options.slidesToScroll),
e.slideCount <= e.options.slidesToShow &&
(e.currentSlide = 0),
e.registerBreakpoints(),
e.setProps(),
e.setupInfinite(),
e.buildArrows(),
e.updateArrows(),
e.initArrowEvents(),
e.buildDots(),
e.updateDots(),
e.initDotEvents(),
e.cleanUpSlideEvents(),
e.initSlideEvents(),
e.checkResponsive(!1, !0),
!0 === e.options.focusOnSelect &&
c(e.$slideTrack)
.children()
.on("click.slick", e.selectHandler),
e.setSlideClasses(
"number" == typeof e.currentSlide ? e.currentSlide : 0
),
e.setPosition(),
e.focusHandler(),
(e.paused = !e.options.autoplay),
e.autoPlay(),
e.$slider.trigger("reInit", [e]);
}),
(r.prototype.resize = function () {
var e = this;
c(window).width() !== e.windowWidth &&
(clearTimeout(e.windowDelay),
(e.windowDelay = window.setTimeout(function () {
(e.windowWidth = c(window).width()),
e.checkResponsive(),
e.unslicked || e.setPosition();
}, 50)));
}),
(r.prototype.removeSlide = r.prototype.slickRemove =
function (e, t, i) {
var n = this;
if (
((e =
"boolean" == typeof e
? !0 === (t = e)
? 0
: n.slideCount - 1
: !0 === t
? --e
: e),
n.slideCount < 1 || e < 0 || n.slideCount - 1 < e)
)
return !1;
n.unload(),
(!0 === i
? n.$slideTrack.children()
: n.$slideTrack.children(this.options.slide).eq(e)
).remove(),
(n.$slides = n.$slideTrack.children(
this.options.slide
)),
n.$slideTrack.children(this.options.slide).detach(),
n.$slideTrack.append(n.$slides),
(n.$slidesCache = n.$slides),
n.reinit();
}),
(r.prototype.setCSS = function (e) {
var t,
i,
n = this,
o = {};
!0 === n.options.rtl && (e = -e),
(t =
"left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
(i =
"top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
(o[n.positionProp] = e),
!1 !== n.transformsEnabled &&
((o = {})[n.animType] =
!1 === n.cssTransitions
? "translate(" + t + ", " + i + ")"
: "translate3d(" + t + ", " + i + ", 0px)"),
n.$slideTrack.css(o);
}),
(r.prototype.setDimensions = function () {
var e = this,
t =
(!1 === e.options.vertical
? !0 === e.options.centerMode &&
e.$list.css({
padding: "0px " + e.options.centerPadding,
})
: (e.$list.height(
e.$slides.first().outerHeight(!0) *
e.options.slidesToShow
),
!0 === e.options.centerMode &&
e.$list.css({
padding: e.options.centerPadding + " 0px",
})),
(e.listWidth = e.$list.width()),
(e.listHeight = e.$list.height()),
!1 === e.options.vertical &&
!1 === e.options.variableWidth
? ((e.slideWidth = Math.ceil(
e.listWidth / e.options.slidesToShow
)),
e.$slideTrack.width(
Math.ceil(
e.slideWidth *
e.$slideTrack.children(".slick-slide").length
)
))
: !0 === e.options.variableWidth
? e.$slideTrack.width(5e3 * e.slideCount)
: ((e.slideWidth = Math.ceil(e.listWidth)),
e.$slideTrack.height(
Math.ceil(
e.$slides.first().outerHeight(!0) *
e.$slideTrack.children(".slick-slide").length
)
)),
e.$slides.first().outerWidth(!0) -
e.$slides.first().width());
!1 === e.options.variableWidth &&
e.$slideTrack
.children(".slick-slide")
.width(e.slideWidth - t);
}),
(r.prototype.setFade = function () {
var i,
n = this;
n.$slides.each(function (e, t) {
(i = n.slideWidth * e * -1),
!0 === n.options.rtl
? c(t).css({
position: "relative",
right: i,
top: 0,
zIndex: n.options.zIndex - 2,
opacity: 0,
})
: c(t).css({
position: "relative",
left: i,
top: 0,
zIndex: n.options.zIndex - 2,
opacity: 0,
});
}),
n.$slides
.eq(n.currentSlide)
.css({ zIndex: n.options.zIndex - 1, opacity: 1 });
}),
(r.prototype.setHeight = function () {
var e,
t = this;
1 === t.options.slidesToShow &&
!0 === t.options.adaptiveHeight &&
!1 === t.options.vertical &&
((e = t.$slides.eq(t.currentSlide).outerHeight(!0)),
t.$list.css("height", e));
}),
(r.prototype.setOption = r.prototype.slickSetOption =
function () {
var e,
t,
i,
n,
o,
s = this,
r = !1;
if (
("object" === c.type(arguments[0])
? ((i = arguments[0]),
(r = arguments[1]),
(o = "multiple"))
: "string" === c.type(arguments[0]) &&
((i = arguments[0]),
(n = arguments[1]),
(r = arguments[2]),
"responsive" === arguments[0] &&
"array" === c.type(arguments[1])
? (o = "responsive")
: void 0 !== arguments[1] && (o = "single")),
"single" === o)
)
s.options[i] = n;
else if ("multiple" === o)
c.each(i, function (e, t) {
s.options[e] = t;
});
else if ("responsive" === o)
for (t in n)
if ("array" !== c.type(s.options.responsive))
s.options.responsive = [n[t]];
else {
for (e = s.options.responsive.length - 1; 0 <= e; )
s.options.responsive[e].breakpoint ===
n[t].breakpoint &&
s.options.responsive.splice(e, 1),
e--;
s.options.responsive.push(n[t]);
}
r && (s.unload(), s.reinit());
}),
(r.prototype.setPosition = function () {
var e = this;
e.setDimensions(),
e.setHeight(),
!1 === e.options.fade
? e.setCSS(e.getLeft(e.currentSlide))
: e.setFade(),
e.$slider.trigger("setPosition", [e]);
}),
(r.prototype.setProps = function () {
var e = this,
t = document.body.style;
(e.positionProp =
!0 === e.options.vertical ? "top" : "left"),
"top" === e.positionProp
? e.$slider.addClass("slick-vertical")
: e.$slider.removeClass("slick-vertical"),
(void 0 === t.WebkitTransition &&
void 0 === t.MozTransition &&
void 0 === t.msTransition) ||
(!0 === e.options.useCSS && (e.cssTransitions = !0)),
e.options.fade &&
("number" == typeof e.options.zIndex
? e.options.zIndex < 3 && (e.options.zIndex = 3)
: (e.options.zIndex = e.defaults.zIndex)),
void 0 !== t.OTransform &&
((e.animType = "OTransform"),
(e.transformType = "-o-transform"),
(e.transitionType = "OTransition"),
void 0 === t.perspectiveProperty) &&
void 0 === t.webkitPerspective &&
(e.animType = !1),
void 0 !== t.MozTransform &&
((e.animType = "MozTransform"),
(e.transformType = "-moz-transform"),
(e.transitionType = "MozTransition"),
void 0 === t.perspectiveProperty) &&
void 0 === t.MozPerspective &&
(e.animType = !1),
void 0 !== t.webkitTransform &&
((e.animType = "webkitTransform"),
(e.transformType = "-webkit-transform"),
(e.transitionType = "webkitTransition"),
void 0 === t.perspectiveProperty) &&
void 0 === t.webkitPerspective &&
(e.animType = !1),
void 0 !== t.msTransform &&
((e.animType = "msTransform"),
(e.transformType = "-ms-transform"),
(e.transitionType = "msTransition"),
void 0 === t.msTransform) &&
(e.animType = !1),
void 0 !== t.transform &&
!1 !== e.animType &&
((e.animType = "transform"),
(e.transformType = "transform"),
(e.transitionType = "transition")),
(e.transformsEnabled =
e.options.useTransform &&
null !== e.animType &&
!1 !== e.animType);
}),
(r.prototype.setSlideClasses = function (e) {
var t,
i,
n,
o = this,
s = o.$slider
.find(".slick-slide")
.removeClass("slick-active slick-center slick-current")
.attr("aria-hidden", "true");
o.$slides.eq(e).addClass("slick-current"),
!0 === o.options.centerMode
? ((i = o.options.slidesToShow % 2 == 0 ? 1 : 0),
(n = Math.floor(o.options.slidesToShow / 2)),
!0 === o.options.infinite &&
((n <= e && e <= o.slideCount - 1 - n
? o.$slides.slice(e - n + i, e + n + 1)
: ((t = o.options.slidesToShow + e),
s.slice(t - n + 1 + i, t + n + 2))
)
.addClass("slick-active")
.attr("aria-hidden", "false"),
0 === e
? s
.eq(s.length - 1 - o.options.slidesToShow)
.addClass("slick-center")
: e === o.slideCount - 1 &&
s
.eq(o.options.slidesToShow)
.addClass("slick-center")),
o.$slides.eq(e).addClass("slick-center"))
: (0 <= e && e <= o.slideCount - o.options.slidesToShow
? o.$slides.slice(e, e + o.options.slidesToShow)
: s.length <= o.options.slidesToShow
? s
: ((i = o.slideCount % o.options.slidesToShow),
(t =
!0 === o.options.infinite
? o.options.slidesToShow + e
: e),
o.options.slidesToShow ==
o.options.slidesToScroll &&
o.slideCount - e < o.options.slidesToShow
? s.slice(
t - (o.options.slidesToShow - i),
t + i
)
: s.slice(t, t + o.options.slidesToShow))
)
.addClass("slick-active")
.attr("aria-hidden", "false"),
("ondemand" !== o.options.lazyLoad &&
"anticipated" !== o.options.lazyLoad) ||
o.lazyLoad();
}),
(r.prototype.setupInfinite = function () {
var e,
t,
i,
n = this;
if (
(!0 === n.options.fade && (n.options.centerMode = !1),
!0 === n.options.infinite &&
!1 === n.options.fade &&
((t = null), n.slideCount > n.options.slidesToShow))
) {
for (
i =
!0 === n.options.centerMode
? n.options.slidesToShow + 1
: n.options.slidesToShow,
e = n.slideCount;
e > n.slideCount - i;
--e
)
c(n.$slides[(t = e - 1)])
.clone(!0)
.attr("id", "")
.attr("data-slick-index", t - n.slideCount)
.prependTo(n.$slideTrack)
.addClass("slick-cloned");
for (e = 0; e < i + n.slideCount; e += 1)
(t = e),
c(n.$slides[t])
.clone(!0)
.attr("id", "")
.attr("data-slick-index", t + n.slideCount)
.appendTo(n.$slideTrack)
.addClass("slick-cloned");
n.$slideTrack
.find(".slick-cloned")
.find("[id]")
.each(function () {
c(this).attr("id", "");
});
}
}),
(r.prototype.interrupt = function (e) {
e || this.autoPlay(), (this.interrupted = e);
}),
(r.prototype.selectHandler = function (e) {
(e = c(e.target).is(".slick-slide")
? c(e.target)
: c(e.target).parents(".slick-slide")),
(e = (e = parseInt(e.attr("data-slick-index"))) || 0);
this.slideCount <= this.options.slidesToShow
? this.slideHandler(e, !1, !0)
: this.slideHandler(e);
}),
(r.prototype.slideHandler = function (e, t, i) {
var n,
o,
s,
r = this;
(t = t || !1),
(!0 === r.animating && !0 === r.options.waitForAnimate) ||
(!0 === r.options.fade && r.currentSlide === e) ||
(!1 === t && r.asNavFor(e),
(n = e),
(t = r.getLeft(n)),
(s = r.getLeft(r.currentSlide)),
(r.currentLeft =
null === r.swipeLeft ? s : r.swipeLeft),
(!1 === r.options.infinite &&
!1 === r.options.centerMode &&
(e < 0 ||
e > r.getDotCount() * r.options.slidesToScroll)) ||
(!1 === r.options.infinite &&
!0 === r.options.centerMode &&
(e < 0 ||
e > r.slideCount - r.options.slidesToScroll))
? !1 === r.options.fade &&
((n = r.currentSlide),
!0 !== i && r.slideCount > r.options.slidesToShow
? r.animateSlide(s, function () {
r.postSlide(n);
})
: r.postSlide(n))
: (r.options.autoplay &&
clearInterval(r.autoPlayTimer),
(o =
n < 0
? r.slideCount % r.options.slidesToScroll != 0
? r.slideCount -
(r.slideCount % r.options.slidesToScroll)
: r.slideCount + n
: n >= r.slideCount
? r.slideCount % r.options.slidesToScroll != 0
? 0
: n - r.slideCount
: n),
(r.animating = !0),
r.$slider.trigger("beforeChange", [
r,
r.currentSlide,
o,
]),
(e = r.currentSlide),
(r.currentSlide = o),
r.setSlideClasses(r.currentSlide),
r.options.asNavFor &&
(s = (s = r.getNavTarget()).slick("getSlick"))
.slideCount <= s.options.slidesToShow &&
s.setSlideClasses(r.currentSlide),
r.updateDots(),
r.updateArrows(),
!0 === r.options.fade
? (!0 !== i
? (r.fadeSlideOut(e),
r.fadeSlide(o, function () {
r.postSlide(o);
}))
: r.postSlide(o),
r.animateHeight())
: !0 !== i &&
r.slideCount > r.options.slidesToShow
? r.animateSlide(t, function () {
r.postSlide(o);
})
: r.postSlide(o)));
}),
(r.prototype.startLoad = function () {
var e = this;
!0 === e.options.arrows &&
e.slideCount > e.options.slidesToShow &&
(e.$prevArrow.hide(), e.$nextArrow.hide()),
!0 === e.options.dots &&
e.slideCount > e.options.slidesToShow &&
e.$dots.hide(),
e.$slider.addClass("slick-loading");
}),
(r.prototype.swipeDirection = function () {
var e = this,
t = e.touchObject.startX - e.touchObject.curX,
i = e.touchObject.startY - e.touchObject.curY,
i = Math.atan2(i, t);
return ((t =
(t = Math.round((180 * i) / Math.PI)) < 0
? 360 - Math.abs(t)
: t) <= 45 &&
0 <= t) ||
(t <= 360 && 315 <= t)
? !1 === e.options.rtl
? "left"
: "right"
: 135 <= t && t <= 225
? !1 === e.options.rtl
? "right"
: "left"
: !0 === e.options.verticalSwiping
? 35 <= t && t <= 135
? "down"
: "up"
: "vertical";
}),
(r.prototype.swipeEnd = function (e) {
var t,
i,
n = this;
if (((n.dragging = !1), (n.swiping = !1), n.scrolling))
return (n.scrolling = !1);
if (
((n.interrupted = !1),
(n.shouldClick = !(10 < n.touchObject.swipeLength)),
void 0 === n.touchObject.curX)
)
return !1;
if (
(!0 === n.touchObject.edgeHit &&
n.$slider.trigger("edge", [n, n.swipeDirection()]),
n.touchObject.swipeLength >= n.touchObject.minSwipe)
) {
switch ((i = n.swipeDirection())) {
case "left":
case "down":
(t = n.options.swipeToSlide
? n.checkNavigable(
n.currentSlide + n.getSlideCount()
)
: n.currentSlide + n.getSlideCount()),
(n.currentDirection = 0);
break;
case "right":
case "up":
(t = n.options.swipeToSlide
? n.checkNavigable(
n.currentSlide - n.getSlideCount()
)
: n.currentSlide - n.getSlideCount()),
(n.currentDirection = 1);
}
"vertical" != i &&
(n.slideHandler(t),
(n.touchObject = {}),
n.$slider.trigger("swipe", [n, i]));
} else
n.touchObject.startX !== n.touchObject.curX &&
(n.slideHandler(n.currentSlide), (n.touchObject = {}));
}),
(r.prototype.swipeHandler = function (e) {
var t = this;
if (
!(
!1 === t.options.swipe ||
("ontouchend" in document && !1 === t.options.swipe) ||
(!1 === t.options.draggable &&
-1 !== e.type.indexOf("mouse"))
)
)
switch (
((t.touchObject.fingerCount =
e.originalEvent && void 0 !== e.originalEvent.touches
? e.originalEvent.touches.length
: 1),
(t.touchObject.minSwipe =
t.listWidth / t.options.touchThreshold),
!0 === t.options.verticalSwiping &&
(t.touchObject.minSwipe =
t.listHeight / t.options.touchThreshold),
e.data.action)
) {
case "start":
t.swipeStart(e);
break;
case "move":
t.swipeMove(e);
break;
case "end":
t.swipeEnd(e);
}
}),
(r.prototype.swipeMove = function (e) {
var t,
i,
n = this,
o =
void 0 !== e.originalEvent
? e.originalEvent.touches
: null;
return (
!(!n.dragging || n.scrolling || (o && 1 !== o.length)) &&
((t = n.getLeft(n.currentSlide)),
(n.touchObject.curX =
void 0 !== o ? o[0].pageX : e.clientX),
(n.touchObject.curY =
void 0 !== o ? o[0].pageY : e.clientY),
(n.touchObject.swipeLength = Math.round(
Math.sqrt(
Math.pow(n.touchObject.curX - n.touchObject.startX, 2)
)
)),
(o = Math.round(
Math.sqrt(
Math.pow(n.touchObject.curY - n.touchObject.startY, 2)
)
)),
!n.options.verticalSwiping && !n.swiping && 4 < o
? !(n.scrolling = !0)
: (!0 === n.options.verticalSwiping &&
(n.touchObject.swipeLength = o),
(o = n.swipeDirection()),
void 0 !== e.originalEvent &&
4 < n.touchObject.swipeLength &&
((n.swiping = !0), e.preventDefault()),
(e =
(!1 === n.options.rtl ? 1 : -1) *
(n.touchObject.curX > n.touchObject.startX
? 1
: -1)),
!0 === n.options.verticalSwiping &&
(e =
n.touchObject.curY > n.touchObject.startY
? 1
: -1),
(i = n.touchObject.swipeLength),
(n.touchObject.edgeHit = !1) === n.options.infinite &&
((0 === n.currentSlide && "right" === o) ||
(n.currentSlide >= n.getDotCount() &&
"left" === o)) &&
((i =
n.touchObject.swipeLength *
n.options.edgeFriction),
(n.touchObject.edgeHit = !0)),
!1 === n.options.vertical
? (n.swipeLeft = t + i * e)
: (n.swipeLeft =
t + i * (n.$list.height() / n.listWidth) * e),
!0 === n.options.verticalSwiping &&
(n.swipeLeft = t + i * e),
!0 !== n.options.fade &&
!1 !== n.options.touchMove &&
(!0 === n.animating
? ((n.swipeLeft = null), !1)
: void n.setCSS(n.swipeLeft))))
);
}),
(r.prototype.swipeStart = function (e) {
var t,
i = this;
if (
((i.interrupted = !0),
1 !== i.touchObject.fingerCount ||
i.slideCount <= i.options.slidesToShow)
)
return !(i.touchObject = {});
void 0 !== e.originalEvent &&
void 0 !== e.originalEvent.touches &&
(t = e.originalEvent.touches[0]),
(i.touchObject.startX = i.touchObject.curX =
void 0 !== t ? t.pageX : e.clientX),
(i.touchObject.startY = i.touchObject.curY =
void 0 !== t ? t.pageY : e.clientY),
(i.dragging = !0);
}),
(r.prototype.unfilterSlides = r.prototype.slickUnfilter =
function () {
var e = this;
null !== e.$slidesCache &&
(e.unload(),
e.$slideTrack.children(this.options.slide).detach(),
e.$slidesCache.appendTo(e.$slideTrack),
e.reinit());
}),
(r.prototype.unload = function () {
var e = this;
c(".slick-cloned", e.$slider).remove(),
e.$dots && e.$dots.remove(),
e.$prevArrow &&
e.htmlExpr.test(e.options.prevArrow) &&
e.$prevArrow.remove(),
e.$nextArrow &&
e.htmlExpr.test(e.options.nextArrow) &&
e.$nextArrow.remove(),
e.$slides
.removeClass(
"slick-slide slick-active slick-visible slick-current"
)
.attr("aria-hidden", "true")
.css("width", "");
}),
(r.prototype.unslick = function (e) {
this.$slider.trigger("unslick", [this, e]), this.destroy();
}),
(r.prototype.updateArrows = function () {
var e = this;
Math.floor(e.options.slidesToShow / 2),
!0 === e.options.arrows &&
e.slideCount > e.options.slidesToShow &&
!e.options.infinite &&
(e.$prevArrow
.removeClass("slick-disabled")
.attr("aria-disabled", "false"),
e.$nextArrow
.removeClass("slick-disabled")
.attr("aria-disabled", "false"),
0 === e.currentSlide
? (e.$prevArrow
.addClass("slick-disabled")
.attr("aria-disabled", "true"),
e.$nextArrow
.removeClass("slick-disabled")
.attr("aria-disabled", "false"))
: ((e.currentSlide >=
e.slideCount - e.options.slidesToShow &&
!1 === e.options.centerMode) ||
(e.currentSlide >= e.slideCount - 1 &&
!0 === e.options.centerMode)) &&
(e.$nextArrow
.addClass("slick-disabled")
.attr("aria-disabled", "true"),
e.$prevArrow
.removeClass("slick-disabled")
.attr("aria-disabled", "false")));
}),
(r.prototype.updateDots = function () {
var e = this;
null !== e.$dots &&
(e.$dots.find("li").removeClass("slick-active").end(),
e.$dots
.find("li")
.eq(
Math.floor(e.currentSlide / e.options.slidesToScroll)
)
.addClass("slick-active"));
}),
(r.prototype.visibility = function () {
this.options.autoplay &&
(document[this.hidden]
? (this.interrupted = !0)
: (this.interrupted = !1));
}),
(c.fn.slick = function () {
for (
var e,
t = this,
i = arguments[0],
n = Array.prototype.slice.call(arguments, 1),
o = t.length,
s = 0;
s < o;
s++
)
if (
("object" == typeof i || void 0 === i
? (t[s].slick = new r(t[s], i))
: (e = t[s].slick[i].apply(t[s].slick, n)),
void 0 !== e)
)
return e;
return t;
});
}.apply(t, i)) && (e.exports = t);
},
},
n = {};
function o(e) {
var t = n[e];
return (
void 0 !== t ||
((t = n[e] = { exports: {} }), i[e].call(t.exports, t, t.exports, o)),
t.exports
);
}
(o.n = function (e) {
var t =
e && e.__esModule
? function () {
return e.default;
}
: function () {
return e;
};
return o.d(t, { a: t }), t;
}),
(o.d = function (e, t) {
for (var i in t)
o.o(t, i) &&
!o.o(e, i) &&
Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
}),
(o.o = function (e, t) {
return Object.prototype.hasOwnProperty.call(e, t);
});
{
o(483);
var e = o(556),
A = o.n(e);
window.innerHeight;
let S,
T,
k,
C = [];
document.addEventListener("DOMContentLoaded", function () {
S = window.innerHeight;
let t = document.querySelector("#snlp-hero-video"),
i = document.querySelector("#snlp-hero-intro"),
n = document.querySelector("#snlp-hero-message"),
o = document.querySelector("#snlp-hero-btns"),
s = document.querySelectorAll(".snlp-carousel__item"),
r = document.querySelectorAll(".snlp-background-transition"),
l = document.querySelector("#modes"),
a = document.querySelector("#snlp-tabs"),
c = document.querySelector(".snlp-tabs__tab--default"),
d = document.querySelectorAll(
".snlp-tabs__toggle--desktop .snlp-tabs__toggle__option"
),
e = document.querySelectorAll(".snlp-tabs__toggle__option"),
u = document.querySelector("#snlp-tabs-close"),
p = document.querySelectorAll(".snlp-product-selector__item__title"),
h = document.querySelectorAll(".snlp-features-cards__card__toggle"),
f = document.querySelectorAll(".snlp-faq_q"),
g = document.querySelectorAll(".snlp-grid__item__toggle"),
v = document.querySelectorAll('.snlp-sticky-nav__items a[href^="#"]'),
y = document.querySelectorAll(".snlp-sticky-nav__toggle"),
m = document.querySelectorAll(".snlp-video-trigger"),
b = document.querySelectorAll(".snlp-carousel__item__arrow"),
x =
(v &&
Array.prototype.forEach.call(v, (e) => {
e = e.getAttribute("href");
document.querySelector(e) && C.push(document.querySelector(e));
}),
document.addEventListener("resize", () => {
S = window.innerHeight;
}),
document.addEventListener(
"scroll",
() => {
var e, t;
s &&
Array.prototype.forEach.call(s, (e) => {
var t, i, n;
(768 <= window.innerWidth ||
e.classList.contains("snlp-carousel__item--default")) &&
((t = parseInt(window.getComputedStyle(e).top)),
(i = e.getBoundingClientRect().top),
(n = e.querySelector("video")) &&
i <= t &&
n.paused &&
!e.classList.contains("snlp-carousel__item--active") &&
n.play(),
e.classList.toggle(
"snlp-carousel__item--active",
i <= t
));
}),
r &&
Array.prototype.forEach.call(r, (e) => {
var t = parseInt(window.getComputedStyle(e).top),
i = e.getBoundingClientRect().top,
n = e.querySelector("video");
e.classList.toggle(
"snlp-background-transition--active",
i <= t
),
n &&
(i <= t
? n.paused && n.play()
: n.paused || n.pause());
}),
l &&
a &&
c &&
d &&
992 <= window.innerWidth &&
((e = parseInt(window.getComputedStyle(a).top)),
c.getBoundingClientRect().top - 173 <= e
? ((k = window.scrollY - l.offsetTop),
(T = 0),
(e = document.querySelector(
".snlp-tabs__toggle__option--active"
)),
0 < d.length &&
!e &&
!d[0].classList.contains(
"snlp-tabs__toggle__option--active"
) &&
(e = document.getElementById(
d[0].getAttribute("data-tab-id")
)) &&
((t = document.querySelectorAll(
".snlp-tabs__toggle__option--active"
)),
Array.prototype.forEach.call(t, (e) => {
e.classList.remove(
"snlp-tabs__toggle__option--active"
);
}),
(t = document.querySelectorAll(
".snlp-tabs__tab--active"
)),
Array.prototype.forEach.call(t, (e) => {
e.classList.remove("snlp-tabs__tab--active");
}),
d[0].classList.add(
"snlp-tabs__toggle__option--active"
),
e.classList.add("snlp-tabs__tab--active")))
: ((t = document.querySelectorAll(
".snlp-tabs__toggle__option--active"
)),
Array.prototype.forEach.call(t, (e) => {
e.classList.remove(
"snlp-tabs__toggle__option--active"
);
}),
(e = document.querySelectorAll(
".snlp-tabs__tab--active"
)),
Array.prototype.forEach.call(e, (e) => {
e.classList.remove("snlp-tabs__tab--active");
}))),
C &&
((t = document.querySelectorAll(
".snlp-sticky-nav__item--active"
)),
Array.prototype.forEach.call(t, (e) => {
e.classList.remove("snlp-sticky-nav__item--active");
}),
Array.prototype.forEach.call(C, (e) => {
var t = e.getBoundingClientRect().top,
i = e.getBoundingClientRect().bottom;
t <= 200 &&
200 < i &&
(t = document.querySelector(
'a[href="#' + e.id + '"]'
)) &&
t.classList.add("snlp-sticky-nav__item--active");
})),
m &&
Array.prototype.forEach.call(m, (e) => {
var t = e.getBoundingClientRect().top;
e &&
!e.classList.contains("snlp-video-triggered") &&
(t <= window.innerHeight
? e.paused &&
(e.play(), e.classList.add("snlp-video-triggered"))
: e.paused || e.pause());
});
},
{ passive: !0 }
),
t &&
t.paused &&
(t.play(),
i &&
o &&
t.addEventListener("ended", (e) => {
i.classList.add("snlp-hero__intro--active"),
o.classList.add("snlp-hero__btns--fixed");
t.classList.add('snlp-hero__video--ended');
}),
n) &&
o &&
t.addEventListener("timeupdate", (e) => {
4.25 < t.currentTime
? (n.classList.remove("snlp-hero__message--active"),
o.classList.remove("snlp-hero__btns--active"))
: 3.25 < t.currentTime &&
n.classList.add("snlp-hero__message--active");
}),
Array.prototype.forEach.call(e, (e) => {
e.addEventListener("click", function (e) {
return (
e.preventDefault(),
!this.classList.contains(
"snlp-tabs__toggle__option--active"
) &&
((e = document.querySelectorAll(
".snlp-tabs__toggle__option--active"
)),
Array.prototype.forEach.call(e, (e) => {
e.classList.remove("snlp-tabs__toggle__option--active");
}),
(e = document.querySelectorAll(".snlp-tabs__tab--active")),
Array.prototype.forEach.call(e, (e) => {
e.classList.remove("snlp-tabs__tab--active");
}),
(e = document.getElementById(
this.getAttribute("data-tab-id")
))) &&
(a.classList.add("snlp-tabs--active"),
this.classList.add("snlp-tabs__toggle__option--active"),
e.classList.add("snlp-tabs__tab--active")),
!1
);
});
}),
u &&
u.addEventListener("click", function (e) {
a.classList.remove("snlp-tabs--active");
var t = document.querySelectorAll(
".snlp-tabs__toggle__option--active"
),
t =
(Array.prototype.forEach.call(t, (e) => {
e.classList.remove("snlp-tabs__toggle__option--active");
}),
document.querySelectorAll(".snlp-tabs__tab--active"));
Array.prototype.forEach.call(t, (e) => {
e.classList.remove("snlp-tabs__tab--active");
});
}),
Array.prototype.forEach.call(p, (e) => {
e.addEventListener("click", function (e) {
return (
e.preventDefault(),
this.parentNode.classList.contains(
"snlp-product-selector__item--active"
) ||
((e = document.querySelectorAll(
".snlp-product-selector__item--active"
)),
Array.prototype.forEach.call(e, (e) => {
e.classList.remove("snlp-product-selector__item--active");
}),
this.parentNode.classList.add(
"snlp-product-selector__item--active"
),
(e =
this.parentNode.parentNode.parentNode.querySelector(
"video"
)) &&
((e.src = this.getAttribute("data-video-path")),
e.paused) &&
e.play()),
!1
);
});
}),
1);
Array.prototype.forEach.call(b, (n) => {
n.addEventListener("click", function (e) {
e.preventDefault(), x++;
let t = n.getAttribute("href"),
i = document.querySelector(t);
return (
i &&
(i.classList.remove("snlp-carousel__item--active"),
setTimeout(function () {
(i.style.zIndex = x),
i.classList.add("snlp-carousel__item--active");
var e = i.querySelector("video");
e && e.paused && e.play();
}, 100)),
!1
);
});
});
var w = document.querySelectorAll(
'a[href^="#"]:not(.snlp-carousel__item__arrow)'
);
Array.prototype.forEach.call(w, (n) => {
n.onclick = (e) => {
var t,
i = n.getAttribute("href");
return (
"#!" != i &&
(t = document.querySelector(i)) &&
(e.preventDefault(),
window.scrollTo({
top:
t.offsetTop -
(991 < window.innerWidth
? "#benefits" == i
? 176
: 173
: 139) +
(t.getAttribute("data-scroll-offset")
? +t.getAttribute("data-scroll-offset")
: 0),
left: 0,
behavior: "smooth",
})),
!0
);
};
}),
Array.prototype.forEach.call(h, (e) => {
e.addEventListener("click", function (e) {
e.preventDefault();
var e = this.parentNode.classList.contains(
"snlp-features-cards__card--active"
),
t = document.querySelectorAll(
".snlp-features-cards__card--active"
);
return (
Array.prototype.forEach.call(t, (e) => {
e.classList.remove("snlp-features-cards__card--active");
}),
e
? this.parentNode.classList.remove(
"snlp-features-cards__card--active"
)
: this.parentNode.classList.add(
"snlp-features-cards__card--active"
),
!1
);
});
}),
Array.prototype.forEach.call(f, (e) => {
e.addEventListener("click", function (e) {
var t = this.nextElementSibling,
i = "true" === this.getAttribute("aria-expanded") || !1;
this.setAttribute("aria-expanded", !i),
t.setAttribute("aria-hidden", i),
t.setAttribute(
"style",
"height: " +
(i
? 0
: t.querySelector(".snlp-faq_a__inner").offsetHeight) +
"px"
);
});
}),
Array.prototype.forEach.call(g, (e) => {
e.addEventListener("click", function (e) {
var t;
this.classList.contains("snlp-grid__item__toggle--active") ||
((t = document.querySelectorAll(
".snlp-grid__item__toggle--active"
)),
Array.prototype.forEach.call(t, (e) => {
e.classList.remove("snlp-grid__item__toggle--active");
}),
this.classList.add("snlp-grid__item__toggle--active"),
this.classList.contains("snlp-grid__item__toggle--on")
? this.parentNode.parentNode.classList.add(
"snlp-grid__item--active"
)
: this.parentNode.parentNode.classList.remove(
"snlp-grid__item--active"
));
});
}),
y &&
Array.prototype.forEach.call(y, (t) => {
t.addEventListener("click", function (e) {
t.parentNode.classList.toggle("snlp-sticky-nav--active");
});
}),
A()({ autoplayVideos: !0 });
});
}
})();


